// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/EYInterstate-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/EYInterstate-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/EYInterstate-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/EYInterstate-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/fonts/EYInterstate-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/img/Calendar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../assets/img/error-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../assets/img/success-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../assets/img/warning-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../assets/img/info-icon.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * main.less
 */
/* rastwe: 10/17/17 - I'm adding an @import here to point at the
 *  EY Online Style Guide. This is required because of some issues with
 *  The "extract-text-webpack-plugin", or webpack itself. In either case,
 *  relying on the @import order instead of webpack fixes the issue.
 *  TODO: undo this later, and just refer to the OSG in the top-level
 *  component. */
/**
 * Global LESS variables
 */
/* Colors */
/* Layout */
.global-lh-pd-fs {
  padding: 0 10px;
}
:export {
  ey-buttercup: #ffee99;
  ey-green: #2c973e;
  ey-green-50: #95cb89;
  ey-lilac: #ac98db;
  ey-lilac-50: #d8d2e0;
  ey-link-blue: #336699;
  ey-link-blue-50: #7fd1d6;
  ey-purple: #91278f;
  ey-purple-50: #c893c7;
  ey-red: #f04c3e;
  ey-white: #fff;
  ey-yellow: #ffd200;
  ey-orange: #f7941d;
  gray-light: #f0f0f0;
  gray: #c0c0c0;
  gray-half: #81858b;
  gray-34th: #44494f;
  gray-dark: #24282d;
  gray-charcoal: #333;
  grey-50: #3b3838;
  grey-70: #7f7f7f;
  ey-sky-blue: #35b7c0;
  ey-teal: #00a3ae;
  gray-100: #44494f;
  grey-light-bg: #f4f4f4;
  gray-14th: #bec1c7;
  ey-ready-green: #00a4ae;
  ey-inqueuebadge: #fcd5b5;
  ey-inprogressbadge: #d7e4bd /* Layout */;
  footer-height: 30px;
  footer-padding: 5px;
  nav-height: 80px;
  screen-xs: 480px;
  screen-sm: 768px;
  screen-md: 992px;
  screen-lg: 1200px;
  cursor-disabled: default;
  labelWeightNormal: normal;
  z-index-select-dropdown: 1060;
  input-color-placeholder: #999;
  channelToolsWidth: 100%;
  baseFontSize: 12px;
  toggleButtonBorder: #d9dadb;
  toggleActiveButton: #ffe600;
  buttonBorderRadius: 4px;
  inputBorderRadius: 4px;
  textColorWhite: #fff;
  inputActiveBorder: #f7941d;
  label-font-weight: bold;
  baseVMFontSize: 0.77vw;
  label-placeholder-color: #81858b;
  formComponentHeight: 30px;
  typeaheadTokenColor: #e7f4ff;
  typeheadLabelColor: #1f8dd6;
  typeheadDisabledColor: #ddd;
  typeheadSelectedColor: #1f8dd6;
  buttonDisabled: #ddd;
  buttonActiveBorder: #bde7ea;
  opacity-transparent: 1;
  opacity-blur: 0.8;
  ey-border-radius: 4px;
  cursor-default: default;
  cursor-pointer: pointer;
  boxshadow-none: none;
  display-inline: inline-block;
  typeahead-background: #646464;
  baseFormLineHeight: 32px;
  global100Percent: 100%;
  globalRadius: 0px;
  bg-disabled: #eee;
  mobile-default: only screen and (min-width : 320x) and (max-width : 575px);
  mobile-large: only screen and (min-width : 576px) and (max-width : 766px);
  tablet-default: only screen and (min-width : 768px) and (max-width : 991px);
  desktop-small: only screen and (min-width : 992px) and (max-width : 1366px);
  desktop-default: only screen and (min-width : 1200px);
  desktop-large: only screen and (min-width : 1824px);
}
@font-face {
  font-family: 'EYInterstate';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: 'EYInterstate';
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: 'EYInterstate';
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: 'EYInterstate';
  font-style: italic;
  font-weight: bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
@font-face {
  font-family: 'EYInterstate';
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
/* default Global font sizes */
html {
  height: 100vh;
  width: 100%;
  font-size: 14px !important;
}
@media only screen and (min-width : 1367px) and (max-width : 1600px) {
  html {
    font-size: 12.61px !important;
  }
}
@media only screen and (min-width : 992px) and (max-width : 1366px) {
  html {
    font-size: 11.2px !important;
  }
}
@media only screen and (min-width : 768px) and (max-width : 991px) {
  html {
    font-size: 11.2px !important;
  }
}
body {
  height: 100%;
  width: 100%;
  overflow: hidden !important;
  margin: 0 auto;
  font-family: 'EYInterstate' !important;
  font-size: 14px !important;
}
@media only screen and (min-width : 1367px) and (max-width : 1600px) {
  body {
    font-size: 12.61px !important;
  }
}
@media only screen and (min-width : 992px) and (max-width : 1366px) {
  body {
    font-size: 11.2px !important;
  }
}
@media only screen and (min-width : 768px) and (max-width : 991px) {
  body {
    font-size: 11.2px !important;
  }
}
body * {
  font-family: 'EYInterstate';
}
/*Typing Loader*/
.typing_loader {
  width: var(--px-6);
  height: var(--px-6);
  border-radius: 50%;
  -webkit-animation: typing 1s linear infinite alternate;
  -moz-animation: Typing 1s linear infinite alternate;
  animation: typing 1s linear infinite alternate;
  margin: var(--px-4) var(--px-10);
  position: relative;
  left: calc(var(--px-12) * -1);
}
@-webkit-keyframes typing {
  0% {
    background-color: #ffd200;
    box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0, 0.2), var(--px-24) 0 0 0 rgba(255, 210, 0, 0.2);
  }
  25% {
    background-color: rgba(255, 210, 0, 0.4);
    box-shadow: var(--px-12) 0 0 0 #ffd200, var(--px-24) 0 0 0 rgba(255, 210, 0, 0.2);
  }
  75% {
    background-color: rgba(255, 210, 0, 0.4);
    box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0, 0.2), var(--px-24) 0 0 0 #ffd200;
  }
}
@-moz-keyframes typing {
  0% {
    background-color: #ffd200;
    box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0, 0.2), var(--px-24) 0 0 0 rgba(255, 210, 0, 0.2);
  }
  25% {
    background-color: rgba(255, 210, 0, 0.4);
    box-shadow: var(--px-12) 0 0 0 #ffd200, var(--px-24) 0 0 0 rgba(255, 210, 0, 0.2);
  }
  75% {
    background-color: rgba(255, 210, 0, 0.4);
    box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0, 0.2), var(--px-24) 0 0 0 #ffd200;
  }
}
@keyframes typing {
  0% {
    background-color: #ffd200;
    box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0, 0.2), var(--px-24) 0 0 0 rgba(255, 210, 0, 0.2);
  }
  25% {
    background-color: rgba(255, 210, 0, 0.4);
    box-shadow: var(--px-12) 0 0 0 #ffd200, var(--px-24) 0 0 0 rgba(255, 210, 0, 0.2);
  }
  75% {
    background-color: rgba(255, 210, 0, 0.4);
    box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0, 0.2), var(--px-24) 0 0 0 #ffd200;
  }
}
html,
body,
div,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video,
button {
  font-family: 'EYInterstate' !important;
  font-size: unset;
  border-radius: unset;
}
body .k-animation-container.k-animation-container-shown {
  z-index: 10009 !important;
}
body .SuspenseLoadingIndicator {
  margin-top: 0 !important;
}
#mount {
  display: flex;
  flex: 1;
  flex-flow: column;
}
.QSISlider {
  top: var(--px-60) !important;
  height: calc(100% - var(--px-60)) !important;
}
.QSISlider > div:first-child {
  height: 100% !important;
}
.rootWrapper {
  height: 99.9vh;
  display: flex;
  flex-flow: column;
  overflow: hidden;
}
.main {
  display: flex;
  flex: 1;
  overflow: hidden;
  position: absolute;
  top: var(--px-56);
  height: calc(100vh - var(--px-56));
  width: 100vw;
  margin: 0 auto;
}
.main.accountdetails {
  top: 0;
  height: 100%;
}
.offlineprep,
.offline {
  border: var(--px-7) solid #109090;
}
.offlineprep .rightContainer,
.offline .rightContainer {
  padding-top: var(--px-30);
}
.training {
  border: var(--px-7) solid #91278f;
}
.connection-available,
.syncstate {
  border: var(--px-7) solid #35a4e8;
}
.container {
  width: 100%;
}
.btn {
  border-radius: 0;
  outline: none !important;
}
ol {
  margin: 0;
  padding: 0;
}
ol li {
  margin: 0;
}
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
ul li {
  margin: 0;
  list-style-type: none;
}
.hide {
  display: none;
}
.carret-right {
  width: 0;
  height: 0;
  border-top: var(--px-5) solid transparent;
  border-bottom: var(--px-5) solid transparent;
  border-left: var(--px-7) solid #24282d;
  margin-right: var(--px-10);
  vertical-align: top;
  margin-top: var(--px-3);
  display: inline-block;
}
.TaskBadgeSection {
  cursor: pointer !important;
}
.TaskBadgeSection:hover .TaskNames span {
  text-decoration: underline;
}
.mainResponsiveWrapper {
  width: calc(100vw - 80px);
  margin: 0 auto;
  max-width: 2048px;
}
.task-left-panel {
  vertical-align: top;
  font-size: var(--px-14);
  position: relative;
  min-width: 14%;
  align-self: auto;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
}
.task-left-panel h3 {
  font-size: var(--px-13);
  margin: 0;
  padding: var(--px-10) 0 0;
  line-height: 2.4px;
}
.task-left-panel h3 a {
  text-decoration: none;
  color: #2e2e38;
}
.task-list-panel {
  width: 400px;
  display: flex;
  flex-direction: column;
}
.task-details-panel {
  width: calc(100% - 400px);
  vertical-align: top;
  align-self: auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.collapse-text {
  writing-mode: vertical-rl;
  font-weight: bold;
  top: 0;
  left: 0;
  margin-top: var(--px-10);
  display: none;
  vertical-align: top;
  font-size: var(--px-13);
  position: absolute;
}
.search-filter-control {
  width: 390px;
  vertical-align: top;
  display: flex;
}
.leftContainerCollapsed .search-filter-control {
  width: 490px;
}
.bold-text {
  font-weight: bold;
}
.drawer-opener {
  z-index: 997 !important;
}
svg {
  vertical-align: top;
}
svg.extra-large {
  width: var(--px-36);
  height: var(--px-36);
  max-width: var(--px-36);
  max-height: var(--px-36);
}
svg.large {
  width: var(--px-24);
  height: var(--px-24);
  max-width: var(--px-24);
  max-height: var(--px-24);
}
svg.medium {
  width: var(--px-20);
  height: var(--px-20);
  max-width: var(--px-20);
  max-height: var(--px-20);
}
svg.small {
  width: var(--px-16);
  height: var(--px-16);
  max-width: var(--px-16);
  max-height: var(--px-16);
}
svg.task-Progress,
svg.task-Review {
  stroke-width: var(--px-3);
}
svg.task-Progress path:nth-child(3),
svg.task-Review path:nth-child(3) {
  stroke: #168736;
}
svg.task-Complete {
  stroke-width: var(--px-3);
}
svg.task-Complete path:nth-child(3) {
  stroke: #168736;
}
svg.task-Open,
svg.task-Complete {
  stroke-width: var(--px-3);
}
svg.task-Open path:last-child,
svg.task-Complete path:last-child {
  fill: transparent !important;
  stroke: transparent;
}
svg.task-Completed:first-child {
  stroke-width: var(--px-3);
}
svg.gray {
  fill: #666;
}
svg.yellow {
  fill: #ffd200;
}
svg.red {
  fill: #b9251c;
}
svg.green {
  fill: #2c973e;
}
svg.orange {
  fill: #f7941d;
}
svg.purple {
  fill: #91278f;
}
svg.blue {
  fill: #155cb4;
}
svg.teal {
  fill: #109090;
}
svg.disable {
  cursor: default;
}
.gray {
  fill: #c0c0c0;
}
.black svg {
  fill: #000;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 var(--px-1000) white inset;
}
.progressBar {
  width: 100%;
  padding-right: var(--px-20);
}
.progressBar progress {
  border: none;
  width: 100%;
  height: var(--px-3);
  background: #c0c0c0;
}
.progressBar progress::-moz-progress-bar {
  background: #c0c0c0;
}
.progressBar progress::-webkit-progress-value {
  background: #ffd200;
}
.results-not-found {
  text-align: center;
  padding: var(--px-20);
  font-size: var(--px-13);
}
.removeFromTask-message {
  font-size: var(--px-13);
}
.cleared .reviewNote-details span.Medium,
.cleared .reviewNote-details span.Low,
.cleared .reviewNote-details span.Critical,
.cleared .reviewNote-details span.High,
.closed .reviewNote-details span.Medium,
.closed .reviewNote-details span.Critical,
.closed .reviewNote-details span.Low,
.closed .reviewNote-details span.High,
.closed .reviewNote-item .left-border,
.cleared .reviewNote-item .left-border {
  color: #c0c0c0 !important;
  border-color: #c0c0c0 !important;
}
.text-input .form-group .input-group input.form-control {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat right top;
}
.error-message-wrapper {
  padding: 0;
  color: #2e2e38;
  display: table;
  width: 100%;
  font-size: var(--px-12);
  line-height: var(--px-18);
  border: var(--px-1) solid #7f7f7f;
}
.error-message-wrapper .error-message {
  display: table-cell;
  padding: var(--px-9) var(--px-10) var(--px-5);
  color: #2e2e38;
  background: #fff;
}
.errorIcon,
.success-icon,
.warning-icon,
.info-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat var(--px-10) var(--px-10);
  width: var(--px-16);
  height: var(--px-16);
  display: inline-block;
  padding: var(--px-18);
  display: table-cell;
  background-color: #b9251c;
  background-size: 50%;
}
.success-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat var(--px-7) var(--px-7);
  background-color: #2c973e;
}
.warning-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat var(--px-9) var(--px-7);
  background-color: #ff9831;
}
.info-icon {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat var(--px-9) var(--px-7);
  background-color: #747480;
}
.note-error {
  color: #b9251c;
}
.note-error .k-editor-widget.k-editor {
  border: var(--px-1) solid #b9251c;
}
.note-error .note-error-icon {
  fill: #b9251c !important;
  margin: var(--px-5) var(--px-5) 0 0;
}
.note-error .note-error-message {
  margin: var(--px-5) 0;
}
.note-error .note-error-message .error-text {
  font-size: var(--px-13);
  color: #b9251c;
  line-height: normal;
}
.StyledModal.modal-body {
  display: flex !important;
  flex: 1;
  flex-direction: row;
  height: calc(-94px + 100vh);
  overflow: hidden !important;
}
.StyledModal.modal-body .StyledTabs {
  width: 100%;
}
.StyledModal.modal-body .StyledTabs > div {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
}
.StyledModal.modal-body ul.tab-list {
  display: flex;
  flex: 1;
  max-height: var(--px-50);
}
.StyledModal.modal-body .tab-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}
.StyledModal.modal-body .tab-content .HeadingWrapper {
  margin: 0 var(--px-20);
}
.optional-tag {
  font-weight: normal;
  font-style: italic;
  color: #3b3838;
  padding-left: var(--px-10);
}
.prevent-select-text {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.NavigationBar .StyledEYLogoWrapper.EYLogo {
  white-space: nowrap;
}
@media only screen and (min-width: 1921px) {
  .NavigationBar .StyledEYLogoWrapper.EYLogo {
    margin-left: 0 !important;
  }
}
@media only screen and (min-width: 1921px) {
  .NavigationBar .EYNavigation {
    margin-right: 0 !important;
  }
}
.NavigationBar .EYNavigation .navChild,
.NavigationBar .EYNavigation .navAnchor {
  height: var(--px-60);
}
.NavigationBar .EYNavigation .DefaultMenuContainer {
  height: var(--px-60);
}
.NavigationBar .EYNavigation .DefaultMenuContainer .Notification .notification-main-wrap {
  max-height: var(--px-24) !important;
}
.NavigationBar .EYEngagementDefault {
  max-height: var(--px-60);
}
@media only screen and (min-width : 1367px) and (max-width : 1600px) {
  html {
    font-size: 12.61px !important;
  }
}
@media only screen and (min-width : 992px) and (max-width : 1366px) {
  html {
    font-size: 11.2px !important;
  }
  .task-category-title {
    width: 100px !important;
  }
  .task-list-panel {
    width: 330px;
  }
  .task-details-panel {
    width: calc(100% - 300px);
  }
  .document-name-span .last-modified .modifiedName {
    max-width: 60% !important;
  }
  .search-filter-control {
    width: 290px;
  }
  .leftContainerCollapsed .rightContainer .task-list-panel {
    width: 400px !important;
  }
  .leftContainerCollapsed .rightContainer .task-details-panel {
    width: calc(100% - 400px) !important;
  }
  .leftContainerCollapsed .rightContainer .search-filter-control {
    width: 390px;
  }
  .container span.timeline .datesContainer section.buttonDiv button {
    height: var(--px-15) !important;
  }
}
.task-layout-wrapper,
.notes-layout-wrapper,
.documents-layout-wrapper,
.modalBodyFlexHieght {
  background-color: #f6f6f6;
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
  overflow-x: hidden;
}
.task-layout-wrapper,
.notes-layout-wrapper {
  background: linear-gradient(to right, #2e2e38 50%, #fff 50%);
}
.modalBodyFlexHieght {
  background: transparent;
}
.modalBodyFlexHieght.nobodyOverflow .Wizcomponent .errorMessageWrapper {
  margin-top: calc(var(--px-10) * -1);
}
.relateEvidenceModalBody {
  display: flex !important;
  height: 100%;
}
.WCGWWrapper .count,
.RiskWrapper .count,
.SEM-body .count,
.ValidationsWrapper .count,
.risk-category-header .count,
.accountTypes .count {
  color: #2e2e38;
  padding: var(--px-4) var(--px-8);
  line-height: var(--px-12);
  border-radius: var(--px-10);
  font-size: var(--px-12);
  display: inline-block;
  vertical-align: text-bottom;
  margin: var(--px-3) 0 var(--px-2) 0;
  text-align: center;
  min-width: 35px;
  border: var(--px-1) solid #ddd;
}
.edit-note-modal-wrapper .modal-wrapper {
  display: flex;
  flex-direction: column;
  height: 490px;
}
.edit-note-modal-wrapper .modal-wrapper .edit-note-modal-body {
  flex-grow: 1;
}
.keyevent-tooltip .motif-icon-button {
  display: none;
}
.keyevent-tooltip .keyevent-date {
  font-size: var(--px-10);
  margin-top: var(--px-10);
  display: inline-block;
}
.keyevent-tooltip .motif-tooltip {
  min-width: 10%;
}
.keyevent-tooltip .keyevent-ellipses {
  font-size: var(--px-12);
  padding: var(--px-5) 0;
}
.keyevent-tooltip .motif-tooltip-content-children {
  max-height: 200px;
  overflow-y: auto;
}
.keyevent-tooltip .motif-tooltip-inner .motif-icon-button svg {
  width: var(--px-10);
  height: var(--px-10);
}
.keyevent-tooltip hr {
  margin: var(--px-10) 0;
  border-top: solid var(--px-1) #ccc;
}
.assertionToolTip .motif-tooltip {
  width: var(--px-250);
}
.assertionToolTip .motif-tooltip .motif-tooltip-wrapper {
  margin-top: 0 !important;
}
.assertionToolTip .motif-tooltip .motif-tooltip-content-children {
  margin: 0;
  width: 100%;
}
.assertionToolTip .motif-tooltip .motif-tooltip-inner .risk-Type-Header {
  padding: 0 var(--px-10) var(--px-10) 0;
  margin: 0;
  font-size: var(--px-14);
  font-weight: bold;
  border-bottom: var(--px-1) solid var(--neutrals-300);
  border-radius: var(--px-4) var(--px-4) 0 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.assertionToolTip .motif-tooltip .motif-tooltip-inner ul.assertionsList {
  font-size: var(--px-14);
  border-radius: 0 0 var(--px-4) var(--px-4) !important;
}
.assertionToolTip .motif-tooltip .motif-tooltip-inner ul.assertionsList li {
  font-weight: bold;
  padding: var(--px-8) 0;
  display: flex;
}
.assertionToolTip .motif-tooltip .motif-tooltip-inner ul.assertionsList li .risk-Type-Label {
  width: auto;
  max-width: var(--px-80);
  display: flex;
  margin-bottom: var(--px-5);
}
.assertionToolTip .motif-tooltip .motif-tooltip-inner ul.assertionsList li .risk-Type-Label .risk-Type-Label-inner {
  max-width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.assertionToolTip .motif-tooltip .motif-tooltip-inner ul.assertionsList li .risk-Type-Value {
  margin-bottom: var(--px-5);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: var(--px-120);
}
.assertionToolTip .motif-tooltip .motif-tooltip-inner ul.assertionsList li:last-child {
  margin-bottom: 0;
}
.assertionToolTip .motif-tooltip .motif-tooltip-inner ul.assertionsList li.emptyContainer {
  padding: var(--px-8) 0;
}
.assertionToolTip .motif-tooltip-right {
  width: var(--px-250);
}
.assertionToolTip .motif-tooltip-right .motif-tooltip-inner ul.assertionsList {
  font-size: var(--px-14);
}
.assertionToolTip .motif-tooltip-right .motif-tooltip-inner ul.assertionsList li {
  font-weight: bold;
  padding: var(--px-8) 0;
}
.motif-modal-overlay:has(> div.add-edit-assignment-modal) {
  z-index: 1001;
}
.motif-modal-overlay:has(> div.create-assignment-modal) {
  z-index: 1001;
}
.motif-modal-overlay.SoftwareUpdateModalContainer .motif-modal-body {
  min-height: var(--px-60) !important;
}
.motif-modal-overlay .motif-modal-body .RelatedListUtility .RelatedListPager .addDocument-paging {
  background-color: #23232f;
}
.motif-modal-overlay .motif-modal-body .RelatedListUtility .RelatedListPager .addDocument-paging .Dropdown-control {
  background-color: #23232f;
}
.motif-modal-overlay .motif-modal-body .RelatedListUtility .RelatedListPager .addDocument-paging input[type='text'] {
  background-color: #23232f;
}
.motif-modal-overlay .motif-modal-body .RelatedListUtility .RelatedListPager .addDocument-paging input[type='text']:hover {
  border-bottom: 0 !important;
}
.motif-modal-overlay .motif-modal-body.SignoffRequirementsModalBody .StyledSignoffRequirementsModal {
  min-height: var(--px-200) !important;
}
.motif-modal-overlay .motif-modal-body.noPadding {
  padding: 0;
}
.motif-modal-overlay .motif-modal-body .StyledToastMessageContainer {
  width: calc(100% - calc(2 * var(--spacing-x-large)));
  left: var(--spacing-x-large);
}
.motif-modal-overlay .DocumentConflictModal {
  max-width: 72%;
  width: 72%;
  max-height: 100%;
  height: calc(100vh - var(--px-40));
  font-size: var(--px-14);
}
.motif-modal-overlay .DocumentConflictModal .DocumentConflictNameWrapper {
  padding: var(--px-10) 0;
  width: 100%;
}
.motif-modal-overlay .DocumentConflictModal .DocumentConflictNameWrapper .DocumentNameWrapper {
  width: 100%;
}
.motif-modal-overlay .DocumentConflictModal .DocumentConflictNameWrapper .DocumentNameWrapper .AdvanceDocName .DocumentNameContainer {
  align-items: flex-start;
}
.motif-modal-overlay .DocumentConflictModal .DocumentConflictNameWrapper .DocumentNameWrapper .AdvanceDocName .DocumentNameContainer .DocumentNameDetails {
  min-height: var(--px-40);
}
.motif-modal-overlay .DocumentConflictModal .DocumentConflictNameWrapper .DocumentNameWrapper .AdvanceDocName .DocumentNameContainer .DocumentNameDetails .DocumentName {
  display: inline-block;
  height: inherit;
}
.motif-modal-overlay .DocumentConflictModal .DocumentConflictNameWrapper .DocumentNameWrapper .AdvanceDocName .DocumentNameContainer .DocumentNameDetails .DocumentName .last-modified {
  margin-left: 0;
}
.motif-modal-overlay .sendToPrimaryTeamModal {
  width: 60% !important;
  max-width: 60% !important;
}
.motif-modal-overlay .errorMessageWrapper {
  margin: calc(var(--px-10) * -1) 0 var(--px-10) 0 !important;
  height: auto;
}
.motif-modal-overlay .errorMessageWrapper .close-icon {
  position: relative;
  top: var(--px-8);
  right: var(--px-10);
}
.motif-modal-overlay .DeleteDocumentModalBody {
  min-height: var(--px-150) !important;
}
.motif-modal-overlay .DeleteDocumentModalBody .errorMessageWrapper {
  margin: var(--px-10) 0 !important;
  height: var(--px-38);
}
.motif-modal-overlay .DeleteDocumentModalBody .errorMessageWrapper .close-icon {
  position: relative;
  top: var(--px-8);
  right: var(--px-10);
}
.motif-modal-overlay .DeleteDocumentModalBody .DocumentName {
  font-size: var(--px-16) !important;
}
.motif-modal-overlay .RestoreModal {
  min-height: var(--px-100) !important;
}
.motif-modal-overlay .RestoreModal .errorMessageWrapper {
  margin: calc(var(--px-10) * -1) 0 var(--px-10) 0 !important;
  height: var(--px-38);
}
.motif-modal-overlay .RestoreModal .errorMessageWrapper .close-icon {
  position: relative;
  top: var(--px-8);
  right: var(--px-10);
}
.motif-modal-overlay .RestoreModal .DocumentNameWrapper .DocumentNameWrapper {
  padding: 0;
}
.motif-modal-overlay .RestoreModal .RestoreText {
  padding: var(--px-10) var(--px-20);
  font-size: var(--px-14);
}
.motif-modal-overlay .PermanentlyDeleteModal {
  min-height: var(--px-150);
}
.motif-modal-overlay .PermanentlyDeleteModal .errorMessageWrapper {
  margin: calc(var(--px-10) * -1) 0 var(--px-10) 0 !important;
  height: var(--px-38);
}
.motif-modal-overlay .PermanentlyDeleteModal .errorMessageWrapper .close-icon {
  position: relative;
  top: var(--px-8);
  right: var(--px-10);
}
.motif-modal-overlay .PermanentlyDeleteModal .DocumentNameWrapper .DocumentNameWrapper {
  padding: 0;
}
.motif-modal-overlay .PermanentlyDeleteModal .PermanentlyDeleteText {
  padding: var(--px-20) 0;
  font-size: var(--px-14);
}
.motif-modal-overlay .ConfidentialityModalContainer .StyledConfidentiality {
  min-height: var(--px-400);
  padding: 0;
}
.motif-modal-overlay .ConfidentialityModalContainer .motif-modal-body.ConfidentialityModalBody {
  overflow-y: auto;
}
.motif-modal-overlay .ConfidentialityModalContainer .motif-modal-body.ConfidentialityModalBody .motif-select-trigger {
  height: var(--px-45);
}
.motif-modal-overlay .ConfidentialityModalContainer .motif-modal-body.ConfidentialityModalBody .motif-select-view-value {
  width: calc(100% - var(--px-30));
}
.motif-modal-overlay .ConfidentialityModalContainer .motif-modal-body.ConfidentialityModalBody .motif-option {
  min-height: var(--px-45);
}
.contentUpdateTooltip .motif-tooltip-inner {
  max-width: var(--px-380);
}
.contentUpdateTooltip .contentUpdateTooltipText {
  display: flex;
  align-items: center;
}
.statusTooltip .motif-tooltip .tooltip-text {
  text-align: center;
}
.statusTooltip .motif-tooltip-inner .motif-tooltip-content-children {
  width: 100%;
}
.statusTooltip .motif-tooltip-inner .tooltip-text {
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}
.canvas-form-tooltip .motif-tooltip-wrapper {
  margin: 0 !important;
}
.DocumentListHeaderPercentToolTip .motif-tooltip-inner {
  width: var(--px-600);
}
.DocumentListHeaderPercentToolTip .motif-tooltip-inner .motif-tooltip-content-children {
  width: 100%;
}
/* CustomScrollbar CSS Starts */
.customScrollbar {
  overflow-y: auto;
}
.customScrollbar::-webkit-scrollbar {
  width: 6px !important;
  border: none !important;
}
.customScrollbar::-webkit-scrollbar-track {
  background: #e7e7ea !important;
  width: 6px !important;
  border: none !important;
}
.customScrollbar::-webkit-scrollbar-thumb {
  background: #c4c4cd !important;
  width: 6px !important;
  cursor: pointer !important;
  border: none !important;
}
.customScrollbar::-webkit-scrollbar-thumb:hover {
  background: #747480 !important;
  border: none !important;
}
::-webkit-scrollbar {
  width: 6px !important;
  border: none !important;
}
::-webkit-scrollbar-track {
  background: #e7e7ea !important;
  width: 6px !important;
  border: none !important;
}
::-webkit-scrollbar-thumb {
  background: #c4c4cd !important;
  width: 6px !important;
  cursor: pointer !important;
  border: none !important;
}
::-webkit-scrollbar-thumb:hover {
  background: #747480 !important;
  border: none !important;
}
/* CustomScrollbar CSS Ends */
.selectBoxlabelTopPos .show {
  display: flex !important;
  align-items: center;
  margin-top: var(--px-5);
}
.selectBoxlabelTopPos .show svg.medium {
  margin-top: 0;
  width: var(--px-16);
  height: var(--px-16);
  fill: #b9251c;
  margin-right: var(--px-5);
}
.selectBoxlabelTopPos .show .error-text {
  color: #b9251c;
}
.delete-tag-tooltip .motif-tooltip {
  width: var(--px-210);
}
.overrideAssignment .motif-tooltip-inner .motif-tooltip-content-children {
  width: 100%;
}
.service-req-tooltip .motif-tooltip-inner {
  width: var(--px-460);
}
.service-req-mark-complete .motif-tooltip-inner {
  min-width: var(--px-20);
  max-width: var(--px-460);
}
.step2-tooltip .motif-tooltip-inner {
  width: var(--px-500);
}
.step2-tooltip .motif-tooltip-inner .motif-tooltip-content-children {
  width: 100%;
}
.motif-modal-content .confirm-start-multiuser-editing-modal-body .document-name {
  display: flex;
  align-items: flex-start;
  width: 100%;
}
.motif-modal-content .confirm-start-multiuser-editing-modal-body .document-name .StyledFileName {
  width: 100%;
}
.motif-modal-content .confirm-start-multiuser-editing-modal-body .document-name .StyledFileName .DocumentName {
  width: 100%;
}
.motif-modal-content .confirm-start-multiuser-editing-modal-body .document-name .StyledFileName .DocumentName .DocumentNameText {
  width: 100%;
}
.motif-modal-content .confirm-start-multiuser-editing-modal-body .document-name .StyledFileName .DocumentName .DocumentNameText .DocumentName {
  width: 100%;
}
.motif-modal-content .confirm-start-multiuser-editing-modal-body .document-name .StyledFileName .documentName-icons {
  display: none;
}
.motif-modal-content.small.sdm-modal-control {
  width: 75% !important;
  max-width: 75% !important;
}
.motif-modal-content.small.StyledDocumentOpened .ModalDocumentOpened .document-opened-header {
  display: flex;
  flex-direction: column;
}
.motif-modal-content.small.StyledDocumentOpened .ModalDocumentOpened .document-opened-header h4 {
  font-weight: bold;
  color: var(--neutrals-900);
  margin: 0 0 var(--px-24) 0;
}
.motif-modal-content.small.StyledDocumentOpened .ModalDocumentOpened .document-opened-header .SpanLabelText {
  color: var(--neutrals-900);
  margin-bottom: var(--px-24);
}
.motif-modal-content.small.StyledDocumentOpened .ModalDocumentOpened .document-opnened-docname .DocumentNameContainer {
  align-items: flex-start;
}
.motif-modal-content.small.StyledDocumentOpened .ModalDocumentOpened .document-opnened-docname .DocumentNameContainer .DocumentName .DocumentName {
  font-size: var(--px-16);
  color: var(--neutrals-900);
  opacity: 1;
}
.motif-modal-content.small.StyledDocumentOpened .ModalDocumentOpened .document-opnened-docname .DocumentNameContainer .DocumentName .DocumentName.disabled {
  color: var(--neutrals-500);
  opacity: 1;
}
.motif-modal-content.small.StyledDocumentOpened .ModalDocumentOpened .document-opnened-docname .DocumentNameContainer .DocumentNameDetails .DocumentName .last-modified,
.motif-modal-content.small.StyledDocumentOpened .ModalDocumentOpened .document-opnened-docname .DocumentNameContainer .DocumentNameDetails .DocumentName .currently-modified {
  margin-left: 0 !important;
  color: var(--neutrals-500);
}
.motif-modal-content.small.ChangeReasonModalContainer {
  height: calc(100% - var(--px-60)) !important;
}
.motif-modal-content.small.ChangeReasonModalContainer .ChangeReasonModalBody .ChangeReasonSelect .react-select-container .react-select__menu .react-select__menu-list {
  max-height: var(--px-500) !important;
}
@media screen and (min-width: 1601px) and (max-width: 1900px) {
  .motif-modal-content.small.ChangeReasonModalContainer .ChangeReasonModalBody .ChangeReasonSelect .react-select-container .react-select__menu .react-select__menu-list {
    max-height: var(--px-350) !important;
  }
}
@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .motif-modal-content.small.ChangeReasonModalContainer .ChangeReasonModalBody .ChangeReasonSelect .react-select-container .react-select__menu .react-select__menu-list {
    max-height: var(--px-350) !important;
  }
}
@media screen and (min-width: 1281px) and (max-width: 1366px) {
  .motif-modal-content.small.ChangeReasonModalContainer .ChangeReasonModalBody .ChangeReasonSelect .react-select-container .react-select__menu .react-select__menu-list {
    max-height: var(--px-320) !important;
  }
}
@media screen and (max-width: 1280px) {
  .motif-modal-content.small.ChangeReasonModalContainer .ChangeReasonModalBody .ChangeReasonSelect .react-select-container .react-select__menu .react-select__menu-list {
    max-height: var(--px-300) !important;
  }
}
.motif-modal-content.small.ConfidentialityModalContainer {
  height: calc(100% - var(--px-60)) !important;
}
.package-list-modal.motif-modal.small {
  height: 100% !important;
}
.package-list-modal .error-icon-wrap {
  margin-top: -1px;
}
.package-list-modal .motif-progress-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - var(--px-350));
}
.package-list-modal .modalbody-wrapper.customScrollbar {
  height: calc(100vh - var(--px-180)) !important;
}
.service-req-modal .error-icon-wrap {
  margin-top: -1px;
}
.service-req-modal .modalbody-wrapper.customScrollbar {
  height: calc(100vh - var(--px-324)) !important;
}
.motif-dropdown-menu-portal {
  min-width: var(--px-300);
}
.MoreMenuContainer .motif-menu-overlay {
  pointer-events: none;
}
.tasks-tooltip .tasks-tooltip-inner {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tasks-tooltip .motif-tooltip-content-children {
  margin-right: 0;
}
.tasks-tooltip .status-count {
  width: var(--px-25);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  margin-right: var(--px-3);
}
.tasks-tooltip svg.large.progress-circle {
  margin-right: var(--px-2);
  width: var(--px-23);
  height: var(--px-23);
  max-width: var(--px-34);
  max-height: var(--px-34);
}
.tasks-tooltip svg.large.progress-circle.in-progress path:last-child {
  stroke: #189d3e;
}
.tasks-tooltip svg.large.progress-circle.in-review path:last-child {
  stroke: #189d3e;
}
.tasks-tooltip svg.large.progress-circle.completed path {
  stroke: #168736;
}
.tasks-tooltip svg.large.progress-circle.completed path:last-child {
  stroke-width: var(--px-1);
}
.tasks-tooltip svg.progress-circle path {
  stroke-width: var(--px-3);
}
.canvasoversight-tooltip .motif-tooltip {
  width: var(--px-320);
}
.canvasoversight-tooltip .motif-tooltip-content-children {
  width: 100%;
}
.canvasoversight-tooltip .clients-list-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 99%;
}
.access-location-tooltip .motif-tooltip-content-children,
.schedule-request-tooltip .motif-tooltip-content-children {
  width: var(--px-400);
}
.schedule-request-tooltip .motif-tooltip-content-children {
  width: var(--px-200) !important;
}
.assertions-tooltip .motif-tooltip-content-children {
  width: var(--px-250);
}
.assertions-tooltip .motif-tooltip-content-children .assertion-header {
  font-size: var(--px-12);
  margin: 0;
  width: 100%;
  padding: var(--px-10) var(--px-15);
  background: #f6f6fa;
  display: flex;
}
.assertions-tooltip .motif-tooltip-content-children .assertion-header .header-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 90%;
  font-size: var(--px-14);
}
.assertions-tooltip .motif-tooltip-content-children .risk-Type-Header {
  margin-left: var(--px-5);
}
.assertions-tooltip .motif-tooltip-content-children .cra-badges-wrap {
  min-height: var(--px-40);
  max-height: var(--px-200);
  font-size: var(--px-10);
}
.count-icon-wrap {
  display: flex;
  align-items: center;
}
.notes-tooltip .motif-tooltip-inner {
  width: var(--px-100);
}
.notes-tooltip .motif-tooltip-inner .motif-tooltip-content-children {
  width: 100%;
}
.notes-tooltip .motif-tooltip-inner .count-text-wrap {
  display: flex;
  align-items: center;
  margin-bottom: var(--px-5);
}
.notes-tooltip .motif-tooltip-inner .status-count {
  width: 25%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
.notes-tooltip .motif-tooltip-inner .status-text {
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  margin-left: var(--px-5);
}
.notes-tooltip .motif-tooltip-inner .status-text.medium {
  color: #ff810a;
}
.notes-tooltip .motif-tooltip-inner .status-text.high {
  color: #bc2f00;
}
.notes-tooltip .motif-tooltip-inner .status-text.critical {
  color: #7a130d;
}
.notes-tooltip .notes-tooltip-inner {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: var(--px-12);
}
.ep-tooltip .motif-tooltip,
.eqr-tooltip .motif-tooltip,
.complete-assng-tooltip .motif-tooltip {
  width: var(--px-200);
}
.ep-tooltip .motif-tooltip-inner .motif-tooltip-content-children,
.eqr-tooltip .motif-tooltip-inner .motif-tooltip-content-children,
.complete-assng-tooltip .motif-tooltip-inner .motif-tooltip-content-children {
  width: 100%;
}
.ep-tooltip .motif-tooltip-inner .count-text-wrap,
.eqr-tooltip .motif-tooltip-inner .count-text-wrap,
.complete-assng-tooltip .motif-tooltip-inner .count-text-wrap {
  display: flex;
  align-items: center;
  margin-bottom: var(--px-5);
}
.ep-tooltip .motif-tooltip-inner .status-count,
.eqr-tooltip .motif-tooltip-inner .status-count,
.complete-assng-tooltip .motif-tooltip-inner .status-count {
  width: 15%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  color: #922b73;
}
.ep-tooltip .motif-tooltip-inner .status-text,
.eqr-tooltip .motif-tooltip-inner .status-text,
.complete-assng-tooltip .motif-tooltip-inner .status-text {
  width: 85%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  margin-left: var(--px-5);
}
.ep-tooltip .ep-tooltip-inner,
.eqr-tooltip .ep-tooltip-inner,
.complete-assng-tooltip .ep-tooltip-inner,
.ep-tooltip .eqr-tooltip-inner,
.eqr-tooltip .eqr-tooltip-inner,
.complete-assng-tooltip .eqr-tooltip-inner,
.ep-tooltip .complete-assng-tooltip-inner,
.eqr-tooltip .complete-assng-tooltip-inner,
.complete-assng-tooltip .complete-assng-tooltip-inner {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: var(--px-12);
}
.ep-tooltip .complete-assng-tooltip-inner,
.eqr-tooltip .complete-assng-tooltip-inner,
.complete-assng-tooltip .complete-assng-tooltip-inner {
  flex-direction: row;
}
.ep-tooltip .complete-assng-tooltip-inner .count-text-wrap,
.eqr-tooltip .complete-assng-tooltip-inner .count-text-wrap,
.complete-assng-tooltip .complete-assng-tooltip-inner .count-text-wrap {
  width: 49%;
  flex-direction: column;
  align-items: flex-start;
}
.ep-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap,
.eqr-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap,
.complete-assng-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap {
  width: 100%;
  display: flex;
  align-items: center;
}
.ep-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text,
.eqr-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text,
.complete-assng-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text {
  font-weight: bold;
  margin-right: var(--px-3);
}
.ep-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text.preparer,
.eqr-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text.preparer,
.complete-assng-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text.preparer {
  color: #155cb4;
}
.ep-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text.reviewer,
.eqr-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text.reviewer,
.complete-assng-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text.reviewer {
  color: #155cb4;
}
.ep-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .status-label,
.eqr-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .status-label,
.complete-assng-tooltip .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .status-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80%;
  display: inline-block;
}
.complete-assng-tooltip .motif-tooltip {
  width: var(--px-250);
}
.complete-assng-tooltip .motif-tooltip-inner .status-text {
  width: 100%;
  margin-left: 0;
  color: #747480;
  font-weight: normal;
  margin-bottom: var(--px-5);
}
.FilterControlWrapper .filter-button-date {
  text-align: left;
}
.addrequest-modal .motif-modal-body ul.errorlist-container {
  margin-top: calc(var(--px-27) * -1);
  position: absolute;
  width: calc(100% - var(--px-40));
}
.addrequest-modal .motif-modal-body ul.errorlist-container li .errorMessageWrapper {
  margin: 0 0 var(--px-3) 0 !important;
}
.motif-tooltip-content.extsignoff-dropdown .tooltip-body .document-approval-item .ellipses {
  width: calc(100% - var(--px-100));
}
.document-opnened-docname .DocumentNameWrapper .DocumentNameWrapper {
  padding: 0;
}
.document-opnened-docname .DocumentNameDetails .DocumentName {
  flex-direction: column;
}
.document-opnened-docname .DocumentNameDetails .DocumentName .DocumentName {
  align-items: flex-start;
  height: auto !important;
}
.k-window .k-window-titlebar .k-window-title {
  font-size: var(--px-17);
  font-weight: bold;
}
.relatedTaskDropdown.bulk-requests-tasks-popup {
  overflow: visible !important;
}
.relatedTaskDropdown.bulk-requests-tasks-popup .taskList {
  padding-inline: 0 !important;
}
.relatedTaskDropdown.bulk-requests-tasks-popup .taskList .taskListBody .listView {
  width: 100% !important;
  margin-bottom: 0 !important;
  padding: var(--px-5) 0 var(--px-5) 0 !important;
}
.relatedTaskDropdown.bulk-requests-tasks-popup .taskList .taskListBody .listView .TaskNames {
  color: #2e2e38 !important;
  margin: 0 !important;
}
.relatedTaskDropdown.bulk-requests-tasks-popup .taskList .taskListBody .listView .TaskNames:hover {
  color: #2e2e38 !important;
}
.relatedTaskDropdown.bulk-requests-tasks-popup .taskList .taskListBody .listView .TaskBadges {
  width: var(--px-60) !important;
}
.relatedTaskDropdown.bulk-requests-tasks-popup .taskList .taskListHeading {
  padding-left: var(--px-30);
}
.relatedTaskDropdown.bulk-requests-tasks-popup .taskList .customScrollbar {
  overflow-y: auto;
}
.relatedTaskDropdown.bulk-requests-tasks-popup.Dataloading {
  pointer-events: none;
}
.relatedTaskDropdown.bulk-requests-tasks-popup.Dataloading .taskList {
  background: #2e2e380d;
  opacity: 0.5;
}
.relatedTaskDropdown.bulk-requests-tasks-popup.Dataloading .taskList .taskListBody {
  overflow: hidden;
}
.relatedTaskDropdown {
  min-width: var(--px-25);
  display: inline-flex !important;
  line-height: var(--px-10);
  justify-content: center;
  align-items: center;
  height: 100%;
}
.relatedTaskDropdown .relatedTaskSection {
  width: var(--px-25);
  display: flex;
  flex-wrap: wrap;
  font-size: var(--px-10) !important;
  font-weight: 400;
  justify-content: center;
  height: 100%;
}
.relatedTaskDropdown .relatedTaskSection .ellipses {
  justify-content: center;
  font-size: var(--px-10);
  font-weight: 400;
  height: var(--px-18);
}
.relatedTaskDropdown .motif-dropdown-trigger {
  width: 100%;
}
.relatedTaskDropdown .motif-dropdown-trigger .relatedTaskSection {
  width: var(--px-25);
  display: flex;
  flex-wrap: wrap;
  font-size: var(--px-10) !important;
  font-weight: 400;
}
.relatedTaskDropdown .motif-dropdown-trigger .relatedTaskSection .ellipses {
  font-size: var(--px-10) !important;
  font-weight: 400;
  height: var(--px-18);
}
.relatedTaskDropdown .taskList .taskListBody .listView .TaskBadges {
  width: var(--px-65) !important;
}
.relatedTaskDropdown .taskList .taskListBody .listView .TaskNames {
  line-height: var(--px-24) !important;
  max-width: calc(100% - var(--px-110)) !important;
  color: #155cb4 !important;
}
.relatedTaskDropdown .taskList .taskListBody .listView .TaskNames:hover {
  color: #155cb4 !important;
}
.relatedTaskDropdown .taskList .taskListBody .listView .TaskNames .showCursor {
  cursor: pointer;
}
.relatedTaskDropdown .taskList .taskListBody .listView .TaskNames a {
  font-size: var(--px-14) !important;
  color: #155cb4 !important;
}
.relatedTaskDropdown .taskList .taskListBody .listView .TaskNames a:hover {
  color: #155cb4 !important;
}
.relatedTaskDropdown .taskList .taskListBody .StyledTaskDrawerSummoner {
  margin-bottom: var(--px-10);
}
.relatedTaskDropdown .taskList .taskListBody .StyledTaskDrawerSummoner:last-child {
  margin-bottom: 0;
}
.relatedTaskDropdown .taskList .taskListBody .StyledTaskDrawerSummoner .listView .TaskNames {
  text-align: left;
}
.relatedTaskDropdown .taskList .taskListBody .StyledTaskDrawerSummoner .listView .TaskNames:hover {
  cursor: pointer;
  text-decoration: underline;
}
.relatedTaskDropdown .taskList .taskListBody .StyledTaskDrawerSummoner .listView .TaskNames a {
  font-size: var(--px-14) !important;
}
.relatedTaskDropdown .CloseButton {
  position: absolute;
  right: var(--px-8);
  top: var(--px-10);
}
.relatedTaskDropdown .CloseButton svg {
  width: var(--px-18) !important;
  height: var(--px-18) !important;
  fill: #2e2e38;
}
.relatedTaskDropdown .CloseButton svg path {
  fill: #2e2e38;
}
.motif-tooltip-content.linkprojects-tooltip .motif-tooltip-content-children .tooltip-content {
  width: var(--px-420);
}
.sharedanalytics-tooltip .motif-tooltip .motif-tooltip-wrapper .motif-tooltip-inner {
  width: var(--px-436_5);
}
@media screen and (max-width: 1366px) {
  .sharedanalytics-tooltip .motif-tooltip .motif-tooltip-wrapper .motif-tooltip-inner {
    width: var(--px-355);
  }
}
.sharedanalytics-tooltip .motif-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children {
  width: 100%;
}
#analyticname-tooltip {
  width: var(--px-350);
}
#analyticname-tooltip.ellipses {
  width: 100% !important;
}
.StyledSearchFilter .filter-search {
  margin-bottom: 0;
  height: var(--px-44);
}
.DocumentNameWrapper .DocumentNameContainer .DocumentNameDetails .note-error,
.DocumentNameWrapper .DocumentNameContainer .DocumentNameDetails .sync-error {
  font-weight: 400 !important;
}
.DocumentNameWrapper .DocumentNameContainer .DocumentNameDetails .note-error .error-text,
.DocumentNameWrapper .DocumentNameContainer .DocumentNameDetails .sync-error .error-text {
  font-weight: 400 !important;
  font-size: var(--px-14) !important;
}
.appliedfilter-tooltipcontent .motif-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children {
  width: 100%;
}
.react-select__menu {
  border: var(--px-1) solid var(--input--border-color) !important;
  border-top: 0 !important;
  border-radius: 0 0 var(--px-8) var(--px-8) !important;
  margin: 0 !important;
  width: 100% !important;
  background-color: var(--neutrals-00white) !important;
  overflow: hidden;
  margin-top: calc(var(--px-1) * -1) !important;
}
.react-select__menu .react-select__menu-list {
  background-color: transparent;
  max-height: var(--px-240);
}
@media only screen and (min-width: 992px) and (max-width: 1366px) {
  .react-select__menu .react-select__menu-list {
    max-height: var(--px-180);
  }
}
@media only screen and (min-width: 1367px) and (max-width: 1600px) {
  .react-select__menu .react-select__menu-list {
    max-height: var(--px-180);
  }
}
.react-select__menu .react-select__menu-list .react-select__option {
  background-color: transparent;
  font-size: var(--px-14);
  font-weight: 300;
  line-height: var(--px-22);
  padding: var(--px-13) var(--px-12);
  color: var(--neutrals-900);
}
.react-select__menu .react-select__menu-list .react-select__option .selectoption-text {
  display: inline-block;
  width: calc(100% - var(--px-30));
}
.react-select__menu .react-select__menu-list .react-select__option .selectoption-text.disabled {
  color: var(--neutrals-600);
}
.react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-disabled {
  cursor: not-allowed !important;
  color: var(--neutrals-600) !important;
}
.react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-disabled:hover {
  cursor: not-allowed !important;
}
.react-select__menu .react-select__menu-list .react-select__option:hover {
  cursor: pointer !important;
  background-color: var(--neutrals-200);
}
.react-select__menu .react-select__menu-list .react-select__option.react-select__option--is-selected {
  background-color: var(--neutrals-200);
}
.react-select__menu .StyledAddDescriptionLabel {
  border-radius: 0 0 var(--px-8) var(--px-8);
}
body[motif-theme='dark'] .StyledFrameToggle .drawer-opener {
  width: var(--px-40) !important;
  background: #3a3a4a;
}
body[motif-theme='dark'] .StyledFrameToggle .drawer-opener .open-drawer {
  background: #3a3a4a;
}
body[motif-theme='dark'] .StyledFrameToggle .drawer-opener .open-drawer svg {
  fill: #fff;
}
body[motif-theme='dark'] .StyledFrameToggle .drawer-opener .open-drawer:hover {
  background: #f9f9fa;
}
body[motif-theme='dark'] .StyledFrameToggle .drawer-opener .open-drawer:hover svg {
  color: #2e2e38;
  fill: #2e2e38;
}
body[motif-theme='dark'] .customScrollbar::-webkit-scrollbar-track {
  background: #23232f !important;
}
body[motif-theme='dark'] .customScrollbar::-webkit-scrollbar-thumb {
  background: #3a3a4a !important;
}
body[motif-theme='dark'] .customScrollbar::-webkit-scrollbar-thumb:hover {
  background: #747480 !important;
}
body[motif-theme='dark'] .assignments-count-wrap,
body[motif-theme='dark'] .sign-off-cards {
  background: #2e2e3c;
}
body[motif-theme='dark'] .sdmChart .highcharts-series-group .highcharts-series .highcharts-color-0 {
  fill: #ff9831;
}
body[motif-theme='dark'] .sdmChart .highcharts-legend .highcharts-series-0 rect {
  fill: #ff9831;
}
body[motif-theme='dark'] .k-window .k-window-titlebar.k-dialog-titlebar {
  background: #fff;
  color: #2e2e38;
}
body[motif-theme='dark'] .k-window .k-window-content .FooterSection {
  border-top-color: #3a3a4a;
}
body[motif-theme='dark'] .addreq-modal.k-window .k-window-titlebar.k-dialog-titlebar {
  background: #3a3a4a;
  color: #fff;
}
body[motif-theme='dark'] .addreq-modal.k-window .k-window-titlebar .k-window-title {
  font-size: var(--px-17);
  font-weight: bold;
}
body[motif-theme='dark'] .addreq-modal.k-window .k-window-content {
  background: #23232f;
  color: #fff;
}
body[motif-theme='dark'] .addreq-modal.k-window .k-window-content .FooterSection {
  border-top-color: #3a3a4a;
}
body[motif-theme='dark'] .keyBtn svg path {
  fill: #ffffff;
}
body[motif-theme='dark'] .document-opnened-docname .DocumentNameDetails .DocumentName .last-modified,
body[motif-theme='dark'] .document-opnened-docname .DocumentNameDetails .DocumentName .currently-modified {
  color: #f6f6fa !important;
}
body[motif-theme='dark'] .document-opnened-docname .documentName-icons svg {
  fill: #fff !important;
}
body[motif-theme='dark'] .color-dropdown .react-select__control {
  background-color: #2e2e3c !important;
}
body[motif-theme='dark'] .metadataTooltipDataArea:hover {
  background-color: #3a3a4a;
}
body[motif-theme='dark'] .bulkSeeTaskBackground {
  background: #2e2e3c;
}
body[motif-theme='dark'] .bulkSeeTaskBackground .horizontalLineForSeeTask {
  border-bottom: var(--px-1) solid #3a3a4a;
}
body[motif-theme='dark'] .offlineprep,
body[motif-theme='dark'] .offline {
  border-color: #42c9c2;
}
body[motif-theme='dark'] .task-left-panel h3 a {
  color: #f6f6fa;
}
body[motif-theme='dark'] svg.task-Complete path:last-child {
  stroke: #57e188;
}
body[motif-theme='dark'] svg.task-Complete path:nth-child(3),
body[motif-theme='dark'] svg.task-Progress path:nth-child(3),
body[motif-theme='dark'] svg.task-Review path:nth-child(3) {
  stroke: #57e188;
}
body[motif-theme='dark'] svg.gray {
  fill: #747480;
}
body[motif-theme='dark'] svg.red {
  fill: #f95d54;
}
body[motif-theme='dark'] svg.blue {
  fill: #4ebeeb;
}
body[motif-theme='dark'] svg.teal {
  fill: #42c9c2;
}
body[motif-theme='dark'] input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 var(--px-1000) #1a1a24 inset;
  -webkit-text-fill-color: #fff;
}
body[motif-theme='dark'] .cleared .reviewNote-details span.Medium,
body[motif-theme='dark'] .closed .reviewNote-details span.Medium,
body[motif-theme='dark'] .cleared .reviewNote-item span.Medium,
body[motif-theme='dark'] .closed .reviewNote-item span.Medium,
body[motif-theme='dark'] .cleared .reviewNote-details span.Low,
body[motif-theme='dark'] .closed .reviewNote-details span.Low,
body[motif-theme='dark'] .cleared .reviewNote-item span.Low,
body[motif-theme='dark'] .closed .reviewNote-item span.Low,
body[motif-theme='dark'] .cleared .reviewNote-details span.Critical,
body[motif-theme='dark'] .closed .reviewNote-details span.Critical,
body[motif-theme='dark'] .cleared .reviewNote-item span.Critical,
body[motif-theme='dark'] .closed .reviewNote-item span.Critical,
body[motif-theme='dark'] .cleared .reviewNote-details span.High,
body[motif-theme='dark'] .closed .reviewNote-details span.High,
body[motif-theme='dark'] .cleared .reviewNote-item span.High,
body[motif-theme='dark'] .closed .reviewNote-item span.High,
body[motif-theme='dark'] .cleared .reviewNote-details .left-border,
body[motif-theme='dark'] .closed .reviewNote-details .left-border,
body[motif-theme='dark'] .cleared .reviewNote-item .left-border,
body[motif-theme='dark'] .closed .reviewNote-item .left-border {
  color: #1a1a24 !important;
  border-color: #1a1a24 !important;
}
body[motif-theme='dark'] .error-message-wrapper {
  color: #f6f6fa;
}
body[motif-theme='dark'] .error-message-wrapper .error-message {
  color: #f6f6fa;
  background: black;
}
body[motif-theme='dark'] .info-icon {
  background-color: #c4c4cd;
}
body[motif-theme='dark'] .errorIcon {
  background-color: #b9251c;
}
body[motif-theme='dark'] .success-icon {
  background-color: #2c973e;
}
body[motif-theme='dark'] .warning-icon {
  background-color: #ff9831;
}
body[motif-theme='dark'] .note-error {
  color: #f95d54;
}
body[motif-theme='dark'] .note-error .k-editor-widget.k-editor {
  border-color: #f95d54;
}
body[motif-theme='dark'] .note-error .note-error-icon {
  fill: #f95d54 !important;
}
body[motif-theme='dark'] .note-error .note-error-message .error-text {
  color: #f95d54;
}
body[motif-theme='dark'] .task-layout-wrapper,
body[motif-theme='dark'] .notes-layout-wrapper {
  background: linear-gradient(to right, #23232f 50%, #1a1a24 50%);
}
body[motif-theme='dark'] .WCGWWrapper .count,
body[motif-theme='dark'] .RiskWrapper .count,
body[motif-theme='dark'] .SEM-body .count,
body[motif-theme='dark'] .ValidationsWrapper .count,
body[motif-theme='dark'] .risk-category-header .count,
body[motif-theme='dark'] .accountTypes .count {
  color: #2e2e38;
  border-color: #f6f6fa;
}
body[motif-theme='dark'] .task-in-details .BuildstepContainer .accountTypes .count {
  color: #fff;
}
body[motif-theme='dark'] hr {
  border-top: solid var(--px-1) #2e2e38;
}
body[motif-theme='dark'] .document-list-pagination input[type='text'] {
  background-color: transparent;
  color: #fff !important;
}
body[motif-theme='dark'] .DocumentListFileUploadWrapper .StyledFileUpload button.btn-default {
  background: #1a1a24;
  color: #fff;
}
body[motif-theme='dark'] .motif-modal-overlay .motif-modal-body .DocumentNameContainer .DocumentNameDetails .DocumentName {
  color: #fff;
}
body[motif-theme='dark'] .motif-modal-overlay .motif-modal-body .edit-note-wrapper .react-select--is-disabled .react-select__control {
  border-bottom: 1px solid #c4c4cd;
}
body[motif-theme='dark'] .motif-modal-overlay .motif-modal-body .review-note-category .reply-input-wrapper .reply-icon {
  fill: #fff;
  opacity: 1;
}
body[motif-theme='dark'] .motif-modal-overlay .motif-modal-body .review-note-category .reply-container .reply {
  background-color: #2e2e38;
}
body[motif-theme='dark'] .motif-modal-overlay .motif-modal-body .review-note-category .reply-container .reply .reply-controls svg {
  fill: #fff;
  opacity: 1;
}
body[motif-theme='dark'] .react-select-container .react-select__menu .react-select__menu-list::-webkit-scrollbar {
  width: var(--px-6);
}
body[motif-theme='dark'] .react-select-container .react-select__menu .react-select__menu-list::-webkit-scrollbar-track {
  background: #23232f;
  width: var(--px-6);
}
body[motif-theme='dark'] .react-select-container .react-select__menu .react-select__menu-list::-webkit-scrollbar-thumb {
  background: #3a3a4a;
  width: var(--px-6);
  cursor: pointer;
}
body[motif-theme='dark'] .react-select-container .react-select__menu .react-select__menu-list::-webkit-scrollbar-thumb:hover {
  background: #747480;
}
body[motif-theme='dark'] .selectBoxlabelTopPos .show svg.medium {
  fill: #f95d54;
}
body[motif-theme='dark'] .selectBoxlabelTopPos .show .error-text {
  color: #f95d54;
}
body[motif-theme='dark'] .create-dropdown .motif-dropdown-item.disabled,
body[motif-theme='dark'] .relate-dropdown .motif-dropdown-item.disabled {
  background-color: #23232f;
}
body[motif-theme='dark'] .add-document-search-bar .addDocument-pager .addDocument-paging {
  background-color: #23232f;
}
body[motif-theme='dark'] .add-document-search-bar .addDocument-pager .addDocument-paging .Dropdown-control {
  background-color: #23232f;
}
body[motif-theme='dark'] .add-document-search-bar .addDocument-pager .addDocument-paging input[type='text'] {
  background-color: #23232f;
}
body[motif-theme='dark'] .tasks-tooltip svg.large.progress-circle.in-progress path:last-child {
  stroke: #34c768;
}
body[motif-theme='dark'] .tasks-tooltip svg.large.progress-circle.in-review path:last-child {
  stroke: #34c768;
}
body[motif-theme='dark'] .tasks-tooltip svg.large.progress-circle.complete path {
  stroke: #57e188;
}
body[motif-theme='dark'] .notes-tooltip .motif-tooltip-inner .status-text.medium {
  color: #ff810a;
}
body[motif-theme='dark'] .notes-tooltip .motif-tooltip-inner .status-text.high {
  color: #ffb46a;
}
body[motif-theme='dark'] .notes-tooltip .motif-tooltip-inner .status-text.critical {
  color: #ff9a91;
}
body[motif-theme='dark'] .ep-tooltip .status-count,
body[motif-theme='dark'] .eqr-tooltip .status-count,
body[motif-theme='dark'] .complete-assng-tooltip .status-count {
  color: #c981b2;
}
body[motif-theme='dark'] .complete-assng-tooltip .motif-tooltip-inner .status-text {
  color: #c4c4cd;
}
body[motif-theme='dark'] .complete-assng-tooltip .motif-tooltip-inner .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text.preparer {
  color: #35a4e8;
}
body[motif-theme='dark'] .complete-assng-tooltip .motif-tooltip-inner .complete-assng-tooltip-inner .count-text-wrap .percent-label-wrap .percent-text.reviewer {
  color: #35a4e8;
}
body[motif-theme='dark'] .relatedtasks-modal .relatedtasks-listcontainer ul li.saving-relatefile {
  background: #2e2e38 !important;
  opacity: 0.7;
}
body[motif-theme='dark'] .assertions-tooltip .motif-tooltip-content-children {
  width: var(--px-250);
}
body[motif-theme='dark'] .assertions-tooltip .motif-tooltip-content-children .assertion-header {
  color: #fff;
  background: #2e2e3c;
}
body[motif-theme='dark'] .assertions-tooltip .motif-tooltip-content-children .craBadgesWrapper {
  border-top: solid 1px #747480;
  background: #2e2e3c;
  color: #fff;
}
body[motif-theme='dark'] .calendar-tooltip .motif-tooltip-inner .cc-tooltip-date,
body[motif-theme='dark'] .schedule-request-tooltip .motif-tooltip-inner .cc-tooltip-date,
body[motif-theme='dark'] .calendar-tooltip .motif-tooltip-inner .tooltip-text,
body[motif-theme='dark'] .schedule-request-tooltip .motif-tooltip-inner .tooltip-text {
  color: #fff;
}
body[motif-theme='dark'] .tree-item-list-level2 .tree-list-item.children-open:last-child:after {
  background: #23232f !important;
}
body[motif-theme='dark'] .addrequest-description span.k-colorpicker,
body[motif-theme='dark'] .addrequest-description .k-picker-wrap.k-state-active,
body[motif-theme='dark'] .addrequest-description .k-picker-wrap,
body[motif-theme='dark'] .requestdetails-info .edit-description span.k-colorpicker,
body[motif-theme='dark'] .requestdetails-info .edit-description .k-picker-wrap.k-state-active,
body[motif-theme='dark'] .requestdetails-info .edit-description .k-picker-wrap {
  background-color: transparent;
}
body[motif-theme='dark'] .addrequest-description table.k-editor .k-content,
body[motif-theme='dark'] .requestdetails-info .edit-description table.k-editor .k-content {
  background-color: #eaeaf2 !important;
}
body[motif-theme='dark'] .add-request .motif-fab:hover svg {
  fill: #1a1a24;
}
body[motif-theme='dark'] .all-types-filter-dropdown,
body[motif-theme='dark'] .eng-filter-dropdown {
  background-color: #3a3a4a;
}
body[motif-theme='dark'] .document-opened-header {
  color: #ffffff !important;
}
body[motif-theme='dark'] .DocumentNameWrapper .documentName-icons .StyledDisplayDocumentSignoffRequirements .signoff-requirement-badge {
  color: #fff !important;
  border-color: #fff !important;
}
body[motif-theme='dark'] .document-list-wrap .handOffItem-buttons,
body[motif-theme='dark'] .document-list-wrap .sign-off-section {
  border-left: var(--px-1) solid #747480 !important;
  border-right: var(--px-1) solid #747480 !important;
}
body[motif-theme='dark'] .document-list-wrap .handOffItem-buttons-top,
body[motif-theme='dark'] .document-list-wrap .sign-off-section-top {
  border-top: var(--px-1) solid #747480 !important;
}
body[motif-theme='dark'] .document-list-wrap .handOffItem-buttons-bottom,
body[motif-theme='dark'] .document-list-wrap .sign-off-section-bottom {
  border-bottom: var(--px-1) solid #747480 !important;
}
body[motif-theme='dark'] .autoassign-banner svg {
  fill: #ff810a;
}
body[motif-theme='dark'] .bulk-requests-tasks-popup .taskList .taskListBody > section:hover {
  background-color: #3a3a4a !important;
}
body[motif-theme='dark'] .bulk-requests-tasks-popup .taskList .taskListBody > section .taskBadgeAndName .TaskNames {
  color: #fff !important;
}
body[motif-theme='dark'] .bulk-requests-tasks-popup .taskList .taskListBody > section .taskBadgeAndName .TaskNames:hover {
  color: #fff !important;
}
body[motif-theme='dark'] .bulk-requests-tasks-popup.Dataloading .taskList {
  background: #2e2e380d;
}
body[motif-theme='dark'] .DocumentNameWrapper .DocumentNameContainer .DocumentSVG svg[name='client-analytic'] path:nth-of-type(1) {
  fill: #fff;
}
body[motif-theme='dark'] .DocumentNameWrapper .DocumentNameContainer .DocumentSVG svg[name='client-analytic'] path:nth-of-type(2) {
  fill: #7883a4;
}
body[motif-theme='dark'] .DocumentNameWrapper .DocumentNameContainer .DocumentSVG svg[name='client-analytic'] path:nth-of-type(3) {
  fill: #2e2e3c;
}
body[motif-theme='dark'] .helix-projects-wrapper {
  background: #1a1a24;
}
body[motif-theme='dark'] .dashboard-main-wrap.RegularLayoutView {
  background: linear-gradient(119deg, #1a1a24 19.79%, #33333e 99.54%);
}
body[motif-theme='dark'] .map-wrapper .design-procedure-wrapper .item-details-wrapper,
body[motif-theme='dark'] .map-wrapper .design-procedure-wrapper .default-template-wrapper {
  background: #1a1a24;
}
.motif-dropdown-menu-portal.cogmenu-btn {
  min-width: var(--px-150) !important;
  width: var(--px-150) !important;
}
.create-dropdown,
.relate-dropdown {
  width: var(--px-165);
}
.create-dropdown .motif-dropdown-item,
.relate-dropdown .motif-dropdown-item {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}
.add-task-modal .wizardContainer {
  height: 100%;
}
.add-task-modal .wizardContainer .componentBodyWrapper {
  flex: 1;
}
.add-task-modal .wizardContainer .componentBodyWrapper .relate-objects-wrap {
  padding: var(--px-10) 0;
}
.add-task-modal .wizardContainer .componentBodyWrapper .relate-objects-wrap .styled-accounts {
  height: calc(100vh - var(--px-550));
}
.add-task-modal .wizardContainer .componentBodyWrapper .relate-objects-wrap .StyledScots {
  height: calc(100vh - var(--px-500)) !important;
}
.add-task-modal .wizardContainer .componentBodyWrapper .relate-objects-wrap .styled-itprocesses {
  height: calc(100vh - var(--px-500));
}
.add-task-modal .wizardContainer .componentBodyWrapper:has(.add-new-task-details),
.add-task-modal .wizardContainer .componentBodyWrapper:has(.add-new-task-create-assignment) {
  overflow-y: auto;
}
.ellipsis-one-line {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pjctsmenu-dropdowncontainer.motif-dropdown-menu-portal {
  z-index: 899;
  min-width: auto !important;
  width: auto !important;
}
.pjctsmenu-dropdowncontainer.motif-dropdown-menu-portal .motif-dropdown-item .motif-icon {
  margin-top: calc(var(--px-4) * -1);
  margin-right: var(--px-5);
}
.primarypjct-modal .primarypjct-msg {
  padding: var(--px-30) var(--px-20) var(--px-40) var(--px-20);
  font-size: var(--px-14);
  font-weight: 300;
}
svg .highcharts-background {
  fill: transparent;
}
.motif-progress-loader-container {
  z-index: 2;
}
.motif-dropdown-menu-portal.custom-rnh-dropdown {
  min-width: var(--px-65);
  max-width: var(--px-120);
  width: auto;
}
.calendar-tooltip .motif-tooltip {
  max-width: var(--px-440);
}
.calendar-tooltip .motif-tooltip-wrapper {
  margin-top: 0 !important;
}
.calendar-tooltip .motif-tooltip-content-children {
  margin-right: 0 !important;
  width: 100%;
}
.calendar-tooltip .tooltip-inner-indicator {
  display: flex;
  align-items: baseline;
  margin-top: var(--px-10);
}
.calendar-tooltip .tooltip-inner-indicator .tooltip-text {
  width: 100%;
}
.calendar-tooltip .cc-tooltip-date {
  color: #747480;
  font-weight: 300;
}
.calendar-tooltip .tooltip-text {
  font-size: var(--px-12);
  color: #2e2e38;
  margin-left: var(--px-5);
}
.validation-tooltip .motif-tooltip {
  width: var(--px-220);
  z-index: 9999;
}
.motif-dropdown-menu-portal.document-name-cog-menu-popup-container {
  width: var(--px-150);
}
.motif-modal.motif-modal-content.custom-message.message {
  width: 35% !important;
  max-width: 35% !important;
}
.motif-modal.motif-modal-content.motif-modal-size-md.ip-filter-modal {
  width: 40%;
  height: auto;
}
.motif-chip-disabled.ti-chip {
  cursor: default !important;
}
.tooltip-documents .motif-tooltip,
.tooltip-assigned-to .motif-tooltip {
  z-index: 0;
}
.filter-dropdown {
  width: var(--px-250);
  padding: var(--px-10) var(--px-20);
  height: var(--px-340);
  overflow: auto;
}
.filter-dropdown .showMenuPopOver {
  width: auto;
}
.filter-dropdown .showMenuPopOver h5 {
  font-size: var(--px-14);
  font-weight: bold;
}
.filter-dropdown .motif-dropdown-item li {
  width: 100%;
  margin: 0;
  display: inline-block;
}
.filter-dropdown .motif-dropdown-item li.title {
  padding: 0;
  cursor: default;
}
.filter-dropdown .motif-dropdown-item li.title span {
  padding: 0;
  margin: var(--px-10) 0;
  font-size: var(--px-14);
  font-weight: bold;
}
.filter-dropdown {
  width: var(--px-250);
  padding: var(--px-5) var(--px-20);
  height: var(--px-220);
  overflow: auto;
}
.filter-dropdown ul.parent {
  cursor: default;
}
.filter-dropdown ul.parent:focus {
  outline: none;
}
.filter-dropdown ul.parent:hover {
  background: none;
}
.filter-dropdown ul.parent li {
  width: 100%;
  margin: 0;
  padding: var(--px-5) 0;
  display: inline-block;
}
.filter-dropdown ul.parent li.title {
  padding: 0;
  cursor: default;
}
.filter-dropdown ul.parent li.title span {
  padding: 0;
  margin: var(--px-10) 0;
  font-size: var(--px-14);
  font-weight: bold;
}
.scope-dropdown {
  width: var(--px-300);
  right: calc(var(--px-19) * -1) !important;
}
.scope-dropdown .searchControl {
  margin: var(--px-15) var(--px-15) var(--px-10) var(--px-15);
}
.scope-dropdown .scope-details-table {
  padding: 0 var(--px-15) var(--px-15);
}
.scope-dropdown .scope-details-table {
  max-height: var(--px-350);
}
.scope-dropdown .scope-details-table > section {
  display: flex;
  flex-direction: column;
}
.scope-dropdown .motif-typeahead .motif-typeahead-close-button {
  line-height: var(--px-20);
}
.scope-dropdown .showMenuPopOver h5 {
  font-size: var(--px-14);
  font-weight: bold;
}
.scope-dropdown .showMenuPopOver .TreeViewListSearchComponent {
  padding: var(--px-15);
}
.scope-dropdown .motif-dropdown-item li {
  width: 100%;
  margin: 0;
  display: inline-block;
}
.scope-dropdown .motif-dropdown-item li.title {
  padding: 0;
  cursor: default;
}
.scope-dropdown .motif-dropdown-item li.title span {
  padding: 0;
  margin: var(--px-10) 0;
  font-size: var(--px-14);
  font-weight: bold;
}
.scope-dropdown .pop-over-sub-heading:first-child h5 {
  margin-top: 0;
}
.scope-dropdown .pop-over-sub-heading h5 {
  margin-bottom: 0;
  width: 100%;
}
.scope-dropdown .pop-over-sub-heading li {
  padding: var(--px-5) 0 var(--px-10) 0;
}
.sdm-creat-req-tooltip .motif-tooltip,
.notification-tooltip-placeholer .motif-tooltip {
  width: var(--px-200);
}
.assignment-count .dropdown-items-wrap {
  margin: 0 0 var(--px-4) 0 !important;
}
.assignment-count .dropdown-items-wrap .cursorDefault {
  pointer-events: none !important;
}
.assignment-count .assign-rev-count {
  margin: 0 0 0 var(--px-5) !important;
}
.notification-tooltip-placeholer .motif-tooltip {
  margin: 0;
  left: 0 !important;
}
.quick-filter-wrap {
  width: var(--px-250);
}
.deletecontrol {
  height: calc(100% - var(--px-300)) !important;
}
.deletecontrol .deleteitem {
  height: 100%;
}
.deletecontrol .deleteitem .deletewrapper {
  height: calc(100% - var(--px-50));
  padding: 0 var(--px-18) 0 var(--px-18);
}
.deletecontrol .deleteitem .deletewrapper li {
  margin-bottom: var(--px-16);
  font-size: var(--px-14);
  list-style-type: none;
}
.deletecontrol .deleteitem h4 {
  font-size: var(--px-14);
  margin: 0;
  padding: var(--px-24) var(--px-18);
}
.timephase-modal {
  height: calc(100vh - var(--px-180)) !important;
}
@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .timephase-modal {
    height: calc(100vh - var(--px-100)) !important;
  }
}
@media screen and (min-width: 992px) and (max-width: 1366px) {
  .timephase-modal {
    height: calc(100vh - var(--px-60)) !important;
  }
}
.add-assignment-modal .motif-modal-footer .motif-button,
.update-dueDate-modal .motif-modal-footer .motif-button,
.delete-assignment-modal .motif-modal-footer .motif-button,
.delete-assignment-modal-timephase .motif-modal-footer .motif-button,
.add-event-modal .motif-modal-footer .motif-button,
.add-timephase-modal .motif-modal-footer .motif-button,
.task-auto-assign-modal .motif-modal-footer .motif-button {
  margin: 0 var(--px-10) 0 0 !important;
}
.addTeamMemberModal {
  height: calc(100vh - var(--px-360)) !important;
}
@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .addTeamMemberModal {
    height: calc(100vh - var(--px-240)) !important;
  }
}
@media screen and (min-width: 992px) and (max-width: 1366px) {
  .addTeamMemberModal {
    height: calc(100vh - var(--px-240)) !important;
  }
}
.QSIFeedbackButton {
  border: 0 !important;
  z-index: 998 !important;
  height: calc(100% - var(--px-70)) !important;
  top: var(--px-65);
}
.QSIFeedbackButton button {
  width: auto !important;
}
.QSIFeedbackButton button > div {
  border-top-right-radius: var(--px-5) !important;
  border-bottom-right-radius: var(--px-5) !important;
  padding: var(--px-15) var(--px-8) !important;
}
.QSIFeedbackButton button div {
  font-size: var(--px-12);
  font-weight: 400;
}
.motif-dropdown-menu-portal.motifSignOffTooltip {
  min-width: var(--px-450) !important;
}
.assigngrp-tooltip .motif-tooltip-content-children {
  width: var(--px-280);
}
.hand-off-modal .motif-loader-container {
  z-index: 2 !important;
}
.registerinformation .motif-tooltip .motif-tooltip-inner {
  width: var(--px-380);
}
.task-assignments-drowdown {
  width: var(--px-700);
}
.assignments-dropdown {
  top: var(--px-4);
}
.assignments-dropdown .motif-dropdown-item {
  width: calc(100% + var(--px-2)) !important;
}
.timephase-dropdown .motif-dropdown-item {
  width: calc(100% + var(--px-2)) !important;
}
.assignment-display .dropdownValidationName svg {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.assignment-display .motif-tooltip {
  width: var(--px-400);
}
.assignment-display .motif-tooltip-content-children {
  width: 100%;
  margin: 0 !important;
}
.assignment-display .motif-tooltip-content-children > section {
  width: 100%;
}
.assignment-display .dropdownValidationName .ellipses {
  width: var(--px-160);
}
.add-tag-modal {
  height: calc(100vh - var(--px-420)) !important;
  min-height: calc(100vh - var(--px-360)) !important;
}
@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .add-tag-modal {
    height: calc(100vh - var(--px-275)) !important;
  }
}
@media screen and (min-width: 992px) and (max-width: 1366px) {
  .add-tag-modal {
    height: calc(100vh - var(--px-245)) !important;
  }
}
.right-motif-card .motif-toast-fixed-top .motif-toast-text-container {
  line-height: var(--px-16) !important;
  padding: var(--px-11) 0 !important;
}
@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .right-motif-card .motif-toast-fixed-top .motif-toast-text-container {
    padding: var(--px-12) 0 !important;
  }
}
@media screen and (min-width: 992px) and (max-width: 1366px) {
  .right-motif-card .motif-toast-fixed-top .motif-toast-text-container {
    padding: var(--px-10) 0 !important;
  }
}
.right-motif-card .motif-typeahead .motif-typeahead-close-button svg {
  height: 100% !important;
  width: 100% !important;
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner {
  width: var(--px-300);
  height: var(--px-150);
  overflow-x: hidden;
  overflow-y: auto;
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner::-webkit-scrollbar {
  width: var(--px-6);
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner::-webkit-scrollbar-track {
  background: #e7e7ea;
  width: var(--px-6);
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner::-webkit-scrollbar-thumb {
  background: #c4c4cd;
  width: var(--px-6);
  cursor: pointer;
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner::-webkit-scrollbar-thumb:hover {
  background: #747480;
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children {
  width: calc(100% - var(--px-28));
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .eyparticipants-header,
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .externalparticipants-header {
  font-size: var(--px-12);
  font-weight: 700;
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .eyparticipants-header .eyparticipants-count,
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .externalparticipants-header .eyparticipants-count,
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .eyparticipants-header .externalparticipants-count,
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .externalparticipants-header .externalparticipants-count {
  margin-left: var(--px-3);
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .eyparticipants-list,
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .externalparticipants-list {
  list-style: none;
  padding-left: 0;
  margin-top: var(--px-5);
  margin-bottom: 0;
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .eyparticipants-list li,
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .externalparticipants-list li {
  margin-bottom: var(--px-5);
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .eyparticipants-list li .eyparticipants-name,
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .externalparticipants-list li .eyparticipants-name,
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .eyparticipants-list li .externalparticipants-name,
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .externalparticipants-list li .externalparticipants-name {
  width: 100%;
  font-size: var(--px-12);
  font-weight: 300;
  font-family: ey_interstate;
}
.prioritymembers-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children .eyparticipants-list {
  margin-bottom: var(--px-15);
}
.entities-modal,
.CreateEditAccountModalContainer,
.CreateEditControlModalContainer,
.CreateEditEstimateModalContainer,
.CreateEditITApplicationModalContainer,
.CreateEditITControlModalContainer,
.CreateEditITProcessModalContainer,
.CreateEditITRiskModalContainer,
.CreateEditMestModalContainer,
.CreateEditRiskModalContainer,
.CreateEditScotModalContainer,
.CreateEditTaskSectionModalContainer,
.CreateEditWCGWModalContainer {
  max-height: calc(100vh - var(--px-40)) !important;
  min-height: calc(100vh - var(--px-40)) !important;
}
.CreateEditITApplicationModalBody .modal-error-wrapper .motif-toast {
  position: absolute;
  z-index: 5;
}
.addTeamMemberModal .motif-modal-body {
  min-height: var(--px-450) !important;
}
.bulk-handOff-modal .motif-modal-body {
  min-height: var(--px-450) !important;
}
.bulk-markComplete-modal .motif-modal-body {
  min-height: var(--px-450) !important;
}
.task-delete-modal .motif-modal-body {
  max-height: var(--px-450) !important;
}
.task-desc-kendo-modal .k-window-content:last-child {
  padding-bottom: 0;
}
.MoreMenuContainer .motif-menu-overlay {
  pointer-events: none;
  z-index: 9999999999 !important;
}
.MoreMenuContainer .motif-menu-overlay.motif-menu-overlay-open .motif-menu {
  display: block;
}
.MoreMenuContainer .motif-menu-overlay .motif-menu {
  display: none;
}
.tooltip-class.motif-tooltip-content {
  width: 32% !important;
}
/* Ellipses Tooltip CSS Starts */
.tooltip {
  position: absolute;
  display: block;
  font-style: normal;
  font-weight: 400;
  line-height: var(--px-20);
  line-break: auto;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  filter: alpha(opacity=0);
  z-index: 99999999999 !important;
}
.tooltip.tooltipCustomWidth {
  width: auto;
  max-width: 20%;
}
.tooltip .tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.tooltip.fade {
  transition: opacity 0.15s linear;
}
.tooltip.in {
  filter: alpha(opacity=100);
  opacity: 1;
}
.tooltip.in.top .tooltip-arrow {
  border-top-color: var(--neutrals-00white) !important;
}
.tooltip.in.bottom .tooltip-arrow {
  border-bottom-color: var(--neutrals-00white) !important;
}
.tooltip.top {
  padding: var(--px-10) 0;
  margin-top: calc(var(--px-3) * -1);
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  border-width: var(--px-10) var(--px-10) 0;
  border-top-color: var(--neutrals-00white) !important;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
}
.tooltip.bottom {
  padding: var(--px-10) 0;
  margin-top: var(--px-3);
}
.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: calc(var(--px-5) * -1);
  border-width: 0 var(--px-10) var(--px-10);
  border-bottom-color: var(--neutrals-00white) !important;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
}
.tooltip .tooltip-inner {
  padding: var(--px-6);
  font-size: var(--px-14);
  color: var(--neutrals-1000) !important;
  background-color: var(--neutrals-00white) !important;
  box-shadow: 0 0 var(--px-20) 0 rgba(0, 0, 0, 0.3);
  text-align: left;
  word-wrap: break-word;
  border-radius: var(--px-4);
  max-width: var(--px-200);
}
.assignment-task-tooltip {
  border-radius: var(--px-12);
}
.assignment-task-tooltip .motif-tooltip-wrapper .motif-tooltip-inner {
  background-color: var(--neutrals-00white);
  padding: 0;
  border-radius: var(--px-12);
}
.assignment-task-tooltip .motif-tooltip-wrapper .motif-tooltip-inner .motif-tooltip-content-children {
  margin: 0;
}
/* Ellipses Tooltip CSS Ends */
.motif-modal-header .motif-modal--header-icon-button:disabled svg path {
  fill: var(--neutrals-500) !important;
}
.motif-h6-default-regular {
  font-size: var(--px-16) !important;
  font-weight: 400 !important;
  line-height: var(--px-24) !important;
}
.motif-h4-default-regular {
  font-size: var(--px-20) !important;
  font-weight: 400 !important;
  line-height: var(--px-30) !important;
}
.motif-label4-default-regular {
  font-size: var(--px-12) !important;
  font-weight: 400 !important;
  line-height: var(--px-18) !important;
}
.contentUpdate-update-selected .motif-modal-body,
.warning-message-modal .motif-modal-body,
.addCanvasForm-modal .motif-modal-body {
  padding: var(--px-24) !important;
}
.delete-package-list-modal .motif-modal-body,
.package-list-modal .motif-modal-body,
.import-modal .motif-modal-body,
.manageTeam-modal .motif-modal-body {
  padding: 0 !important;
}
.contentinfo-icon {
  cursor: pointer;
}
.motif-dropdown-menu .StyledCogDropdownMenuContent {
  height: auto;
  max-height: var(--px-266);
  overflow-y: auto;
}
[motif-theme] .motif-checkbox-disabled .motif-checkbox-input + .motif-checkbox-inner {
  background-color: var(--ui-stroke-disabled) !important;
  border-color: var(--ui-stroke-disabled) !important;
}
[motif-theme] .motif-checkbox-disabled .motif-checkbox-input + .motif-checkbox-inner .motif-checkbox-icon {
  color: var(--ui-background-main);
}
[motif-theme] .motif-checkbox-wrapper-disabled:hover .motif-checkbox-checked .motif-checkbox-inner {
  background-color: var(--ui-stroke-disabled) !important;
  border-color: var(--ui-stroke-disabled) !important;
}
[motif-theme] .motif-checkbox-wrapper-disabled:hover .motif-checkbox-checked .motif-checkbox-inner .motif-checkbox-icon {
  color: var(--ui-background-main);
}
.checkboxLabel-statusLabel {
  cursor: pointer;
}
/* ql-editor CSS - Starts */
.ql-editor li[data-list='bullet'] > .ql-ui:before {
  font-family: auto !important;
}
/* ql-editor CSS - Ends */
.DocumentNameWrapper .DocumentFileName .document-name .coedit-mode .coedit-mode-label {
  max-width: var(--px-450) !important;
}
.container-blur {
  opacity: 0.5;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./components/Main/main.less","webpack://./components/vars.less","webpack://./components/globals.less","webpack://./components/Main/small-loader.less"],"names":[],"mappings":"AAAA;;EAEE;AACF;;;;;gBAKgB;AAChB;;EAEE;AACF,WAAW;AACX,WAAW;ACoEX;EACC,eAAA;ADlED;ACuFA;EACC,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,wBAAA;EACA,yBAAA;EACA,6BAAA;EACA,6BAAA;EACA,uBAAA;EACA,kBAAA;EAEA,2BAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,gCAAA;EACA,yBAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,oBAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,wBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,0EAAA;EACA,yEAAA;EACA,2EAAA;EACA,2EAAA;EACA,qDAAA;EACA,mDAAA;ADvFD;AEtFA;EACC,2BAAA;EACA,4CAAA;AFwFD;AEtFA;EACC,2BAAA;EACA,kBAAA;EACA,4CAAA;AFwFD;AEtFA;EACC,2BAAA;EACA,iBAAA;EACA,4CAAA;AFwFD;AEtFA;EACC,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,4CAAA;AFwFD;AEtFA;EACC,2BAAA;EACA,gBAAA;EACA,4CAAA;AFwFD;AACA,8BAA8B;AE3D9B;EACC,aAAA;EACA,WAAA;EACA,0BAAA;AF6DD;AE5DC;EAAA;IACC,6BAAA;EF+DA;AACF;AE9DC;EAAA;IACC,4BAAA;EFiEA;AACF;AEhEC;EAAA;IACC,4BAAA;EFmEA;AACF;AEhEA;EACC,YAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,sCAAA;EACA,0BAAA;AFkED;AEjEC;EAAA;IACC,6BAAA;EFoEA;AACF;AEnEC;EAAA;IACC,4BAAA;EFsEA;AACF;AErEC;EAAA;IACC,4BAAA;EFwEA;AACF;AEvFA;EAiBE,2BAAA;AFyEF;AACA,gBAAgB;AGtKhB;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sDAAA;EACG,mDAAA;EACK,8CAAA;EACR,gCAAA;EACA,kBAAA;EACA,6BAAA;AHwKJ;AGtKA;EACI;IACI,yBAAA;IACA,gGAAA;EHwKN;EGrKE;IACI,wCAAA;IACA,iFAAA;EHuKN;EGpKE;IAAK,wCAAA;IACD,iFAAA;EHuKN;AACF;AGnKA;EACG;IACK,yBAAA;IACA,gGAAA;EHqKN;EGlKE;IACI,wCAAA;IACA,iFAAA;EHoKN;EGjKE;IAAK,wCAAA;IACD,iFAAA;EHoKN;AACF;AGhKA;EACG;IACK,yBAAA;IACA,gGAAA;EHkKN;EG/JE;IACI,wCAAA;IACA,iFAAA;EHiKN;EG9JE;IAAK,wCAAA;IACD,iFAAA;EHiKN;AACF;AAhNA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFC,sCAAA;EACA,gBAAA;EACA,oBAAA;AAkND;AA/MA;EAEE,yBAAA;AAgNF;AAlNA;EAME,wBAAA;AA+MF;AA3MA;EACC,aAAA;EACA,OAAA;EACA,iBAAA;AA6MD;AA1MA;EACC,4BAAA;EACA,4CAAA;AA4MD;AAzME;EACC,uBAAA;AA2MH;AAtMA;EACC,cAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AAwMD;AArMA;EACC,aAAA;EACA,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;EACA,YAAA;EACA,cAAA;AAuMD;AArMC;EACC,MAAA;EACA,YAAA;AAuMF;AAnMA;;EAEC,iCAAA;AAqMD;AAvMA;;EAKE,yBAAA;AAsMF;AAlMA;EACC,iCAAA;AAoMD;AAjMA;;EAEC,iCAAA;AAmMD;AA5LA;EACC,WAAA;AA8LD;AA3LA;EACC,gBAAA;EACA,wBAAA;AA6LD;AA1LA;EACC,SAAA;EACA,UAAA;AA4LD;AA9LA;EAKE,SAAA;AA4LF;AAxLA;EACC,SAAA;EACA,UAAA;EACA,qBAAA;AA0LD;AA7LA;EAME,SAAA;EACA,qBAAA;AA0LF;AAtLA;EACC,aAAA;AAwLD;AArLA;EACC,QAAA;EACA,SAAA;EACA,yCAAA;EACA,4CAAA;EACA,sCAAA;EACA,0BAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AAuLD;AApLA;EACC,0BAAA;AAsLD;AApLC;EAGG,0BAAA;AAoLJ;AA9KA;EACC,yBAAA;EACA,cAAA;EACA,iBAAA;AAgLD;AA7KA;EACC,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AA+KD;AAxLA;EAYE,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;AA+KF;AA9LA;EAkBG,qBAAA;EACA,cAAA;AA+KH;AA1KA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;AA4KD;AAzKA;EACC,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA2KD;AAxKA;EACC,yBAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA0KD;AAvKA;EACC,YAAA;EACA,mBAAA;EACA,aAAA;AAyKD;AAtKA;EAEE,YAAA;AAuKF;AAnKA;EACC,iBAAA;AAqKD;AAlKA;EACC,uBAAA;AAoKD;AAjKA;EACC,mBAAA;AAmKD;AAjKC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAmKF;AAhKC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAkKF;AA/JC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAiKF;AA9JC;EACC,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AAgKF;AA7JC;;EAEC,yBAAA;AA+JF;AA5JG;;EACC,eAAA;AA+JJ;AA1JC;EACC,yBAAA;AA4JF;AAzJG;EACC,eAAA;AA2JJ;AAtJC;;EAEC,yBAAA;AAwJF;AArJG;;EACC,4BAAA;EACA,mBAAA;AAwJJ;AAnJC;EACC,yBAAA;AAqJF;AAlJC;EACC,UAAA;AAoJF;AAjJC;EACC,aAAA;AAmJF;AAhJC;EACC,aAAA;AAkJF;AA/IC;EACC,aAAA;AAiJF;AA9IC;EACC,aAAA;AAgJF;AA7IC;EACC,aAAA;AA+IF;AA5IC;EACC,aAAA;AA8IF;AA3IC;EACC,aAAA;AA6IF;AA1IC;EACC,eAAA;AA4IF;AAxIA;EACC,aAAA;AA0ID;AAvIA;EAEE,UAAA;AAwIF;AApIA;EACC,oDAAA;AAsID;AAnIA;EACC,WAAA;EACA,2BAAA;AAqID;AAvIA;EAKE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAqIF;AA7IA;EAYE,mBAAA;AAoIF;AAhJA;EAgBE,mBAAA;AAmIF;AA/HA;EACC,kBAAA;EACA,qBAAA;EACA,uBAAA;AAiID;AA9HA;EACC,uBAAA;AAgID;AA7HA;;;;;;;;;;EAUC,yBAAA;EACA,gCAAA;AA+HD;AA5HA;EACC,uEAAA;AA8HD;AA3HA;EACC,UAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;AA6HD;AApIA;EAUE,mBAAA;EACA,6CAAA;EACA,cAAA;EACA,gBAAA;AA6HF;AAzHA;;;;EAIC,uFAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;AA2HD;AAxHA;EACC,qFAAA;EACA,yBAAA;AA0HD;AAvHA;EACC,qFAAA;EACA,yBAAA;AAyHD;AAtHA;EACC,qFAAA;EACA,yBAAA;AAwHD;AArHA;EACC,cAAA;AAuHD;AAxHA;EAIE,iCAAA;AAuHF;AA3HA;EAQE,wBAAA;EACA,mCAAA;AAsHF;AA/HA;EAaE,qBAAA;AAqHF;AAlIA;EAgBG,uBAAA;EACA,cAAA;EACA,mBAAA;AAqHH;AA9GA;EACC,wBAAA;EACA,OAAA;EACA,mBAAA;EACA,2BAAA;EACA,2BAAA;AAgHD;AArHA;EAQE,WAAA;AAgHF;AAxHA;EAYE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,YAAA;AA+GF;AA9HA;EAmBE,aAAA;EACA,OAAA;EACA,wBAAA;AA8GF;AAnIA;EAyBE,aAAA;EACA,OAAA;EACA,gBAAA;AA6GF;AAxIA;EA8BG,sBAAA;AA6GH;AAxGA;EACC,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;AA0GD;AAtGA;EACC,2BAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAwGD;AAnGE;EACC,mBAAA;AAqGH;AAnGG;EAAA;IACC,yBAAA;EAsGF;AACF;AAjGE;EAAA;IACC,0BAAA;EAoGD;AACF;AAlHA;;EAkBG,oBAAA;AAoGH;AAtHA;EAsBG,oBAAA;AAmGH;AAzHA;EA0BK,mCAAA;AAkGL;AA5HA;EAiCE,wBAAA;AA8FF;AA1FA;EACC;IACC,6BAAA;EA4FA;AACF;AAzFA;EACC;IACC,4BAAA;EA2FA;EAxFD;IACC,uBAAA;EA0FA;EAvFD;IACC,YAAA;EAyFA;EAtFD;IACC,yBAAA;EAwFA;EArFD;IACC,yBAAA;EAuFA;EApFD;IACC,YAAA;EAsFA;EAnFD;IAEE,uBAAA;EAoFD;EAtFD;IAME,oCAAA;EAmFD;EAzFD;IAUE,YAAA;EAkFD;EA9ED;IACC,+BAAA;EAgFA;AACF;AA7EA;;;;EAIC,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AA+ED;AA5EA;;EAEC,4DAAA;AA8ED;AA3EA;EACC,uBAAA;AA6ED;AA3EC;EAGG,mCAAA;AA2EJ;AAxDA;EACC,wBAAA;EACA,YAAA;AA0DD;AAvDA;;;;;;EAOE,cAAA;EACA,gCAAA;EACA,yBAAA;EACA,2BAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,8BAAA;AAwDF;AApDA;EAEE,aAAA;EACA,sBAAA;EACA,aAAA;AAqDF;AAzDA;EAOG,YAAA;AAqDH;AAhDA;EAEE,aAAA;AAiDF;AAnDA;EAME,uBAAA;EACA,wBAAA;EACA,qBAAA;AAgDF;AAxDA;EAYE,cAAA;AA+CF;AA3DA;EAgBE,uBAAA;EACA,sBAAA;AA8CF;AA/DA;EAqBE,iBAAA;EACA,gBAAA;AA6CF;AAnEA;EA0BE,mBAAA;EACA,oBAAA;AA4CF;AAvEA;EA+BE,sBAAA;EACA,kCAAA;AA2CF;AAvCA;EAEE,oBAAA;AAwCF;AA1CA;EAKG,wBAAA;AAwCH;AA7CA;EASG,SAAA;EACA,WAAA;AAuCH;AAjDA;EAeI,sCAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,oDAAA;EACA,0CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAqCJ;AA5DA;EA2BI,uBAAA;EACA,qDAAA;AAoCJ;AAhEA;EA+BK,iBAAA;EACA,sBAAA;EACA,aAAA;AAoCL;AArEA;EAoCM,WAAA;EACA,uBAAA;EACA,aAAA;EACA,0BAAA;AAoCN;AA3EA;EA0CO,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAoCP;AAlFA;EAmDM,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;AAkCN;AA/BK;EACC,gBAAA;AAiCN;AA9BK;EACC,sBAAA;AAgCN;AAhGA;EAwEE,oBAAA;AA2BF;AAnGA;EA4EI,uBAAA;AA0BJ;AAtGA;EA+EK,iBAAA;EACA,sBAAA;AA0BL;AAnBA;EACC,aAAA;AAqBD;AAlBA;EACC,aAAA;AAoBD;AAhBC;EAEE,mCAAA;AAiBH;AApBA;EAWK,yBAAA;AAYL;AAvBA;EAcM,yBAAA;AAYN;AA1BA;EAkBM,yBAAA;AAWN;AATM;EACC,2BAAA;AAWP;AAJE;EAEE,oCAAA;AAKJ;AADE;EACC,UAAA;AAGH;AAtCA;EAwCG,oDAAA;EACA,4BAAA;AACH;AA1CA;EA8CE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,kCAAA;EACA,uBAAA;AADF;AAjDA;EAqDG,uBAAA;EACA,WAAA;AADH;AArDA;EAyDI,WAAA;AADJ;AAxDA;EA6DM,uBAAA;AAFN;AA3DA;EAgEO,wBAAA;AAFP;AA9DA;EAmEQ,qBAAA;EACA,eAAA;AAFR;AAlEA;EAuES,cAAA;AAFT;AArEA;EAkFE,qBAAA;EACA,yBAAA;AAVF;AAzEA;EAuFE,2DAAA;EACA,YAAA;AAXF;AA7EA;EA2FG,kBAAA;EACA,gBAAA;EACA,mBAAA;AAXH;AAlFA;EAkGE,oCAAA;AAbF;AArFA;EAqGG,iCAAA;EACA,oBAAA;AAbH;AAzFA;EAyGI,kBAAA;EACA,gBAAA;EACA,mBAAA;AAbJ;AA9FA;EAgHG,kCAAA;AAfH;AAjGA;EAqHE,oCAAA;AAjBF;AApGA;EAwHG,2DAAA;EACA,oBAAA;AAjBH;AAxGA;EA4HI,kBAAA;EACA,gBAAA;EACA,mBAAA;AAjBJ;AA7GA;EAoII,UAAA;AApBJ;AAhHA;EAyIG,kCAAA;EACA,uBAAA;AAtBH;AApHA;EA+IE,yBAAA;AAxBF;AAvHA;EAkJG,2DAAA;EACA,oBAAA;AAxBH;AA3HA;EAsJI,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxBJ;AAhIA;EA8JI,UAAA;AA3BJ;AAnIA;EAmKG,uBAAA;EACA,uBAAA;AA7BH;AAvIA;EA0KG,yBAAA;EACA,UAAA;AAhCH;AAoCG;EACC,gBAAA;AAlCJ;AAiCG;EAIE,oBAAA;AAlCL;AA8BG;EAQE,gCAAA;AAnCL;AA2BG;EAYE,wBAAA;AApCL;AA2CA;EAEE,wBAAA;AA1CF;AAwCA;EAME,aAAA;EACA,mBAAA;AA3CF;AA+CA;EAGG,kBAAA;AA/CH;AA4CA;EASG,WAAA;AAlDH;AAyCA;EAaG,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAnDH;AAwDA;EAEE,oBAAA;AAvDF;AA2DA;EAEE,oBAAA;AA1DF;AAwDA;EAKG,WAAA;AA1DH;AACA,+BAA+B;AA+D/B;EACC,gBAAA;AA7DD;AA+DC;EACC,qBAAA;EACA,uBAAA;AA7DF;AAgEC;EACC,8BAAA;EACA,qBAAA;EACA,uBAAA;AA9DF;AAiEC;EACC,8BAAA;EACA,qBAAA;EACA,0BAAA;EACA,uBAAA;AA/DF;AAkEC;EACC,8BAAA;EACA,uBAAA;AAhEF;AAoEA;EACC,qBAAA;EACA,uBAAA;AAlED;AAqEA;EACC,8BAAA;EACA,qBAAA;EACA,uBAAA;AAnED;AAsEA;EACC,8BAAA;EACA,qBAAA;EACA,0BAAA;EACA,uBAAA;AApED;AAuEA;EACC,8BAAA;EACA,uBAAA;AArED;AACA,6BAA6B;AAyE7B;EAEE,wBAAA;EACA,mBAAA;EACA,uBAAA;AAxEF;AAoEA;EAOG,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;AAxEH;AA6DA;EAeG,cAAA;AAzEH;AA8EA;EAEE,oBAAA;AA7EF;AAkFA;EAGG,WAAA;AAlFH;AAuFA;EAEE,oBAAA;AAtFF;AA0FA;EAEE,uBAAA;EACA,wBAAA;AAzFF;AA6FA;EAEE,oBAAA;AA5FF;AA0FA;EAKG,WAAA;AA5FH;AAiGA;EAGG,aAAA;EACA,uBAAA;EACA,WAAA;AAjGH;AA4FA;EAOI,WAAA;AAhGJ;AAyFA;EASK,WAAA;AA/FL;AAsFA;EAWM,WAAA;AA9FN;AAmFA;EAaO,WAAA;AA7FP;AAgFA;EAkBK,aAAA;AA/FL;AAqGE;EACC,qBAAA;EACA,yBAAA;AAnGH;AAsGE;EAGG,aAAA;EACA,sBAAA;AAtGL;AAkGE;EAOI,iBAAA;EACA,0BAAA;EACA,0BAAA;AAtGN;AA6FE;EAaI,0BAAA;EACA,2BAAA;AAvGN;AAyFE;EAoBI,uBAAA;AA1GN;AAsFE;EAwBI,uBAAA;EACA,0BAAA;EACA,UAAA;AA3GN;AA6GM;EACC,0BAAA;EACA,UAAA;AA3GP;AA6EE;;EAoCI,yBAAA;EACA,0BAAA;AA7GN;AAmHE;EACC,4CAAA;AAjHH;AAgHE;EAQM,oCAAA;AArHR;AAuHQ;EAAA;IACC,oCAAA;EApHP;AACF;AAsHQ;EAAA;IACC,oCAAA;EAnHP;AACF;AAqHQ;EAAA;IACC,oCAAA;EAlHP;AACF;AAoHQ;EAAA;IACC,oCAAA;EAjHP;AACF;AAyHE;EACC,4CAAA;AAvHH;AA4HA;EACC,uBAAA;AA1HD;AA6HA;EAEE,gBAAA;AA5HF;AA0HA;EAME,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mCAAA;AA7HF;AAoHA;EAaE,8CAAA;AA9HF;AAkIA;EAEE,gBAAA;AAjIF;AA+HA;EAME,8CAAA;AAlIF;AAsIA;EACC,wBAAA;AApID;AAuIA;EAEE,oBAAA;AAtIF;AA0IA;EAEE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzIF;AAoIA;EASE,eAAA;AA1IF;AAiIA;EAaE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AA3IF;AAyHA;EAsBE,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,wBAAA;AA5IF;AAgJI;EACC,eAAA;AA9IL;AAmJE;EAEE,eAAA;AAlJJ;AAsJE;EAEE,eAAA;AArJJ;AAmJE;EAME,yBAAA;AAtJJ;AAsGA;EAsDE,yBAAA;AAzJF;AA6JA;EAEE,oBAAA;AA5JF;AA0JA;EAME,WAAA;AA7JF;AAuJA;EAUE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;AA9JF;AAkKA;;EAGE,oBAAA;AAjKF;AAqKA;EAEE,+BAAA;AApKF;AAwKA;EAEE,oBAAA;AAvKF;AAqKA;EAKG,uBAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,aAAA;AAvKH;AA6JA;EAaI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;EACA,uBAAA;AAvKJ;AAqJA;EAuBG,wBAAA;AAzKH;AAkJA;EA2BG,wBAAA;EACA,yBAAA;EACA,uBAAA;AA1KH;AA+KA;EACC,aAAA;EACA,mBAAA;AA7KD;AAgLA;EAEE,oBAAA;AA/KF;AA6KA;EAKG,WAAA;AA/KH;AA0KA;EASG,aAAA;EACA,mBAAA;EACA,0BAAA;AAhLH;AAqKA;EAeG,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAjLH;AA8JA;EAuBG,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;AAlLH;AAoLG;EACC,cAAA;AAlLJ;AAqLG;EACC,cAAA;AAnLJ;AAsLG;EACC,cAAA;AApLJ;AA6IA;EA6CE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;AAvLF;AA2LA;;;EAIE,oBAAA;AA1LF;AAsLA;;;EASG,WAAA;AA1LH;AAiLA;;;EAaG,aAAA;EACA,mBAAA;EACA,0BAAA;AAzLH;AA0KA;;;EAmBG,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;AAxLH;AAgKA;;;EA4BG,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;AAvLH;AAsJA;;;;;;;;;EAwCE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;AAnLF;AAuIA;;;EAgDE,mBAAA;AAlLF;AAkIA;;;EAmDG,UAAA;EACA,sBAAA;EACA,uBAAA;AAhLH;AA2HA;;;EAwDI,WAAA;EACA,aAAA;EACA,mBAAA;AA9KJ;AAoHA;;;EA8DK,iBAAA;EACA,yBAAA;AA7KL;AA+KK;;;EACC,cAAA;AA3KN;AA8KK;;;EACC,cAAA;AA1KN;AAoGA;;;EA2EK,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,UAAA;EACA,qBAAA;AA1KL;AAiLA;EAEE,oBAAA;AAhLF;AA8KA;EAOG,WAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,0BAAA;AAlLH;AAuLA;EAEE,gBAAA;AAtLF;AA0LA;EACC,mCAAA;EACA,kBAAA;EACA,gCAAA;AAxLD;AAqLA;EAME,oCAAA;AAxLF;AA4LA;EACC,iCAAA;AA1LD;AA6LA;EAGG,UAAA;AA7LH;AA0LA;EASG,sBAAA;AAhMH;AAuLA;EAYI,uBAAA;EACA,uBAAA;AAhMJ;AAsMA;EACC,uBAAA;EACA,iBAAA;AApMD;AAwMC;EACC,4BAAA;AAtMF;AAqMC;EAIE,4BAAA;AAtMH;AAkMC;EAQI,sBAAA;EACA,2BAAA;EACA,+CAAA;AAvML;AA6LC;EAaK,yBAAA;EACA,oBAAA;AAvMN;AAyMM;EACC,yBAAA;AAvMP;AAsLC;EAsBK,8BAAA;AAzMN;AAmLC;EA4BG,0BAAA;AA5MJ;AAgLC;EAgCG,gBAAA;AA7MJ;AAiNE;EACC,oBAAA;AA/MH;AA8ME;EAIE,qBAAA;EACA,YAAA;AA/MJ;AA0ME;EAQG,gBAAA;AA/ML;AAsNA;EACC,uBAAA;EACA,+BAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AApND;AA8MA;EASE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AApNF;AAqMA;EAkBG,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;AApNH;AA+LA;EA0BE,WAAA;AAtNF;AA4LA;EA6BG,mBAAA;EACA,aAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;AAtNH;AAqLA;EAoCI,kCAAA;EACA,gBAAA;EACA,oBAAA;AAtNJ;AAgLA;EA+CK,8BAAA;AA5NL;AA6KA;EAmDK,oCAAA;EACA,gDAAA;EACA,yBAAA;AA7NL;AA+NK;EACC,yBAAA;AA7NN;AAqKA;EA4DM,eAAA;AA9NN;AAkKA;EAgEM,kCAAA;EACA,yBAAA;AA/NN;AAiOM;EACC,yBAAA;AA/NP;AA2JA;EA2EI,2BAAA;AAnOJ;AAqOI;EACC,gBAAA;AAnOL;AAqJA;EAmFM,gBAAA;AArON;AAuOM;EACC,eAAA;EACA,0BAAA;AArOP;AA8IA;EA2FO,kCAAA;AAtOP;AA2IA;EAoGE,kBAAA;EACA,kBAAA;EACA,iBAAA;AA5OF;AAsIA;EAyGG,8BAAA;EACA,+BAAA;EACA,aAAA;AA5OH;AAiIA;EA8GI,aAAA;AA5OJ;AAkPA;EAEE,oBAAA;AAjPF;AAqPA;EAII,sBAAA;AAtPJ;AAwPI;EAAA;IACC,oBAAA;EArPH;AACF;AA6OA;EAWK,WAAA;AArPL;AA4PA;EACC,oBAAA;AA1PD;AA4PC;EACC,sBAAA;AA1PF;AA8PA;EAEE,gBAAA;EACA,oBAAA;AA7PF;AAiQA;;EAEC,2BAAA;AA/PD;AA6PA;;EAKE,2BAAA;EACA,kCAAA;AA9PF;AAkQA;EAKK,WAAA;AApQL;AA4QA;EACC,+DAAA;EACA,wBAAA;EACA,qDAAA;EACA,oBAAA;EACA,sBAAA;EACA,oDAAA;EACA,gBAAA;EACA,6CAAA;AA1QD;AAkQA;EAWE,6BAAA;EACA,yBAAA;AA1QF;AA4QE;EAAA;IACC,yBAAA;EAzQD;AACF;AA2QE;EAAA;IACC,yBAAA;EAxQD;AACF;AAoPA;EAuBG,6BAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kCAAA;EACA,0BAAA;AAxQH;AA4OA;EA+BI,qBAAA;EACA,gCAAA;AAxQJ;AA0QI;EACC,0BAAA;AAxQL;AA4QG;EACC,8BAAA;EACA,qCAAA;AA1QJ;AA4QI;EACC,8BAAA;AA1QL;AA8QG;EACC,0BAAA;EACA,qCAAA;AA5QJ;AA+QG;EACC,qCAAA;AA7QJ;AAuNA;EA4DE,0CAAA;AAhRF;AAoRA;EAGG,8BAAA;EACA,mBAAA;AApRH;AAgRA;EAOI,mBAAA;AApRJ;AA6QA;EAUK,UAAA;AApRL;AAuRI;EACC,mBAAA;AArRL;AAoRI;EAIE,cAAA;EACA,aAAA;AArRN;AA8RE;EACC,8BAAA;AA5RH;AA+RE;EACC,8BAAA;AA7RH;AAgSE;EACC,8BAAA;AA9RH;AA0PA;;EA4CE,mBAAA;AAlSF;AAsPA;EAiDG,aAAA;AApSH;AAmPA;EAqDG,aAAA;AArSH;AA2SG;EACC,gBAAA;EACA,cAAA;AAzSJ;AA4OA;EAmEI,yBAAA;AA5SJ;AAmTG;EACC,mBAAA;EACA,WAAA;AAjTJ;AAqOA;EAgFI,uBAAA;EACA,iBAAA;AAlTJ;AAiOA;EAsFG,mBAAA;EACA,WAAA;AApTH;AA6NA;EA0FI,yBAAA;AApTJ;AA0NA;EAkGI,aAAA;AAzTJ;AAuNA;;EA4GK,yBAAA;AA/TL;AAmNA;EAmHI,qBAAA;AAnUJ;AAgNA;EAyHE,oCAAA;AAtUF;AA0UE;EACC,yBAAA;AAxUH;AA0MA;EAmIE,mBAAA;AA1UF;AAuMA;EAsIG,wCAAA;AA1UH;AAoMA;;EA4IE,qBAAA;AA5UF;AAgMA;EAkJI,cAAA;AA/UJ;AAuVI;EACC,eAAA;AArVL;AA8VI;;;EACC,eAAA;AA1VL;AA+VE;EACC,aAAA;AA7VH;AAgWE;EACC,aAAA;AA9VH;AAiWE;EACC,aAAA;AA/VH;AAkWE;EACC,aAAA;AAhWH;AAyKA;EA4LE,sDAAA;EACA,6BAAA;AAlWF;AAqKA;;;;;;;;;;;;;;;;;;;;EAyMI,yBAAA;EACA,gCAAA;AAxVJ;AA8IA;EAgNE,cAAA;AA3VF;AA2IA;EAmNG,cAAA;EACA,iBAAA;AA3VH;AAuIA;EAyNE,yBAAA;AA7VF;AAoIA;EA6NE,yBAAA;AA9VF;AAiIA;EAiOE,yBAAA;AA/VF;AA8HA;EAqOE,yBAAA;AAhWF;AA2HA;EAyOE,cAAA;AAjWF;AAwHA;EA4OG,qBAAA;AAjWH;AAqHA;EAgPG,wBAAA;AAlWH;AAkHA;EAqPI,cAAA;AApWJ;AA+GA;;EA4PE,+DAAA;AAvWF;AA2GA;;;;;;EAsRG,cAAA;EACA,qBAAA;AAzXH;AAkGA;EA+RK,WAAA;AA9XL;AA+FA;EAsSE,qCAAA;AAlYF;AA4FA;EA2SG,6BAAA;EACA,sBAAA;AApYH;AAwFA;EAmTI,mBAAA;EACA,WAAA;AAxYJ;AAoFA;EA8TM,WAAA;AA/YN;AAiFA;EAsUM,gCAAA;AApZN;AA8EA;EA8UM,UAAA;EACA,UAAA;AAzZN;AA0EA;EAqVM,yBAAA;AA5ZN;AAuEA;EAyVQ,UAAA;EACA,UAAA;AA7ZR;AAyaI;EACC,kBAAA;AAvaL;AA0aI;EACC,mBAAA;EACA,kBAAA;AAxaL;AA2aI;EACC,mBAAA;EACA,kBAAA;EACA,eAAA;AAzaL;AA4aI;EACC,mBAAA;AA1aL;AAoDA;EA+XI,aAAA;AAhbJ;AAiDA;EAmYI,cAAA;AAjbJ;AAybG;;EACC,yBAAA;AAtbJ;AA0CA;EAoZI,yBAAA;AA3bJ;AAuCA;EAuZK,yBAAA;AA3bL;AAoCA;EA2ZK,yBAAA;AA5bL;AAscK;EACC,eAAA;AApcN;AAycG;EAEE,eAAA;AAxcL;AA4cG;EAEE,eAAA;AA3cL;AAodI;EACC,cAAA;AAldL;AAqdI;EACC,cAAA;AAndL;AAsdI;EACC,cAAA;AApdL;AAeA;;;EA+cG,cAAA;AAzdH;AAUA;EAsdI,cAAA;AA7dJ;AAoeO;EACC,cAAA;AAleR;AAqeO;EACC,cAAA;AAneR;AACA;EA4eE,8BAAA;EACA,YAAA;AA1eF;AAHA;EAkfG,oBAAA;AA5eH;AANA;EAqfI,WAAA;EACA,mBAAA;AA5eJ;AAVA;EA0fI,6BAAA;EACA,mBAAA;EACA,WAAA;AA7eJ;AAfA;;;;EAsgBI,WAAA;AAjfJ;AArBA;EA4gBE,8BAAA;AApfF;AAxBA;;;;;;EAqhBE,6BAAA;AArfF;AAhCA;;EA0hBE,oCAAA;AAtfF;AApCA;EA8hBE,aAAA;AAvfF;AAvCA;;EAmiBE,yBAAA;AAxfF;AA3CA;EAuiBE,yBAAA;AAzfF;AA9CA;EA8iBK,sBAAA;EACA,6BAAA;AA7fL;AAlDA;;EAwjBG,iDAAA;EACA,kDAAA;AAlgBH;AAvDA;;EA8jBG,gDAAA;AAngBH;AA3DA;;EAmkBG,mDAAA;AApgBH;AA/DA;EAykBG,aAAA;AAvgBH;AA+gBK;EACC,oCAAA;AA7gBN;AArEA;EAulBO,sBAAA;AA/gBP;AAihBO;EACC,sBAAA;AA/gBR;AAuhBE;EAEE,qBAAA;AAthBJ;AA9EA;EA2mBG,UAAA;AA1hBH;AAjFA;EA+mBG,aAAA;AA3hBH;AApFA;EAmnBG,aAAA;AA5hBH;AAvFA;EAwnBE,mBAAA;AA9hBF;AAkiBE;EACC,mEAAA;AAhiBH;AA7FA;;EAooBI,mBAAA;AAniBJ;AAyiBA;EACC,mCAAA;EACA,+BAAA;AAviBD;AA0iBA;;EAEC,oBAAA;AAxiBD;AAsiBA;;EAKE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAviBF;AA2iBA;EAGE,YAAA;AA3iBF;AAwiBA;EAMG,OAAA;AA3iBH;AAqiBA;EAUI,uBAAA;AA5iBJ;AAkiBA;EAaK,mCAAA;AA5iBL;AA+hBA;EAiBK,8CAAA;AA7iBL;AA4hBA;EAqBK,mCAAA;AA9iBL;AAkjBG;;EAEC,gBAAA;AAhjBJ;AAsjBA;EACC,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApjBD;AAujBA;EACC,YAAA;EACA,0BAAA;EACA,sBAAA;AArjBD;AAkjBA;EAOG,kCAAA;EACA,yBAAA;AAtjBH;AA2jBA;EACC,4DAAA;EACA,uBAAA;EACA,gBAAA;AAzjBD;AA4jBA;EAEE,iBAAA;AA3jBF;AA+jBA;EACC,UAAA;AA7jBD;AAgkBA;EACC,uBAAA;EACA,wBAAA;EACA,WAAA;AA9jBD;AAikBA;EAEE,wBAAA;AAhkBF;AA8jBA;EAME,wBAAA;AAjkBF;AA2jBA;EAUE,0BAAA;EACA,WAAA;AAlkBF;AAujBA;EAeE,aAAA;EACA,qBAAA;EACA,wBAAA;AAnkBF;AAkjBA;EAoBG,WAAA;AAnkBH;AA+iBA;EAyBE,cAAA;EACA,gBAAA;AArkBF;AA2iBA;EA8BE,uBAAA;EACA,cAAA;EACA,wBAAA;AAtkBF;AA0kBA;EAEE,oBAAA;EACA,aAAA;AAzkBF;AA6kBA;EACC,oBAAA;AA3kBD;AA8kBA;EACC,qBAAA;EACA,yBAAA;AA5kBD;AA+kBA;EACC,UAAA;EACA,YAAA;AA7kBD;AAglBA;EACC,0BAAA;AA9kBD;AAilBA;;EAGE,UAAA;AAhlBF;AAolBA;EACC,oBAAA;EACA,kCAAA;EACA,qBAAA;EACA,cAAA;AAllBD;AA8kBA;EAOE,WAAA;AAllBF;AA2kBA;EAUG,uBAAA;EACA,iBAAA;AAllBH;AAukBA;EAiBG,WAAA;EACA,SAAA;EACA,qBAAA;AArlBH;AAulBG;EACC,UAAA;EACA,eAAA;AArlBJ;AAmlBG;EAKE,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AArlBL;AA4lBA;EACC,oBAAA;EACA,iCAAA;EACA,qBAAA;EACA,cAAA;AA1lBD;AAslBA;EAOE,eAAA;AA1lBF;AA4lBE;EACC,aAAA;AA1lBH;AA6lBE;EACC,gBAAA;AA3lBH;AA6kBA;EAkBG,WAAA;EACA,SAAA;EACA,sBAAA;EACA,qBAAA;AA5lBH;AA8lBG;EACC,UAAA;EACA,eAAA;AA5lBJ;AA0lBG;EAKE,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AA5lBL;AAmmBA;EACC,oBAAA;EACA,yCAAA;AAjmBD;AA+lBA;EAKE,2DAAA;AAjmBF;AA4lBA;EASE,oCAAA;AAlmBF;AAylBA;EAaE,yBAAA;AAnmBF;AAslBA;EAgBG,aAAA;EACA,sBAAA;AAnmBH;AAklBA;EAuBG,yBAAA;AAtmBH;AA+kBA;EA6BG,uBAAA;EACA,iBAAA;AAzmBH;AA2kBA;EAkCG,qBAAA;AA1mBH;AAwkBA;EAwCG,WAAA;EACA,SAAA;EACA,qBAAA;AA7mBH;AA+mBG;EACC,UAAA;EACA,eAAA;AA7mBJ;AA2mBG;EAKE,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AA7mBL;AAonBE;EAEE,aAAA;AAnnBJ;AAsjBA;EAkEG,gBAAA;EACA,WAAA;AArnBH;AAkjBA;EAuEG,qCAAA;AAtnBH;AA2nBA;;EAGE,oBAAA;AA1nBF;AA8nBA;EAEE,oCAAA;AA7nBF;AA2nBA;EAKG,+BAAA;AA7nBH;AAwnBA;EAUE,oCAAA;AA/nBF;AAmoBA;EAEE,SAAA;EACA,kBAAA;AAloBF;AAsoBA;EACC,oBAAA;AApoBD;AAuoBA;EACC,6CAAA;AAroBD;AAooBA;EAIE,YAAA;AAroBF;AAioBA;EAOG,iCAAA;EACA,sCAAA;AAroBH;AA6nBA;EAWI,2BAAA;EACA,uBAAA;EACA,qBAAA;AAroBJ;AAwnBA;EAkBG,uBAAA;EACA,SAAA;EACA,kCAAA;AAvoBH;AA4oBA;EACC,8CAAA;AA1oBD;AA4oBC;EAAA;IACC,8CAAA;EAzoBA;AACF;AA2oBC;EAAA;IACC,6CAAA;EAxoBA;AACF;AA2oBA;;;;;;;EAQE,qCAAA;AA1oBF;AA8oBA;EACC,8CAAA;AA5oBD;AA8oBC;EAAA;IACC,8CAAA;EA3oBA;AACF;AA6oBC;EAAA;IACC,8CAAA;EA1oBA;AACF;AA6oBA;EACC,oBAAA;EACA,uBAAA;EACA,4CAAA;EACA,iBAAA;AA3oBD;AAuoBA;EAOE,sBAAA;AA3oBF;AAooBA;EAUG,+CAAA;EACA,kDAAA;EACA,4CAAA;AA3oBH;AA+nBA;EAgBG,uBAAA;EACA,gBAAA;AA5oBH;AAipBA;EACC,mCAAA;AA/oBD;AAkpBA;EAEE,oBAAA;AAjpBF;AAqpBA;EAEE,qBAAA;AAppBF;AAwpBA;EAEE,oBAAA;AAvpBF;AA2pBA;EACC,oBAAA;AAzpBD;AA4pBA;EACC,gBAAA;AA1pBD;AAypBA;EAIE,0CAAA;AA1pBF;AA8pBA;EAEE,0CAAA;AA7pBF;AAiqBA;EAIG,WAAA;EACA,YAAA;EACA,eAAA;AAlqBH;AA4pBA;EAWE,oBAAA;AApqBF;AAypBA;EAeE,WAAA;EACA,oBAAA;AArqBF;AAqpBA;EAmBG,WAAA;AArqBH;AAkpBA;EAyBG,oBAAA;AAxqBH;AA6qBA;EACC,8CAAA;EACA,kDAAA;AA3qBD;AA6qBC;EAAA;IACC,8CAAA;EA1qBA;AACF;AA4qBC;EAAA;IACC,8CAAA;EAzqBA;AACF;AA4qBA;EAGG,oCAAA;EACA,kCAAA;AA5qBH;AA8qBG;EAAA;IACC,kCAAA;EA3qBF;AACF;AA6qBG;EAAA;IACC,kCAAA;EA1qBF;AACF;AA8pBA;EAiBE,uBAAA;EACA,sBAAA;AA5qBF;AAgrBA;EAGG,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AAhrBH;AAkrBG;EACC,kBAAA;AAhrBJ;AAmrBG;EACC,mBAAA;EACA,kBAAA;AAjrBJ;AAorBG;EACC,mBAAA;EACA,kBAAA;EACA,eAAA;AAlrBJ;AAqrBG;EACC,mBAAA;AAnrBJ;AA2pBA;EA4BI,gCAAA;AAprBJ;AAwpBA;;EAgCK,uBAAA;EACA,gBAAA;AAprBL;AAmpBA;;;;EAqCM,wBAAA;AAlrBN;AA6oBA;;EA2CK,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AAprBL;AAsoBA;;EAiDM,0BAAA;AAnrBN;AAkoBA;;;;EAqDO,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;AAjrBP;AAynBA;EA8DK,2BAAA;AAprBL;AA2rBA;;;;;;;;;;;;;EAaC,iDAAA;EACA,iDAAA;AAzrBD;AA4rBA;EAGG,kBAAA;EACA,UAAA;AA5rBH;AAisBA;EAEE,oCAAA;AAhsBF;AAosBA;EAEE,oCAAA;AAnsBF;AAusBA;EAEE,oCAAA;AAtsBF;AA0sBA;EAEE,oCAAA;AAzsBF;AA+sBE;EACC,iBAAA;AA7sBH;AAktBA;EAEE,oBAAA;EACA,8BAAA;AAjtBF;AAmtBE;EAEE,cAAA;AAltBJ;AA2sBA;EAYG,aAAA;AAptBH;AA2tBA;EACC,qBAAA;AAztBD;AACA,gCAAgC;AA8tBhC;EACC,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,+BAAA;AA5tBD;AA8tBC;EACC,WAAA;EACA,cAAA;AA5tBF;AAusBA;EAyBE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;AA7tBF;AAguBC;EACC,gCAAA;AA9tBF;AAiuBC;EACC,0BAAA;EACA,UAAA;AA/tBF;AAiuBE;EAEE,oDAAA;AAhuBJ;AAouBE;EAEE,uDAAA;AAnuBJ;AAwuBC;EACC,uBAAA;EACA,kCAAA;AAtuBF;AAouBC;EAKE,SAAA;EACA,SAAA;EACA,yCAAA;EACA,oDAAA;EACA,sCAAA;AAtuBH;AA0uBC;EACC,uBAAA;EACA,uBAAA;AAxuBF;AAsuBC;EAKE,MAAA;EACA,SAAA;EACA,mCAAA;EACA,yCAAA;EACA,uDAAA;EACA,sCAAA;AAxuBH;AA4pBA;EAiFE,oBAAA;EACA,uBAAA;EACA,sCAAA;EACA,oDAAA;EACA,iDAAA;EACA,gBAAA;EACA,qBAAA;EACA,0BAAA;EACA,wBAAA;AA1uBF;AA8uBA;EACC,2BAAA;AA5uBD;AA2uBA;EAKG,yCAAA;EACA,UAAA;EACA,2BAAA;AA7uBH;AAsuBA;EAUI,SAAA;AA7uBJ;AACA,8BAA8B;AAuvB5B;EAGG,oCAAA;AAvvBL;AAiwBA;EACC,kCAAA;EACA,2BAAA;EACA,oCAAA;AA/vBD;AAkwBA;EACC,kCAAA;EACA,2BAAA;EACA,oCAAA;AAhwBD;AAmwBA;EACC,kCAAA;EACA,2BAAA;EACA,oCAAA;AAjwBD;AAowBA;;;EAIE,gCAAA;AAnwBF;AAuwBA;;;;EAKE,qBAAA;AAtwBF;AA0wBA;EACC,eAAA;AAxwBD;AA2wBA;EAEE,YAAA;EACA,yBAAA;EACA,gBAAA;AA1wBF;AA8wBA;EACC,sDAAA;EACA,kDAAA;AA5wBD;AA+wBA;EACC,gCAAA;AA7wBD;AAgxBA;EACC,sDAAA;EACA,kDAAA;AA9wBD;AAixBA;EAKC,gCAAA;AAnxBD;AAsxBA;EACC,eAAA;AApxBD;AACA,2BAA2B;AAuxB3B;EAEE,4BAAA;AAtxBF;AACA,yBAAyB;AA0xBzB;EAKK,mCAAA;AA5xBL;AAmyBA;EACC,YAAA;EACA,oBAAA;AAjyBD","sourcesContent":["/**\n * main.less\n */\n\n@import '../globals';\n@import './small-loader.less';\n\n// html {\n// \tfont-size: 14px !important;\n// \theight: 100vh;// to apply background from ASU\n// }\n\nhtml,\nbody,\ndiv,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo,\nbutton {\n\tfont-family: 'EYInterstate' !important;\n\tfont-size: unset;\n\tborder-radius: unset;\n}\n\nbody {\n\t.k-animation-container.k-animation-container-shown {\n\t\tz-index: 10009 !important;\n\t}\n\n\t.SuspenseLoadingIndicator {\n\t\tmargin-top: 0 !important;\n\t}\n}\n\n#mount {\n\tdisplay: flex;\n\tflex: 1;\n\tflex-flow: column;\n}\n\n.QSISlider {\n\ttop: var(--px-60) !important;\n\theight: calc(100% - var(--px-60)) !important;\n\n\t& > div {\n\t\t&:first-child {\n\t\t\theight: 100% !important;\n\t\t}\n\t}\n}\n\n.rootWrapper {\n\theight: 99.9vh;\n\tdisplay: flex;\n\tflex-flow: column;\n\toverflow: hidden;\n}\n\n.main {\n\tdisplay: flex;\n\tflex: 1;\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: var(--px-56);\n\theight: calc(100vh - var(--px-56));\n\twidth: 100vw;\n\tmargin: 0 auto;\n\n\t&.accountdetails {\n\t\ttop: 0;\n\t\theight: 100%;\n\t}\n}\n\n.offlineprep,\n.offline {\n\tborder: var(--px-7) solid #109090;\n\n\t.rightContainer {\n\t\tpadding-top: var(--px-30);\n\t}\n}\n\n.training {\n\tborder: var(--px-7) solid #91278f;\n}\n\n.connection-available,\n.syncstate {\n\tborder: var(--px-7) solid #35a4e8;\n}\n\n// .StyledTimeTrackerSection {\n// \tbottom: var(--px-105);\n// }\n\n.container {\n\twidth: 100%;\n}\n\n.btn {\n\tborder-radius: 0;\n\toutline: none !important;\n}\n\nol {\n\tmargin: 0;\n\tpadding: 0;\n\n\tli {\n\t\tmargin: 0;\n\t}\n}\n\nul {\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style-type: none;\n\n\tli {\n\t\tmargin: 0;\n\t\tlist-style-type: none;\n\t}\n}\n\n.hide {\n\tdisplay: none;\n}\n\n.carret-right {\n\twidth: 0;\n\theight: 0;\n\tborder-top: var(--px-5) solid transparent;\n\tborder-bottom: var(--px-5) solid transparent;\n\tborder-left: var(--px-7) solid @gray-dark;\n\tmargin-right: var(--px-10);\n\tvertical-align: top;\n\tmargin-top: var(--px-3);\n\tdisplay: inline-block;\n}\n\n.TaskBadgeSection {\n\tcursor: pointer !important;\n\n\t&:hover {\n\t\t.TaskNames {\n\t\t\tspan {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.mainResponsiveWrapper {\n\twidth: calc(100vw - 80px);\n\tmargin: 0 auto;\n\tmax-width: 2048px;\n}\n\n.task-left-panel {\n\tvertical-align: top;\n\tfont-size: var(--px-14);\n\tposition: relative;\n\tmin-width: 14%;\n\talign-self: auto;\n\toverflow-y: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1 1 0%;\n\n\th3 {\n\t\tfont-size: var(--px-13);\n\t\tmargin: 0;\n\t\tpadding: var(--px-10) 0 0;\n\t\tline-height: 2.4px;\n\n\t\ta {\n\t\t\ttext-decoration: none;\n\t\t\tcolor: #2e2e38;\n\t\t}\n\t}\n}\n\n.task-list-panel {\n\twidth: 400px;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.task-details-panel {\n\twidth: calc(100% - 400px);\n\tvertical-align: top;\n\talign-self: auto;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.collapse-text {\n\twriting-mode: vertical-rl;\n\tfont-weight: bold;\n\ttop: 0;\n\tleft: 0;\n\tmargin-top: var(--px-10);\n\tdisplay: none;\n\tvertical-align: top;\n\tfont-size: var(--px-13);\n\tposition: absolute;\n}\n\n.search-filter-control {\n\twidth: 390px;\n\tvertical-align: top;\n\tdisplay: flex;\n}\n\n.leftContainerCollapsed {\n\t.search-filter-control {\n\t\twidth: 490px;\n\t}\n}\n\n.bold-text {\n\tfont-weight: bold;\n}\n\n.drawer-opener {\n\tz-index: 997 !important;\n}\n\nsvg {\n\tvertical-align: top;\n\n\t&.extra-large {\n\t\twidth: var(--px-36);\n\t\theight: var(--px-36);\n\t\tmax-width: var(--px-36);\n\t\tmax-height: var(--px-36);\n\t}\n\n\t&.large {\n\t\twidth: var(--px-24);\n\t\theight: var(--px-24);\n\t\tmax-width: var(--px-24);\n\t\tmax-height: var(--px-24);\n\t}\n\n\t&.medium {\n\t\twidth: var(--px-20);\n\t\theight: var(--px-20);\n\t\tmax-width: var(--px-20);\n\t\tmax-height: var(--px-20);\n\t}\n\n\t&.small {\n\t\twidth: var(--px-16);\n\t\theight: var(--px-16);\n\t\tmax-width: var(--px-16);\n\t\tmax-height: var(--px-16);\n\t}\n\n\t&.task-Progress,\n\t&.task-Review {\n\t\tstroke-width: var(--px-3);\n\n\t\tpath {\n\t\t\t&:nth-child(3) {\n\t\t\t\tstroke: #168736;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.task-Complete {\n\t\tstroke-width: var(--px-3);\n\n\t\tpath {\n\t\t\t&:nth-child(3) {\n\t\t\t\tstroke: #168736;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.task-Open,\n\t&.task-Complete {\n\t\tstroke-width: var(--px-3);\n\n\t\tpath {\n\t\t\t&:last-child {\n\t\t\t\tfill: transparent !important;\n\t\t\t\tstroke: transparent;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.task-Completed:first-child {\n\t\tstroke-width: var(--px-3);\n\t}\n\n\t&.gray {\n\t\tfill: #666;\n\t}\n\n\t&.yellow {\n\t\tfill: #ffd200;\n\t}\n\n\t&.red {\n\t\tfill: #b9251c;\n\t}\n\n\t&.green {\n\t\tfill: #2c973e;\n\t}\n\n\t&.orange {\n\t\tfill: #f7941d;\n\t}\n\n\t&.purple {\n\t\tfill: #91278f;\n\t}\n\n\t&.blue {\n\t\tfill: #155cb4;\n\t}\n\n\t&.teal {\n\t\tfill: #109090;\n\t}\n\n\t&.disable {\n\t\tcursor: default;\n\t}\n}\n\n.gray {\n\tfill: @gray;\n}\n\n.black {\n\tsvg {\n\t\tfill: @ey-black;\n\t}\n}\n\ninput:-webkit-autofill {\n\t-webkit-box-shadow: 0 0 0 var(--px-1000) white inset;\n}\n\n.progressBar {\n\twidth: 100%;\n\tpadding-right: var(--px-20);\n\n\tprogress {\n\t\tborder: none;\n\t\twidth: 100%;\n\t\theight: var(--px-3);\n\t\tbackground: @gray;\n\t}\n\n\tprogress::-moz-progress-bar {\n\t\tbackground: @gray;\n\t}\n\n\tprogress::-webkit-progress-value {\n\t\tbackground: @ey-yellow;\n\t}\n}\n\n.results-not-found {\n\ttext-align: center;\n\tpadding: var(--px-20);\n\tfont-size: var(--px-13);\n}\n\n.removeFromTask-message {\n\tfont-size: var(--px-13);\n}\n\n.cleared .reviewNote-details span.Medium,\n.cleared .reviewNote-details span.Low,\n.cleared .reviewNote-details span.Critical,\n.cleared .reviewNote-details span.High,\n.closed .reviewNote-details span.Medium,\n.closed .reviewNote-details span.Critical,\n.closed .reviewNote-details span.Low,\n.closed .reviewNote-details span.High,\n.closed .reviewNote-item .left-border,\n.cleared .reviewNote-item .left-border {\n\tcolor: #c0c0c0 !important;\n\tborder-color: #c0c0c0 !important;\n}\n\n.text-input .form-group .input-group input.form-control {\n\tbackground: url('../../../assets/img/Calendar.svg') no-repeat right top;\n}\n\n.error-message-wrapper {\n\tpadding: 0;\n\tcolor: #2e2e38;\n\tdisplay: table;\n\twidth: 100%;\n\tfont-size: var(--px-12);\n\tline-height: var(--px-18);\n\tborder: var(--px-1) solid #7f7f7f;\n\n\t.error-message {\n\t\tdisplay: table-cell;\n\t\tpadding: var(--px-9) var(--px-10) var(--px-5);\n\t\tcolor: #2e2e38;\n\t\tbackground: #fff;\n\t}\n}\n\n.errorIcon,\n.success-icon,\n.warning-icon,\n.info-icon {\n\tbackground: url('../../../assets/img/error-icon.svg') no-repeat var(--px-10) var(--px-10);\n\twidth: var(--px-16);\n\theight: var(--px-16);\n\tdisplay: inline-block;\n\tpadding: var(--px-18);\n\tdisplay: table-cell;\n\tbackground-color: #b9251c;\n\tbackground-size: 50%;\n}\n\n.success-icon {\n\tbackground: url('../../../assets/img/success-icon.svg') no-repeat var(--px-7) var(--px-7);\n\tbackground-color: #2c973e;\n}\n\n.warning-icon {\n\tbackground: url('../../../assets/img/warning-icon.png') no-repeat var(--px-9) var(--px-7);\n\tbackground-color: #ff9831;\n}\n\n.info-icon {\n\tbackground: url('../../../assets/img/info-icon.png') no-repeat var(--px-9) var(--px-7);\n\tbackground-color: #747480;\n}\n\n.note-error {\n\tcolor: #b9251c;\n\n\t.k-editor-widget.k-editor {\n\t\tborder: var(--px-1) solid #b9251c;\n\t}\n\n\t.note-error-icon {\n\t\tfill: #b9251c !important;\n\t\tmargin: var(--px-5) var(--px-5) 0 0;\n\t}\n\n\t.note-error-message {\n\t\tmargin: var(--px-5) 0;\n\n\t\t.error-text {\n\t\t\tfont-size: var(--px-13);\n\t\t\tcolor: #b9251c;\n\t\t\tline-height: normal;\n\t\t}\n\t}\n}\n\n//Motif-CheckBox\n\n.StyledModal.modal-body {\n\tdisplay: flex !important;\n\tflex: 1;\n\tflex-direction: row;\n\theight: calc(-94px + 100vh);\n\toverflow: hidden !important;\n\n\t.StyledTabs {\n\t\twidth: 100%;\n\t}\n\n\t.StyledTabs > div {\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\tflex-direction: column;\n\t\theight: 100%;\n\t}\n\n\tul.tab-list {\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\tmax-height: var(--px-50);\n\t}\n\n\t.tab-content {\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\toverflow: hidden;\n\n\t\t.HeadingWrapper {\n\t\t\tmargin: 0 var(--px-20);\n\t\t}\n\t}\n}\n\n.optional-tag {\n\tfont-weight: @labelWeightNormal;\n\tfont-style: italic;\n\tcolor: @grey-50;\n\tpadding-left: var(--px-10);\n}\n\n//Prevent text selection on multiple task selection\n.prevent-select-text {\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n.NavigationBar {\n\t.StyledEYLogoWrapper {\n\t\t&.EYLogo {\n\t\t\twhite-space: nowrap;\n\n\t\t\t@media only screen and (min-width: 1921px) {\n\t\t\t\tmargin-left: 0 !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t.EYNavigation {\n\t\t@media only screen and (min-width: 1921px) {\n\t\t\tmargin-right: 0 !important;\n\t\t}\n\n\t\t.navChild,\n\t\t.navAnchor {\n\t\t\theight: var(--px-60);\n\t\t}\n\n\t\t.DefaultMenuContainer {\n\t\t\theight: var(--px-60);\n\n\t\t\t.Notification {\n\t\t\t\t.notification-main-wrap {\n\t\t\t\t\tmax-height: var(--px-24) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.EYEngagementDefault {\n\t\tmax-height: var(--px-60);\n\t}\n}\n\n@media @desktop-medium {\n\thtml {\n\t\tfont-size: 12.61px !important;\n\t}\n}\n\n@media @desktop-small {\n\thtml {\n\t\tfont-size: 11.2px !important;\n\t}\n\n\t.task-category-title {\n\t\twidth: 100px !important;\n\t}\n\n\t.task-list-panel {\n\t\twidth: 330px;\n\t}\n\n\t.task-details-panel {\n\t\twidth: calc(100% - 300px);\n\t}\n\n\t.document-name-span .last-modified .modifiedName {\n\t\tmax-width: 60% !important;\n\t}\n\n\t.search-filter-control {\n\t\twidth: 290px;\n\t}\n\n\t.leftContainerCollapsed .rightContainer {\n\t\t.task-list-panel {\n\t\t\twidth: 400px !important;\n\t\t}\n\n\t\t.task-details-panel {\n\t\t\twidth: calc(100% - 400px) !important;\n\t\t}\n\n\t\t.search-filter-control {\n\t\t\twidth: 390px;\n\t\t}\n\t}\n\n\t.container span.timeline .datesContainer section.buttonDiv button {\n\t\theight: var(--px-15) !important;\n\t}\n}\n\n.task-layout-wrapper,\n.notes-layout-wrapper,\n.documents-layout-wrapper,\n.modalBodyFlexHieght {\n\tbackground-color: #f6f6f6;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1 1 0%;\n\toverflow-x: hidden;\n}\n\n.task-layout-wrapper,\n.notes-layout-wrapper {\n\tbackground: linear-gradient(to right, #2e2e38 50%, #fff 50%);\n}\n\n.modalBodyFlexHieght {\n\tbackground: transparent;\n\n\t&.nobodyOverflow {\n\t\t.Wizcomponent {\n\t\t\t.errorMessageWrapper {\n\t\t\t\tmargin-top: calc(var(--px-10) * -1);\n\t\t\t}\n\t\t}\n\t}\n}\n\n// .taskNotesModalContainer {\n// \t&.motif-modal-content {\n// \t\tmax-width: 1280px !important;\n// \t\tmargin: 0 auto;\n// \t}\n// \t.motif-accordion-content {\n// \t\twidth: 100% !important;\n// \t}\n// \t.motif-accordion .accordion-view {\n// \t\tmargin-bottom: var(--px-40) !important;\n// \t}\n// }\n\n.relateEvidenceModalBody {\n\tdisplay: flex !important;\n\theight: 100%;\n}\n\n.WCGWWrapper,\n.RiskWrapper,\n.SEM-body,\n.ValidationsWrapper,\n.risk-category-header,\n.accountTypes {\n\t.count {\n\t\tcolor: #2e2e38;\n\t\tpadding: var(--px-4) var(--px-8);\n\t\tline-height: var(--px-12);\n\t\tborder-radius: var(--px-10);\n\t\tfont-size: var(--px-12);\n\t\tdisplay: inline-block;\n\t\tvertical-align: text-bottom;\n\t\tmargin: var(--px-3) 0 var(--px-2) 0;\n\t\ttext-align: center;\n\t\tmin-width: 35px;\n\t\tborder: var(--px-1) solid #ddd;\n\t}\n}\n\n.edit-note-modal-wrapper {\n\t.modal-wrapper {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\theight: 490px;\n\n\t\t.edit-note-modal-body {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n}\n\n.keyevent-tooltip {\n\t.motif-icon-button {\n\t\tdisplay: none;\n\t}\n\n\t.keyevent-date {\n\t\tfont-size: var(--px-10);\n\t\tmargin-top: var(--px-10);\n\t\tdisplay: inline-block;\n\t}\n\n\t.motif-tooltip {\n\t\tmin-width: 10%;\n\t}\n\n\t.keyevent-ellipses {\n\t\tfont-size: var(--px-12);\n\t\tpadding: var(--px-5) 0;\n\t}\n\n\t.motif-tooltip-content-children {\n\t\tmax-height: 200px;\n\t\toverflow-y: auto;\n\t}\n\n\t.motif-tooltip-inner .motif-icon-button svg {\n\t\twidth: var(--px-10);\n\t\theight: var(--px-10);\n\t}\n\n\thr {\n\t\tmargin: var(--px-10) 0;\n\t\tborder-top: solid var(--px-1) #ccc;\n\t}\n}\n\n.assertionToolTip {\n\t.motif-tooltip {\n\t\twidth: var(--px-250);\n\n\t\t.motif-tooltip-wrapper {\n\t\t\tmargin-top: 0 !important;\n\t\t}\n\n\t\t.motif-tooltip-content-children {\n\t\t\tmargin: 0;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.motif-tooltip-inner {\n\t\t\t.risk-Type-Header {\n\t\t\t\tpadding: 0 var(--px-10) var(--px-10) 0;\n\t\t\t\tmargin: 0;\n\t\t\t\tfont-size: var(--px-14);\n\t\t\t\tfont-weight: bold;\n\t\t\t\tborder-bottom: var(--px-1) solid var(--neutrals-300);\n\t\t\t\tborder-radius: var(--px-4) var(--px-4) 0 0;\n\t\t\t\toverflow: hidden;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t}\n\n\t\t\tul.assertionsList {\n\t\t\t\tfont-size: var(--px-14);\n\t\t\t\tborder-radius: 0 0 var(--px-4) var(--px-4) !important;\n\n\t\t\t\tli {\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tpadding: var(--px-8) 0;\n\t\t\t\t\tdisplay: flex;\n\n\t\t\t\t\t.risk-Type-Label {\n\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\tmax-width: var(--px-80);\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin-bottom: var(--px-5);\n\n\t\t\t\t\t\t.risk-Type-Label-inner {\n\t\t\t\t\t\t\tmax-width: 95%;\n\t\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.risk-Type-Value {\n\t\t\t\t\t\tmargin-bottom: var(--px-5);\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\twidth: var(--px-120);\n\t\t\t\t\t}\n\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t}\n\n\t\t\t\t\t&.emptyContainer {\n\t\t\t\t\t\tpadding: var(--px-8) 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.motif-tooltip-right {\n\t\twidth: var(--px-250);\n\n\t\t.motif-tooltip-inner {\n\t\t\tul.assertionsList {\n\t\t\t\tfont-size: var(--px-14);\n\n\t\t\t\tli {\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tpadding: var(--px-8) 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.motif-modal-overlay:has(> div.add-edit-assignment-modal) {\n\tz-index: 1001;\n}\n\n.motif-modal-overlay:has(> div.create-assignment-modal) {\n\tz-index: 1001;\n}\n\n.motif-modal-overlay {\n\t&.SoftwareUpdateModalContainer {\n\t\t.motif-modal-body {\n\t\t\tmin-height: var(--px-60) !important;\n\t\t}\n\t}\n\n\t.motif-modal-body {\n\t\t.RelatedListUtility {\n\t\t\t.RelatedListPager {\n\t\t\t\t.addDocument-paging {\n\t\t\t\t\tbackground-color: #23232f;\n\n\t\t\t\t\t.Dropdown-control {\n\t\t\t\t\t\tbackground-color: #23232f;\n\t\t\t\t\t}\n\n\t\t\t\t\tinput[type='text'] {\n\t\t\t\t\t\tbackground-color: #23232f;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tborder-bottom: 0 !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.SignoffRequirementsModalBody {\n\t\t\t.StyledSignoffRequirementsModal {\n\t\t\t\tmin-height: var(--px-200) !important;\n\t\t\t}\n\t\t}\n\n\t\t&.noPadding {\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t//To be removed once we add the below css in Voltron Modal component\n\t\t.StyledToastMessageContainer {\n\t\t\twidth: calc(100% - calc(2 * var(--spacing-x-large)));\n\t\t\tleft: var(--spacing-x-large);\n\t\t}\n\t}\n\n\t.DocumentConflictModal {\n\t\tmax-width: 72%;\n\t\twidth: 72%;\n\t\tmax-height: 100%;\n\t\theight: calc(100vh - var(--px-40));\n\t\tfont-size: var(--px-14);\n\n\t\t.DocumentConflictNameWrapper {\n\t\t\tpadding: var(--px-10) 0;\n\t\t\twidth: 100%;\n\n\t\t\t.DocumentNameWrapper {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t.AdvanceDocName {\n\t\t\t\t\t.DocumentNameContainer {\n\t\t\t\t\t\talign-items: flex-start;\n\n\t\t\t\t\t\t.DocumentNameDetails {\n\t\t\t\t\t\t\tmin-height: var(--px-40);\n\n\t\t\t\t\t\t\t.DocumentName {\n\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\theight: inherit;\n\n\t\t\t\t\t\t\t\t.last-modified {\n\t\t\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.sendToPrimaryTeamModal {\n\t\twidth: 60% !important;\n\t\tmax-width: 60% !important;\n\t}\n\n\t.errorMessageWrapper {\n\t\tmargin: calc(var(--px-10) * -1) 0 var(--px-10) 0 !important;\n\t\theight: auto;\n\n\t\t.close-icon {\n\t\t\tposition: relative;\n\t\t\ttop: var(--px-8);\n\t\t\tright: var(--px-10);\n\t\t}\n\t}\n\n\t.DeleteDocumentModalBody {\n\t\tmin-height: var(--px-150) !important;\n\n\t\t.errorMessageWrapper {\n\t\t\tmargin: var(--px-10) 0 !important;\n\t\t\theight: var(--px-38);\n\n\t\t\t.close-icon {\n\t\t\t\tposition: relative;\n\t\t\t\ttop: var(--px-8);\n\t\t\t\tright: var(--px-10);\n\t\t\t}\n\t\t}\n\n\t\t.DocumentName {\n\t\t\tfont-size: var(--px-16) !important;\n\t\t}\n\t}\n\n\t.RestoreModal {\n\t\tmin-height: var(--px-100) !important;\n\n\t\t.errorMessageWrapper {\n\t\t\tmargin: calc(var(--px-10) * -1) 0 var(--px-10) 0 !important;\n\t\t\theight: var(--px-38);\n\n\t\t\t.close-icon {\n\t\t\t\tposition: relative;\n\t\t\t\ttop: var(--px-8);\n\t\t\t\tright: var(--px-10);\n\t\t\t}\n\t\t}\n\n\t\t.DocumentNameWrapper {\n\t\t\t.DocumentNameWrapper {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\n\t\t.RestoreText {\n\t\t\tpadding: var(--px-10) var(--px-20);\n\t\t\tfont-size: var(--px-14);\n\t\t}\n\t}\n\n\t.PermanentlyDeleteModal {\n\t\tmin-height: var(--px-150);\n\n\t\t.errorMessageWrapper {\n\t\t\tmargin: calc(var(--px-10) * -1) 0 var(--px-10) 0 !important;\n\t\t\theight: var(--px-38);\n\n\t\t\t.close-icon {\n\t\t\t\tposition: relative;\n\t\t\t\ttop: var(--px-8);\n\t\t\t\tright: var(--px-10);\n\t\t\t}\n\t\t}\n\n\t\t.DocumentNameWrapper {\n\t\t\t.DocumentNameWrapper {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\n\t\t.PermanentlyDeleteText {\n\t\t\tpadding: var(--px-20) 0;\n\t\t\tfont-size: var(--px-14);\n\t\t}\n\t}\n\n\t.ConfidentialityModalContainer {\n\t\t.StyledConfidentiality {\n\t\t\tmin-height: var(--px-400);\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t.motif-modal-body {\n\t\t\t&.ConfidentialityModalBody {\n\t\t\t\toverflow-y: auto;\n\n\t\t\t\t.motif-select-trigger {\n\t\t\t\t\theight: var(--px-45);\n\t\t\t\t}\n\n\t\t\t\t.motif-select-view-value {\n\t\t\t\t\twidth: calc(100% - var(--px-30));\n\t\t\t\t}\n\n\t\t\t\t.motif-option {\n\t\t\t\t\tmin-height: var(--px-45);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.contentUpdateTooltip {\n\t.motif-tooltip-inner {\n\t\tmax-width: var(--px-380);\n\t}\n\n\t.contentUpdateTooltipText {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n}\n\n.statusTooltip {\n\t.motif-tooltip {\n\t\t.tooltip-text {\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t.motif-tooltip-inner {\n\t\t.motif-tooltip-content-children {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.tooltip-text {\n\t\t\twidth: 100%;\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t\twhite-space: nowrap;\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n}\n\n.canvas-form-tooltip {\n\t.motif-tooltip-wrapper {\n\t\tmargin: 0 !important;\n\t}\n}\n\n.DocumentListHeaderPercentToolTip {\n\t.motif-tooltip-inner {\n\t\twidth: var(--px-600);\n\n\t\t.motif-tooltip-content-children {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n/* CustomScrollbar CSS Starts */\n.customScrollbar {\n\toverflow-y: auto;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 6px !important;\n\t\tborder: none !important;\n\t}\n\n\t&::-webkit-scrollbar-track {\n\t\tbackground: #e7e7ea !important;\n\t\twidth: 6px !important;\n\t\tborder: none !important;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground: #c4c4cd !important;\n\t\twidth: 6px !important;\n\t\tcursor: pointer !important;\n\t\tborder: none !important;\n\t}\n\n\t&::-webkit-scrollbar-thumb:hover {\n\t\tbackground: #747480 !important;\n\t\tborder: none !important;\n\t}\n}\n\n::-webkit-scrollbar {\n\twidth: 6px !important;\n\tborder: none !important;\n}\n\n::-webkit-scrollbar-track {\n\tbackground: #e7e7ea !important;\n\twidth: 6px !important;\n\tborder: none !important;\n}\n\n::-webkit-scrollbar-thumb {\n\tbackground: #c4c4cd !important;\n\twidth: 6px !important;\n\tcursor: pointer !important;\n\tborder: none !important;\n}\n\n::-webkit-scrollbar-thumb:hover {\n\tbackground: #747480 !important;\n\tborder: none !important;\n}\n\n/* CustomScrollbar CSS Ends */\n\n.selectBoxlabelTopPos {\n\t.show {\n\t\tdisplay: flex !important;\n\t\talign-items: center;\n\t\tmargin-top: var(--px-5);\n\n\t\tsvg.medium {\n\t\t\tmargin-top: 0;\n\t\t\twidth: var(--px-16);\n\t\t\theight: var(--px-16);\n\t\t\tfill: #b9251c;\n\t\t\tmargin-right: var(--px-5);\n\t\t}\n\n\t\t.error-text {\n\t\t\tcolor: #b9251c;\n\t\t}\n\t}\n}\n\n.delete-tag-tooltip {\n\t.motif-tooltip {\n\t\twidth: var(--px-210);\n\t}\n}\n\n//createassignment modal\n.overrideAssignment {\n\t.motif-tooltip-inner {\n\t\t.motif-tooltip-content-children {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n.service-req-tooltip {\n\t.motif-tooltip-inner {\n\t\twidth: var(--px-460);\n\t}\n}\n\n.service-req-mark-complete {\n\t.motif-tooltip-inner {\n\t\tmin-width: var(--px-20);\n\t\tmax-width: var(--px-460);\n\t}\n}\n\n.step2-tooltip {\n\t.motif-tooltip-inner {\n\t\twidth: var(--px-500);\n\n\t\t.motif-tooltip-content-children {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n.motif-modal-content {\n\t.confirm-start-multiuser-editing-modal-body {\n\t\t.document-name {\n\t\t\tdisplay: flex;\n\t\t\talign-items: flex-start;\n\t\t\twidth: 100%;\n\t\t\t.StyledFileName {\n\t\t\t\twidth: 100%;\n\t\t\t\t.DocumentName {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\t.DocumentNameText {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t.DocumentName {\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.documentName-icons {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.small {\n\t\t&.sdm-modal-control {\n\t\t\twidth: 75% !important;\n\t\t\tmax-width: 75% !important;\n\t\t}\n\n\t\t&.StyledDocumentOpened {\n\t\t\t.ModalDocumentOpened {\n\t\t\t\t.document-opened-header {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\n\t\t\t\t\th4 {\n\t\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\t\tcolor: var(--neutrals-900);\n\t\t\t\t\t\tmargin: 0 0 var(--px-24) 0;\n\t\t\t\t\t}\n\n\t\t\t\t\t.SpanLabelText {\n\t\t\t\t\t\tcolor: var(--neutrals-900);\n\t\t\t\t\t\tmargin-bottom: var(--px-24);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.document-opnened-docname {\n\t\t\t\t\t.DocumentNameContainer {\n\t\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\t}\n\n\t\t\t\t\t.DocumentNameContainer .DocumentName .DocumentName {\n\t\t\t\t\t\tfont-size: var(--px-16);\n\t\t\t\t\t\tcolor: var(--neutrals-900);\n\t\t\t\t\t\topacity: 1;\n\n\t\t\t\t\t\t&.disabled {\n\t\t\t\t\t\t\tcolor: var(--neutrals-500);\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.DocumentNameContainer .DocumentNameDetails .DocumentName .last-modified,\n\t\t\t\t\t.DocumentNameContainer .DocumentNameDetails .DocumentName .currently-modified {\n\t\t\t\t\t\tmargin-left: 0 !important;\n\t\t\t\t\t\tcolor: var(--neutrals-500);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ChangeReasonModalContainer {\n\t\t\theight: calc(100% - var(--px-60)) !important;\n\n\t\t\t.ChangeReasonModalBody {\n\t\t\t\t.ChangeReasonSelect {\n\t\t\t\t\t.react-select-container {\n\t\t\t\t\t\t.react-select__menu {\n\t\t\t\t\t\t\t.react-select__menu-list {\n\t\t\t\t\t\t\t\tmax-height: var(--px-500) !important;\n\n\t\t\t\t\t\t\t\t@media screen and (min-width: 1601px) and (max-width: 1900px) {\n\t\t\t\t\t\t\t\t\tmax-height: var(--px-350) !important;\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t@media screen and (min-width: 1367px) and (max-width: 1600px) {\n\t\t\t\t\t\t\t\t\tmax-height: var(--px-350) !important;\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t@media screen and (min-width: 1281px) and (max-width: 1366px) {\n\t\t\t\t\t\t\t\t\tmax-height: var(--px-320) !important;\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t\t@media screen and (max-width: 1280px) {\n\t\t\t\t\t\t\t\t\tmax-height: var(--px-300) !important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ConfidentialityModalContainer {\n\t\t\theight: calc(100% - var(--px-60)) !important;\n\t\t}\n\t}\n}\n\n.package-list-modal.motif-modal.small {\n\theight: 100% !important;\n}\n\n.package-list-modal {\n\t.error-icon-wrap {\n\t\tmargin-top: -1px;\n\t}\n\n\t.motif-progress-loader {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: calc(100vh - var(--px-350));\n\t}\n\n\t.modalbody-wrapper.customScrollbar {\n\t\theight: calc(100vh - var(--px-180)) !important;\n\t}\n}\n\n.service-req-modal {\n\t.error-icon-wrap {\n\t\tmargin-top: -1px;\n\t}\n\n\t.modalbody-wrapper.customScrollbar {\n\t\theight: calc(100vh - var(--px-324)) !important;\n\t}\n}\n\n.motif-dropdown-menu-portal {\n\tmin-width: var(--px-300);\n}\n\n.MoreMenuContainer {\n\t.motif-menu-overlay {\n\t\tpointer-events: none;\n\t}\n}\n\n.tasks-tooltip {\n\t.tasks-tooltip-inner {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t.motif-tooltip-content-children {\n\t\tmargin-right: 0;\n\t}\n\n\t.status-count {\n\t\twidth: var(--px-25);\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\ttext-align: left;\n\t\tmargin-right: var(--px-3);\n\t}\n\n\tsvg.large.progress-circle {\n\t\tmargin-right: var(--px-2);\n\t\twidth: var(--px-23);\n\t\theight: var(--px-23);\n\t\tmax-width: var(--px-34);\n\t\tmax-height: var(--px-34);\n\n\t\t&.in-progress {\n\t\t\tpath {\n\t\t\t\t&:last-child {\n\t\t\t\t\tstroke: #189d3e;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.in-review {\n\t\t\tpath:last-child {\n\t\t\t\tstroke: #189d3e;\n\t\t\t}\n\t\t}\n\n\t\t&.completed {\n\t\t\tpath {\n\t\t\t\tstroke: #168736;\n\t\t\t}\n\n\t\t\tpath:last-child {\n\t\t\t\tstroke-width: var(--px-1);\n\t\t\t}\n\t\t}\n\t}\n\n\tsvg.progress-circle path {\n\t\tstroke-width: var(--px-3);\n\t}\n}\n\n.canvasoversight-tooltip {\n\t.motif-tooltip {\n\t\twidth: var(--px-320);\n\t}\n\n\t.motif-tooltip-content-children {\n\t\twidth: 100%;\n\t}\n\n\t.clients-list-item {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\twidth: 99%;\n\t}\n}\n\n.access-location-tooltip,\n.schedule-request-tooltip {\n\t.motif-tooltip-content-children {\n\t\twidth: var(--px-400);\n\t}\n}\n\n.schedule-request-tooltip {\n\t.motif-tooltip-content-children {\n\t\twidth: var(--px-200) !important;\n\t}\n}\n\n.assertions-tooltip {\n\t.motif-tooltip-content-children {\n\t\twidth: var(--px-250);\n\n\t\t.assertion-header {\n\t\t\tfont-size: var(--px-12);\n\t\t\tmargin: 0;\n\t\t\twidth: 100%;\n\t\t\tpadding: var(--px-10) var(--px-15);\n\t\t\tbackground: #f6f6fa;\n\t\t\tdisplay: flex;\n\n\t\t\t.header-text {\n\t\t\t\twhite-space: nowrap;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\twidth: 90%;\n\t\t\t\tfont-size: var(--px-14);\n\t\t\t}\n\t\t}\n\n\t\t.risk-Type-Header {\n\t\t\tmargin-left: var(--px-5);\n\t\t}\n\n\t\t.cra-badges-wrap {\n\t\t\tmin-height: var(--px-40);\n\t\t\tmax-height: var(--px-200);\n\t\t\tfont-size: var(--px-10);\n\t\t}\n\t}\n}\n\n.count-icon-wrap {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.notes-tooltip {\n\t.motif-tooltip-inner {\n\t\twidth: var(--px-100);\n\n\t\t.motif-tooltip-content-children {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.count-text-wrap {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: var(--px-5);\n\t\t}\n\n\t\t.status-count {\n\t\t\twidth: 25%;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t.status-text {\n\t\t\twidth: 75%;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-left: var(--px-5);\n\n\t\t\t&.medium {\n\t\t\t\tcolor: #ff810a;\n\t\t\t}\n\n\t\t\t&.high {\n\t\t\t\tcolor: #bc2f00;\n\t\t\t}\n\n\t\t\t&.critical {\n\t\t\t\tcolor: #7a130d;\n\t\t\t}\n\t\t}\n\t}\n\n\t.notes-tooltip-inner {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\tfont-size: var(--px-12);\n\t}\n}\n\n.ep-tooltip,\n.eqr-tooltip,\n.complete-assng-tooltip {\n\t.motif-tooltip {\n\t\twidth: var(--px-200);\n\t}\n\n\t.motif-tooltip-inner {\n\t\t.motif-tooltip-content-children {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.count-text-wrap {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: var(--px-5);\n\t\t}\n\n\t\t.status-count {\n\t\t\twidth: 15%;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tdisplay: inline-block;\n\t\t\tcolor: #922b73;\n\t\t}\n\n\t\t.status-text {\n\t\t\twidth: 85%;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-left: var(--px-5);\n\t\t}\n\t}\n\n\t.ep-tooltip-inner,\n\t.eqr-tooltip-inner,\n\t.complete-assng-tooltip-inner {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\tfont-size: var(--px-12);\n\t}\n\n\t.complete-assng-tooltip-inner {\n\t\tflex-direction: row;\n\n\t\t.count-text-wrap {\n\t\t\twidth: 49%;\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-start;\n\n\t\t\t.percent-label-wrap {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\t// justify-content: space-between;\n\t\t\t\t.percent-text {\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tmargin-right: var(--px-3);\n\n\t\t\t\t\t&.preparer {\n\t\t\t\t\t\tcolor: #155cb4;\n\t\t\t\t\t}\n\n\t\t\t\t\t&.reviewer {\n\t\t\t\t\t\tcolor: #155cb4;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.status-label {\n\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\t\twidth: 80%;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.complete-assng-tooltip {\n\t.motif-tooltip {\n\t\twidth: var(--px-250);\n\t}\n\n\t.motif-tooltip-inner {\n\t\t.status-text {\n\t\t\twidth: 100%;\n\t\t\tmargin-left: 0;\n\t\t\tcolor: #747480;\n\t\t\tfont-weight: normal;\n\t\t\tmargin-bottom: var(--px-5);\n\t\t}\n\t}\n}\n\n.FilterControlWrapper {\n\t.filter-button-date {\n\t\ttext-align: left;\n\t}\n}\n\n.addrequest-modal .motif-modal-body ul.errorlist-container {\n\tmargin-top: calc(var(--px-27) * -1);\n\tposition: absolute;\n\twidth: calc(100% - var(--px-40));\n\n\tli .errorMessageWrapper {\n\t\tmargin: 0 0 var(--px-3) 0 !important;\n\t}\n}\n\n.motif-tooltip-content.extsignoff-dropdown .tooltip-body .document-approval-item .ellipses {\n\twidth: calc(100% - var(--px-100));\n}\n\n.document-opnened-docname {\n\t.DocumentNameWrapper {\n\t\t.DocumentNameWrapper {\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\n\t.DocumentNameDetails {\n\t\t.DocumentName {\n\t\t\tflex-direction: column;\n\n\t\t\t.DocumentName {\n\t\t\t\talign-items: flex-start;\n\t\t\t\theight: auto !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.k-window .k-window-titlebar .k-window-title {\n\tfont-size: var(--px-17);\n\tfont-weight: bold;\n}\n\n.relatedTaskDropdown {\n\t&.bulk-requests-tasks-popup {\n\t\toverflow: visible !important;\n\n\t\t.taskList {\n\t\t\tpadding-inline: 0 !important;\n\n\t\t\t.taskListBody {\n\t\t\t\t.listView {\n\t\t\t\t\twidth: 100% !important;\n\t\t\t\t\tmargin-bottom: 0 !important;\n\t\t\t\t\tpadding: var(--px-5) 0 var(--px-5) 0 !important;\n\n\t\t\t\t\t.TaskNames {\n\t\t\t\t\t\tcolor: #2e2e38 !important;\n\t\t\t\t\t\tmargin: 0 !important;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tcolor: #2e2e38 !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.TaskBadges {\n\t\t\t\t\t\twidth: var(--px-60) !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.taskListHeading {\n\t\t\t\tpadding-left: var(--px-30);\n\t\t\t}\n\n\t\t\t.customScrollbar {\n\t\t\t\toverflow-y: auto;\n\t\t\t}\n\t\t}\n\n\t\t&.Dataloading {\n\t\t\tpointer-events: none;\n\n\t\t\t.taskList {\n\t\t\t\tbackground: #2e2e380d;\n\t\t\t\topacity: 0.5;\n\n\t\t\t\t.taskListBody {\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.relatedTaskDropdown {\n\tmin-width: var(--px-25);\n\tdisplay: inline-flex !important;\n\tline-height: var(--px-10);\n\tjustify-content: center;\n\talign-items: center;\n\theight: 100%;\n\n\t.relatedTaskSection {\n\t\twidth: var(--px-25);\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tfont-size: var(--px-10) !important;\n\t\tfont-weight: 400;\n\t\tjustify-content: center;\n\t\theight: 100%;\n\n\t\t.ellipses {\n\t\t\tjustify-content: center;\n\t\t\tfont-size: var(--px-10);\n\t\t\tfont-weight: 400;\n\t\t\theight: var(--px-18);\n\t\t}\n\t}\n\n\t.motif-dropdown-trigger {\n\t\twidth: 100%;\n\n\t\t.relatedTaskSection {\n\t\t\twidth: var(--px-25);\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: wrap;\n\t\t\tfont-size: var(--px-10) !important;\n\t\t\tfont-weight: 400;\n\n\t\t\t.ellipses {\n\t\t\t\tfont-size: var(--px-10) !important;\n\t\t\t\tfont-weight: 400;\n\t\t\t\theight: var(--px-18);\n\t\t\t}\n\t\t}\n\t}\n\n\t.taskList {\n\t\t.taskListBody {\n\t\t\t.listView {\n\t\t\t\t.TaskBadges {\n\t\t\t\t\twidth: var(--px-65) !important;\n\t\t\t\t}\n\n\t\t\t\t.TaskNames {\n\t\t\t\t\tline-height: var(--px-24) !important;\n\t\t\t\t\tmax-width: calc(100% - var(--px-110)) !important;\n\t\t\t\t\tcolor: #155cb4 !important;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: #155cb4 !important;\n\t\t\t\t\t}\n\n\t\t\t\t\t.showCursor {\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t}\n\n\t\t\t\t\ta {\n\t\t\t\t\t\tfont-size: var(--px-14) !important;\n\t\t\t\t\t\tcolor: #155cb4 !important;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tcolor: #155cb4 !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.StyledTaskDrawerSummoner {\n\t\t\t\tmargin-bottom: var(--px-10);\n\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\n\t\t\t\t.listView {\n\t\t\t\t\t.TaskNames {\n\t\t\t\t\t\ttext-align: left;\n\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tfont-size: var(--px-14) !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.CloseButton {\n\t\tposition: absolute;\n\t\tright: var(--px-8);\n\t\ttop: var(--px-10);\n\n\t\tsvg {\n\t\t\twidth: var(--px-18) !important;\n\t\t\theight: var(--px-18) !important;\n\t\t\tfill: #2e2e38;\n\n\t\t\tpath {\n\t\t\t\tfill: #2e2e38;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.motif-tooltip-content.linkprojects-tooltip {\n\t.motif-tooltip-content-children .tooltip-content {\n\t\twidth: var(--px-420);\n\t}\n}\n\n.sharedanalytics-tooltip {\n\t.motif-tooltip {\n\t\t.motif-tooltip-wrapper {\n\t\t\t.motif-tooltip-inner {\n\t\t\t\twidth: var(--px-436_5);\n\n\t\t\t\t@media screen and (max-width: 1366px) {\n\t\t\t\t\twidth: var(--px-355);\n\t\t\t\t}\n\n\t\t\t\t.motif-tooltip-content-children {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n#analyticname-tooltip {\n\twidth: var(--px-350);\n\n\t&.ellipses {\n\t\twidth: 100% !important;\n\t}\n}\n\n.StyledSearchFilter {\n\t.filter-search {\n\t\tmargin-bottom: 0;\n\t\theight: var(--px-44);\n\t}\n}\n\n.DocumentNameWrapper .DocumentNameContainer .DocumentNameDetails .note-error,\n.DocumentNameWrapper .DocumentNameContainer .DocumentNameDetails .sync-error {\n\tfont-weight: 400 !important;\n\n\t.error-text {\n\t\tfont-weight: 400 !important;\n\t\tfont-size: var(--px-14) !important;\n\t}\n}\n\n.appliedfilter-tooltipcontent {\n\t.motif-tooltip {\n\t\t.motif-tooltip-wrapper {\n\t\t\t.motif-tooltip-inner {\n\t\t\t\t.motif-tooltip-content-children {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n//styles for react select menu when using portal\n.react-select__menu {\n\tborder: var(--px-1) solid var(--input--border-color) !important;\n\tborder-top: 0 !important;\n\tborder-radius: 0 0 var(--px-8) var(--px-8) !important;\n\tmargin: 0 !important;\n\twidth: 100% !important;\n\tbackground-color: var(--neutrals-00white) !important;\n\toverflow: hidden;\n\tmargin-top: calc(var(--px-1) * -1) !important;\n\n\t.react-select__menu-list {\n\t\tbackground-color: transparent;\n\t\tmax-height: var(--px-240);\n\n\t\t@media only screen and (min-width: 992px) and (max-width: 1366px) {\n\t\t\tmax-height: var(--px-180);\n\t\t}\n\n\t\t@media only screen and (min-width: 1367px) and (max-width: 1600px) {\n\t\t\tmax-height: var(--px-180);\n\t\t}\n\n\t\t.react-select__option {\n\t\t\tbackground-color: transparent;\n\t\t\tfont-size: var(--px-14);\n\t\t\tfont-weight: 300;\n\t\t\tline-height: var(--px-22);\n\t\t\tpadding: var(--px-13) var(--px-12);\n\t\t\tcolor: var(--neutrals-900);\n\n\t\t\t.selectoption-text {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\twidth: calc(100% - var(--px-30));\n\n\t\t\t\t&.disabled {\n\t\t\t\t\tcolor: var(--neutrals-600);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.react-select__option--is-disabled {\n\t\t\t\tcursor: not-allowed !important;\n\t\t\t\tcolor: var(--neutrals-600) !important;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tcursor: not-allowed !important;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\tcursor: pointer !important;\n\t\t\t\tbackground-color: var(--neutrals-200);\n\t\t\t}\n\n\t\t\t&.react-select__option--is-selected {\n\t\t\t\tbackground-color: var(--neutrals-200);\n\t\t\t}\n\t\t}\n\t}\n\n\t.StyledAddDescriptionLabel {\n\t\tborder-radius: 0 0 var(--px-8) var(--px-8);\n\t}\n}\n\nbody[motif-theme='dark'] {\n\t.StyledFrameToggle {\n\t\t.drawer-opener {\n\t\t\twidth: var(--px-40) !important;\n\t\t\tbackground: #3a3a4a;\n\n\t\t\t.open-drawer {\n\t\t\t\tbackground: #3a3a4a;\n\n\t\t\t\tsvg {\n\t\t\t\t\tfill: #fff;\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: #f9f9fa;\n\n\t\t\t\t\tsvg {\n\t\t\t\t\t\tcolor: #2e2e38;\n\t\t\t\t\t\tfill: #2e2e38;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// CustomScrollbar CSS Starts\n\t.customScrollbar {\n\t\t&::-webkit-scrollbar-track {\n\t\t\tbackground: #23232f !important;\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground: #3a3a4a !important;\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb:hover {\n\t\t\tbackground: #747480 !important;\n\t\t}\n\t}\n\n\t// CustomScrollbar CSS Ends\n\n\t.assignments-count-wrap,\n\t.sign-off-cards {\n\t\tbackground: #2e2e3c;\n\t}\n\n\t.sdmChart {\n\t\t.highcharts-series-group .highcharts-series .highcharts-color-0 {\n\t\t\tfill: #ff9831;\n\t\t}\n\n\t\t.highcharts-legend .highcharts-series-0 rect {\n\t\t\tfill: #ff9831;\n\t\t}\n\t}\n\n\t.k-window {\n\t\t.k-window-titlebar {\n\t\t\t&.k-dialog-titlebar {\n\t\t\t\tbackground: #fff;\n\t\t\t\tcolor: #2e2e38;\n\t\t\t}\n\t\t}\n\n\t\t.k-window-content {\n\t\t\t.FooterSection {\n\t\t\t\tborder-top-color: #3a3a4a;\n\t\t\t}\n\t\t}\n\t}\n\n\t.addreq-modal.k-window {\n\t\t.k-window-titlebar {\n\t\t\t&.k-dialog-titlebar {\n\t\t\t\tbackground: #3a3a4a;\n\t\t\t\tcolor: #fff;\n\t\t\t}\n\n\t\t\t.k-window-title {\n\t\t\t\tfont-size: var(--px-17);\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\t\t}\n\n\t\t.k-window-content {\n\t\t\tbackground: #23232f;\n\t\t\tcolor: #fff;\n\n\t\t\t.FooterSection {\n\t\t\t\tborder-top-color: #3a3a4a;\n\t\t\t}\n\t\t}\n\t}\n\n\t.keyBtn {\n\t\tsvg {\n\t\t\tpath {\n\t\t\t\tfill: #ffffff;\n\t\t\t}\n\t\t}\n\t}\n\n\t.document-opnened-docname {\n\t\t.DocumentNameDetails {\n\t\t\t.DocumentName {\n\t\t\t\t.last-modified,\n\t\t\t\t.currently-modified {\n\t\t\t\t\tcolor: #f6f6fa !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.documentName-icons {\n\t\t\tsvg {\n\t\t\t\tfill: #fff !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t.color-dropdown .react-select__control {\n\t\tbackground-color: #2e2e3c !important;\n\t}\n\n\t.metadataTooltipDataArea {\n\t\t&:hover {\n\t\t\tbackground-color: #3a3a4a;\n\t\t}\n\t}\n\n\t.bulkSeeTaskBackground {\n\t\tbackground: #2e2e3c;\n\n\t\t.horizontalLineForSeeTask {\n\t\t\tborder-bottom: var(--px-1) solid #3a3a4a;\n\t\t}\n\t}\n\n\t.offlineprep,\n\t.offline {\n\t\tborder-color: #42c9c2;\n\t}\n\n\t.task-left-panel {\n\t\th3 {\n\t\t\ta {\n\t\t\t\tcolor: #f6f6fa;\n\t\t\t}\n\t\t}\n\t}\n\n\tsvg {\n\t\t&.task-Complete {\n\t\t\tpath {\n\t\t\t\t&:last-child {\n\t\t\t\t\tstroke: #57e188;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.task-Complete,\n\t\t&.task-Progress,\n\t\t&.task-Review {\n\t\t\tpath {\n\t\t\t\t&:nth-child(3) {\n\t\t\t\t\tstroke: #57e188;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.gray {\n\t\t\tfill: #747480;\n\t\t}\n\n\t\t&.red {\n\t\t\tfill: #f95d54;\n\t\t}\n\n\t\t&.blue {\n\t\t\tfill: #4ebeeb;\n\t\t}\n\n\t\t&.teal {\n\t\t\tfill: #42c9c2;\n\t\t}\n\t}\n\n\tinput:-webkit-autofill {\n\t\t-webkit-box-shadow: 0 0 0 var(--px-1000) #1a1a24 inset;\n\t\t-webkit-text-fill-color: #fff;\n\t}\n\n\t.cleared,\n\t.closed {\n\t\t.reviewNote-details,\n\t\t.reviewNote-item {\n\t\t\tspan.Medium,\n\t\t\tspan.Low,\n\t\t\tspan.Critical,\n\t\t\tspan.High,\n\t\t\t.left-border {\n\t\t\t\tcolor: #1a1a24 !important;\n\t\t\t\tborder-color: #1a1a24 !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t.error-message-wrapper {\n\t\tcolor: #f6f6fa;\n\n\t\t.error-message {\n\t\t\tcolor: #f6f6fa;\n\t\t\tbackground: black;\n\t\t}\n\t}\n\n\t.info-icon {\n\t\tbackground-color: #c4c4cd;\n\t}\n\n\t.errorIcon {\n\t\tbackground-color: #b9251c;\n\t}\n\n\t.success-icon {\n\t\tbackground-color: #2c973e;\n\t}\n\n\t.warning-icon {\n\t\tbackground-color: #ff9831;\n\t}\n\n\t.note-error {\n\t\tcolor: #f95d54;\n\n\t\t.k-editor-widget.k-editor {\n\t\t\tborder-color: #f95d54;\n\t\t}\n\n\t\t.note-error-icon {\n\t\t\tfill: #f95d54 !important;\n\t\t}\n\n\t\t.note-error-message {\n\t\t\t.error-text {\n\t\t\t\tcolor: #f95d54;\n\t\t\t}\n\t\t}\n\t}\n\n\t.task-layout-wrapper,\n\t.notes-layout-wrapper {\n\t\tbackground: linear-gradient(to right, #23232f 50%, #1a1a24 50%);\n\t}\n\n\t// .FourFortyLayoutContainer {\n\t// \tbackground: linear-gradient(to right, #23232f 50%, #1a1a24 50%);\n\n\t// \t.left-container {\n\t// \t\t.left-container__list {\n\t// \t\t\t.left_header_group {\n\t// \t\t\t\tcolor: #c4c4cd !important;\n\t// \t\t\t}\n\n\t// \t\t\t.left-container__list__category-header__label {\n\t// \t\t\t\tcolor: #c4c4cd !important;\n\t// \t\t\t}\n\t// \t\t}\n\t// \t}\n\t// }\n\n\t.WCGWWrapper,\n\t.RiskWrapper,\n\t.SEM-body,\n\t.ValidationsWrapper,\n\t.risk-category-header,\n\t.accountTypes {\n\t\t.count {\n\t\t\tcolor: #2e2e38;\n\t\t\tborder-color: #f6f6fa;\n\t\t}\n\t}\n\n\t.task-in-details {\n\t\t.BuildstepContainer {\n\t\t\t.accountTypes {\n\t\t\t\t.count {\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\thr {\n\t\tborder-top: solid var(--px-1) #2e2e38;\n\t}\n\n\t.document-list-pagination {\n\t\tinput[type='text'] {\n\t\t\tbackground-color: transparent;\n\t\t\tcolor: #fff !important;\n\t\t}\n\t}\n\n\t.DocumentListFileUploadWrapper {\n\t\t.StyledFileUpload {\n\t\t\tbutton.btn-default {\n\t\t\t\tbackground: #1a1a24;\n\t\t\t\tcolor: #fff;\n\t\t\t}\n\t\t}\n\t}\n\n\t.motif-modal-overlay {\n\t\t.motif-modal-body {\n\t\t\t.DocumentNameContainer {\n\t\t\t\t.DocumentNameDetails {\n\t\t\t\t\t.DocumentName {\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.edit-note-wrapper {\n\t\t\t\t.react-select--is-disabled {\n\t\t\t\t\t.react-select__control {\n\t\t\t\t\t\tborder-bottom: 1px solid #c4c4cd;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.review-note-category {\n\t\t\t\t.reply-input-wrapper {\n\t\t\t\t\t.reply-icon {\n\t\t\t\t\t\tfill: #fff;\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.reply-container {\n\t\t\t\t\t.reply {\n\t\t\t\t\t\tbackground-color: #2e2e38;\n\n\t\t\t\t\t\t.reply-controls {\n\t\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\t\tfill: #fff;\n\t\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.react-select-container {\n\t\t.react-select__menu {\n\t\t\t.react-select__menu-list {\n\t\t\t\t&::-webkit-scrollbar {\n\t\t\t\t\twidth: var(--px-6);\n\t\t\t\t}\n\n\t\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\t\tbackground: #23232f;\n\t\t\t\t\twidth: var(--px-6);\n\t\t\t\t}\n\n\t\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\t\tbackground: #3a3a4a;\n\t\t\t\t\twidth: var(--px-6);\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\n\t\t\t\t&::-webkit-scrollbar-thumb:hover {\n\t\t\t\t\tbackground: #747480;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.selectBoxlabelTopPos {\n\t\t.show {\n\t\t\tsvg.medium {\n\t\t\t\tfill: #f95d54;\n\t\t\t}\n\n\t\t\t.error-text {\n\t\t\t\tcolor: #f95d54;\n\t\t\t}\n\t\t}\n\t}\n\n\t.create-dropdown,\n\t.relate-dropdown {\n\t\t.motif-dropdown-item {\n\t\t\t&.disabled {\n\t\t\t\tbackground-color: #23232f;\n\t\t\t}\n\t\t}\n\t}\n\n\t.add-document-search-bar {\n\t\t.addDocument-pager {\n\t\t\t.addDocument-paging {\n\t\t\t\tbackground-color: #23232f;\n\n\t\t\t\t.Dropdown-control {\n\t\t\t\t\tbackground-color: #23232f;\n\t\t\t\t}\n\n\t\t\t\tinput[type='text'] {\n\t\t\t\t\tbackground-color: #23232f;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.tasks-tooltip {\n\t\tsvg.large.progress-circle {\n\t\t\t&.in-progress {\n\t\t\t\tpath {\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tstroke: #34c768;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.in-review {\n\t\t\t\tpath:last-child {\n\t\t\t\t\tstroke: #34c768;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.complete {\n\t\t\t\tpath {\n\t\t\t\t\tstroke: #57e188;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.notes-tooltip {\n\t\t.motif-tooltip-inner {\n\t\t\t.status-text {\n\t\t\t\t&.medium {\n\t\t\t\t\tcolor: #ff810a;\n\t\t\t\t}\n\n\t\t\t\t&.high {\n\t\t\t\t\tcolor: #ffb46a;\n\t\t\t\t}\n\n\t\t\t\t&.critical {\n\t\t\t\t\tcolor: #ff9a91;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.ep-tooltip,\n\t.eqr-tooltip,\n\t.complete-assng-tooltip {\n\t\t.status-count {\n\t\t\tcolor: #c981b2;\n\t\t}\n\t}\n\n\t.complete-assng-tooltip {\n\t\t.motif-tooltip-inner {\n\t\t\t.status-text {\n\t\t\t\tcolor: #c4c4cd;\n\t\t\t}\n\n\t\t\t.complete-assng-tooltip-inner {\n\t\t\t\t.count-text-wrap {\n\t\t\t\t\t.percent-label-wrap {\n\t\t\t\t\t\t.percent-text {\n\t\t\t\t\t\t\t&.preparer {\n\t\t\t\t\t\t\t\tcolor: #35a4e8;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t&.reviewer {\n\t\t\t\t\t\t\t\tcolor: #35a4e8;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.relatedtasks-modal .relatedtasks-listcontainer ul li.saving-relatefile {\n\t\tbackground: #2e2e38 !important;\n\t\topacity: 0.7;\n\t}\n\n\t.assertions-tooltip {\n\t\t.motif-tooltip-content-children {\n\t\t\twidth: var(--px-250);\n\n\t\t\t.assertion-header {\n\t\t\t\tcolor: #fff;\n\t\t\t\tbackground: #2e2e3c;\n\t\t\t}\n\n\t\t\t.craBadgesWrapper {\n\t\t\t\tborder-top: solid 1px #747480;\n\t\t\t\tbackground: #2e2e3c;\n\t\t\t\tcolor: #fff;\n\t\t\t}\n\t\t}\n\t}\n\n\t.calendar-tooltip,\n\t.schedule-request-tooltip {\n\t\t.motif-tooltip-inner {\n\t\t\t.cc-tooltip-date,\n\t\t\t.tooltip-text {\n\t\t\t\tcolor: #fff;\n\t\t\t}\n\t\t}\n\t}\n\n\t.tree-item-list-level2 .tree-list-item.children-open:last-child:after {\n\t\tbackground: #23232f !important;\n\t}\n\n\t.addrequest-description span.k-colorpicker,\n\t.addrequest-description .k-picker-wrap.k-state-active,\n\t.addrequest-description .k-picker-wrap,\n\t.requestdetails-info .edit-description span.k-colorpicker,\n\t.requestdetails-info .edit-description .k-picker-wrap.k-state-active,\n\t.requestdetails-info .edit-description .k-picker-wrap {\n\t\tbackground-color: transparent;\n\t}\n\n\t.addrequest-description table.k-editor .k-content,\n\t.requestdetails-info .edit-description table.k-editor .k-content {\n\t\tbackground-color: #eaeaf2 !important;\n\t}\n\n\t.add-request .motif-fab:hover svg {\n\t\tfill: #1a1a24;\n\t}\n\n\t.all-types-filter-dropdown,\n\t.eng-filter-dropdown {\n\t\tbackground-color: #3a3a4a;\n\t}\n\n\t.document-opened-header {\n\t\tcolor: #ffffff !important;\n\t}\n\n\t.DocumentNameWrapper {\n\t\t.documentName-icons {\n\t\t\t.StyledDisplayDocumentSignoffRequirements {\n\t\t\t\t.signoff-requirement-badge {\n\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t\tborder-color: #fff !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.document-list-wrap {\n\t\t.handOffItem-buttons,\n\t\t.sign-off-section {\n\t\t\tborder-left: var(--px-1) solid #747480 !important;\n\t\t\tborder-right: var(--px-1) solid #747480 !important;\n\t\t}\n\n\t\t.handOffItem-buttons-top,\n\t\t.sign-off-section-top {\n\t\t\tborder-top: var(--px-1) solid #747480 !important;\n\t\t}\n\n\t\t.handOffItem-buttons-bottom,\n\t\t.sign-off-section-bottom {\n\t\t\tborder-bottom: var(--px-1) solid#747480 !important;\n\t\t}\n\t}\n\n\t.autoassign-banner {\n\t\tsvg {\n\t\t\tfill: #ff810a;\n\t\t}\n\t}\n\n\t.bulk-requests-tasks-popup {\n\t\t.taskList {\n\t\t\t.taskListBody {\n\t\t\t\t> section {\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground-color: #3a3a4a !important;\n\t\t\t\t\t}\n\n\t\t\t\t\t.taskBadgeAndName {\n\t\t\t\t\t\t.TaskNames {\n\t\t\t\t\t\t\tcolor: #fff !important;\n\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.Dataloading {\n\t\t\t.taskList {\n\t\t\t\tbackground: #2e2e380d;\n\t\t\t}\n\t\t}\n\t}\n\n\t.DocumentNameWrapper .DocumentNameContainer .DocumentSVG svg[name='client-analytic'] {\n\t\tpath:nth-of-type(1) {\n\t\t\tfill: #fff;\n\t\t}\n\n\t\tpath:nth-of-type(2) {\n\t\t\tfill: #7883a4;\n\t\t}\n\n\t\tpath:nth-of-type(3) {\n\t\t\tfill: #2e2e3c;\n\t\t}\n\t}\n\n\t.helix-projects-wrapper {\n\t\tbackground: #1a1a24;\n\t}\n\n\t.dashboard-main-wrap {\n\t\t&.RegularLayoutView {\n\t\t\tbackground: linear-gradient(119deg, #1a1a24 19.79%, #33333e 99.54%);\n\t\t}\n\t}\n\t.map-wrapper {\n\t\t.design-procedure-wrapper {\n\t\t\t.item-details-wrapper,\n\t\t\t.default-template-wrapper {\n\t\t\t\tbackground: #1a1a24;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.motif-dropdown-menu-portal.cogmenu-btn {\n\tmin-width: var(--px-150) !important;\n\twidth: var(--px-150) !important;\n}\n\n.create-dropdown,\n.relate-dropdown {\n\twidth: var(--px-165);\n\n\t.motif-dropdown-item {\n\t\ttext-overflow: ellipsis;\n\t\toverflow: hidden;\n\t\twhite-space: nowrap;\n\t\tdisplay: inline-block;\n\t}\n}\n\n.add-task-modal {\n\t.wizardContainer {\n\t\t// width: calc(100% - var(--px-40)) !important;\n\t\theight: 100%;\n\n\t\t.componentBodyWrapper {\n\t\t\tflex: 1;\n\t\t\t// overflow: hidden;\n\n\t\t\t.relate-objects-wrap {\n\t\t\t\tpadding: var(--px-10) 0;\n\n\t\t\t\t.styled-accounts {\n\t\t\t\t\theight: calc(100vh - var(--px-550));\n\t\t\t\t}\n\n\t\t\t\t.StyledScots {\n\t\t\t\t\theight: calc(100vh - var(--px-500)) !important;\n\t\t\t\t}\n\n\t\t\t\t.styled-itprocesses {\n\t\t\t\t\theight: calc(100vh - var(--px-500));\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&:has(.add-new-task-details),\n\t\t\t&:has(.add-new-task-create-assignment) {\n\t\t\t\toverflow-y: auto;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ellipsis-one-line {\n\tdisplay: inline-block;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.pjctsmenu-dropdowncontainer.motif-dropdown-menu-portal {\n\tz-index: 899;\n\tmin-width: auto !important;\n\twidth: auto !important;\n\n\t.motif-dropdown-item {\n\t\t.motif-icon {\n\t\t\tmargin-top: calc(var(--px-4) * -1);\n\t\t\tmargin-right: var(--px-5);\n\t\t}\n\t}\n}\n\n.primarypjct-modal .primarypjct-msg {\n\tpadding: var(--px-30) var(--px-20) var(--px-40) var(--px-20);\n\tfont-size: var(--px-14);\n\tfont-weight: 300;\n}\n\nsvg {\n\t.highcharts-background {\n\t\tfill: transparent;\n\t}\n}\n\n.motif-progress-loader-container {\n\tz-index: 2;\n}\n\n.motif-dropdown-menu-portal.custom-rnh-dropdown {\n\tmin-width: var(--px-65);\n\tmax-width: var(--px-120);\n\twidth: auto;\n}\n\n.calendar-tooltip {\n\t.motif-tooltip {\n\t\tmax-width: var(--px-440);\n\t}\n\n\t.motif-tooltip-wrapper {\n\t\tmargin-top: 0 !important;\n\t}\n\n\t.motif-tooltip-content-children {\n\t\tmargin-right: 0 !important;\n\t\twidth: 100%;\n\t}\n\n\t.tooltip-inner-indicator {\n\t\tdisplay: flex;\n\t\talign-items: baseline;\n\t\tmargin-top: var(--px-10);\n\n\t\t.tooltip-text {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t.cc-tooltip-date {\n\t\tcolor: #747480;\n\t\tfont-weight: 300;\n\t}\n\n\t.tooltip-text {\n\t\tfont-size: var(--px-12);\n\t\tcolor: #2e2e38;\n\t\tmargin-left: var(--px-5);\n\t}\n}\n\n.validation-tooltip {\n\t.motif-tooltip {\n\t\twidth: var(--px-220);\n\t\tz-index: 9999;\n\t}\n}\n\n.motif-dropdown-menu-portal.document-name-cog-menu-popup-container {\n\twidth: var(--px-150);\n}\n\n.motif-modal.motif-modal-content.custom-message.message {\n\twidth: 35% !important;\n\tmax-width: 35% !important;\n}\n\n.motif-modal.motif-modal-content.motif-modal-size-md.ip-filter-modal {\n\twidth: 40%;\n\theight: auto;\n}\n\n.motif-chip-disabled.ti-chip {\n\tcursor: default !important;\n}\n\n.tooltip-documents,\n.tooltip-assigned-to {\n\t.motif-tooltip {\n\t\tz-index: 0;\n\t}\n}\n\n.filter-dropdown {\n\twidth: var(--px-250);\n\tpadding: var(--px-10) var(--px-20);\n\theight: var(--px-340);\n\toverflow: auto;\n\n\t.showMenuPopOver {\n\t\twidth: auto;\n\n\t\th5 {\n\t\t\tfont-size: var(--px-14);\n\t\t\tfont-weight: bold;\n\t\t}\n\t}\n\n\t.motif-dropdown-item {\n\t\tli {\n\t\t\twidth: 100%;\n\t\t\tmargin: 0;\n\t\t\tdisplay: inline-block;\n\n\t\t\t&.title {\n\t\t\t\tpadding: 0;\n\t\t\t\tcursor: default;\n\n\t\t\t\tspan {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: var(--px-10) 0;\n\t\t\t\t\tfont-size: var(--px-14);\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.filter-dropdown {\n\twidth: var(--px-250);\n\tpadding: var(--px-5) var(--px-20);\n\theight: var(--px-220);\n\toverflow: auto;\n\n\tul.parent {\n\t\tcursor: default;\n\n\t\t&:focus {\n\t\t\toutline: none;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: none;\n\t\t}\n\n\t\tli {\n\t\t\twidth: 100%;\n\t\t\tmargin: 0;\n\t\t\tpadding: var(--px-5) 0;\n\t\t\tdisplay: inline-block;\n\n\t\t\t&.title {\n\t\t\t\tpadding: 0;\n\t\t\t\tcursor: default;\n\n\t\t\t\tspan {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: var(--px-10) 0;\n\t\t\t\t\tfont-size: var(--px-14);\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.scope-dropdown {\n\twidth: var(--px-300);\n\tright: calc(var(--px-19) * -1) !important;\n\n\t.searchControl {\n\t\tmargin: var(--px-15) var(--px-15) var(--px-10) var(--px-15);\n\t}\n\n\t.scope-details-table {\n\t\tpadding: 0 var(--px-15) var(--px-15);\n\t}\n\n\t.scope-details-table {\n\t\tmax-height: var(--px-350);\n\n\t\t> section {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t}\n\t}\n\n\t.motif-typeahead {\n\t\t.motif-typeahead-close-button {\n\t\t\tline-height: var(--px-20);\n\t\t}\n\t}\n\n\t.showMenuPopOver {\n\t\th5 {\n\t\t\tfont-size: var(--px-14);\n\t\t\tfont-weight: bold;\n\t\t}\n\n\t\t.TreeViewListSearchComponent {\n\t\t\tpadding: var(--px-15);\n\t\t}\n\t}\n\n\t.motif-dropdown-item {\n\t\tli {\n\t\t\twidth: 100%;\n\t\t\tmargin: 0;\n\t\t\tdisplay: inline-block;\n\n\t\t\t&.title {\n\t\t\t\tpadding: 0;\n\t\t\t\tcursor: default;\n\n\t\t\t\tspan {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: var(--px-10) 0;\n\t\t\t\t\tfont-size: var(--px-14);\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.pop-over-sub-heading {\n\t\t&:first-child {\n\t\t\th5 {\n\t\t\t\tmargin-top: 0;\n\t\t\t}\n\t\t}\n\n\t\th5 {\n\t\t\tmargin-bottom: 0;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\tli {\n\t\t\tpadding: var(--px-5) 0 var(--px-10) 0;\n\t\t}\n\t}\n}\n\n.sdm-creat-req-tooltip,\n.notification-tooltip-placeholer {\n\t.motif-tooltip {\n\t\twidth: var(--px-200);\n\t}\n}\n\n.assignment-count {\n\t.dropdown-items-wrap {\n\t\tmargin: 0 0 var(--px-4) 0 !important;\n\n\t\t.cursorDefault {\n\t\t\tpointer-events: none !important;\n\t\t}\n\t}\n\n\t.assign-rev-count {\n\t\tmargin: 0 0 0 var(--px-5) !important;\n\t}\n}\n\n.notification-tooltip-placeholer {\n\t.motif-tooltip {\n\t\tmargin: 0;\n\t\tleft: 0 !important;\n\t}\n}\n\n.quick-filter-wrap {\n\twidth: var(--px-250);\n}\n\n.deletecontrol {\n\theight: calc(100% - var(--px-300)) !important;\n\n\t.deleteitem {\n\t\theight: 100%;\n\n\t\t.deletewrapper {\n\t\t\theight: calc(100% - var(--px-50));\n\t\t\tpadding: 0 var(--px-18) 0 var(--px-18);\n\n\t\t\tli {\n\t\t\t\tmargin-bottom: var(--px-16);\n\t\t\t\tfont-size: var(--px-14);\n\t\t\t\tlist-style-type: none;\n\t\t\t}\n\t\t}\n\n\t\th4 {\n\t\t\tfont-size: var(--px-14);\n\t\t\tmargin: 0;\n\t\t\tpadding: var(--px-24) var(--px-18);\n\t\t}\n\t}\n}\n\n.timephase-modal {\n\theight: calc(100vh - var(--px-180)) !important;\n\n\t@media screen and (min-width: 1367px) and (max-width: 1600px) {\n\t\theight: calc(100vh - var(--px-100)) !important;\n\t}\n\n\t@media screen and (min-width: 992px) and (max-width: 1366px) {\n\t\theight: calc(100vh - var(--px-60)) !important;\n\t}\n}\n\n.add-assignment-modal,\n.update-dueDate-modal,\n.delete-assignment-modal,\n.delete-assignment-modal-timephase,\n.add-event-modal,\n.add-timephase-modal,\n.task-auto-assign-modal {\n\t.motif-modal-footer .motif-button {\n\t\tmargin: 0 var(--px-10) 0 0 !important;\n\t}\n}\n\n.addTeamMemberModal {\n\theight: calc(100vh - var(--px-360)) !important;\n\n\t@media screen and (min-width: 1367px) and (max-width: 1600px) {\n\t\theight: calc(100vh - var(--px-240)) !important;\n\t}\n\n\t@media screen and (min-width: 992px) and (max-width: 1366px) {\n\t\theight: calc(100vh - var(--px-240)) !important;\n\t}\n}\n\n.QSIFeedbackButton {\n\tborder: 0 !important;\n\tz-index: 998 !important;\n\theight: calc(100% - var(--px-70)) !important;\n\ttop: var(--px-65);\n\n\tbutton {\n\t\twidth: auto !important;\n\n\t\t> div {\n\t\t\tborder-top-right-radius: var(--px-5) !important;\n\t\t\tborder-bottom-right-radius: var(--px-5) !important;\n\t\t\tpadding: var(--px-15) var(--px-8) !important;\n\t\t}\n\n\t\tdiv {\n\t\t\tfont-size: var(--px-12);\n\t\t\tfont-weight: 400;\n\t\t}\n\t}\n}\n\n.motif-dropdown-menu-portal.motifSignOffTooltip {\n\tmin-width: var(--px-450) !important;\n}\n\n.assigngrp-tooltip {\n\t.motif-tooltip-content-children {\n\t\twidth: var(--px-280);\n\t}\n}\n\n.hand-off-modal {\n\t.motif-loader-container {\n\t\tz-index: 2 !important;\n\t}\n}\n\n.registerinformation {\n\t.motif-tooltip .motif-tooltip-inner {\n\t\twidth: var(--px-380);\n\t}\n}\n\n.task-assignments-drowdown {\n\twidth: var(--px-700);\n}\n\n.assignments-dropdown {\n\ttop: var(--px-4);\n\n\t.motif-dropdown-item {\n\t\twidth: calc(100% + var(--px-2)) !important;\n\t}\n}\n\n.timephase-dropdown {\n\t.motif-dropdown-item {\n\t\twidth: calc(100% + var(--px-2)) !important;\n\t}\n}\n\n.assignment-display {\n\t.dropdownValidationName {\n\t\tsvg {\n\t\t\t// margin: 0 var(--px-6) 0 var(--px-2);\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t.motif-tooltip {\n\t\twidth: var(--px-400);\n\t}\n\n\t.motif-tooltip-content-children {\n\t\twidth: 100%;\n\t\tmargin: 0 !important;\n\n\t\t> section {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t.dropdownValidationName {\n\t\t.ellipses {\n\t\t\twidth: var(--px-160);\n\t\t}\n\t}\n}\n\n.add-tag-modal {\n\theight: calc(100vh - var(--px-420)) !important;\n\tmin-height: calc(100vh - var(--px-360)) !important;\n\n\t@media screen and (min-width: 1367px) and (max-width: 1600px) {\n\t\theight: calc(100vh - var(--px-275)) !important;\n\t}\n\n\t@media screen and (min-width: 992px) and (max-width: 1366px) {\n\t\theight: calc(100vh - var(--px-245)) !important;\n\t}\n}\n\n.right-motif-card {\n\t.motif-toast-fixed-top {\n\t\t.motif-toast-text-container {\n\t\t\tline-height: var(--px-16) !important;\n\t\t\tpadding: var(--px-11) 0 !important;\n\n\t\t\t@media screen and (min-width: 1367px) and (max-width: 1600px) {\n\t\t\t\tpadding: var(--px-12) 0 !important;\n\t\t\t}\n\n\t\t\t@media screen and (min-width: 992px) and (max-width: 1366px) {\n\t\t\t\tpadding: var(--px-10) 0 !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t.motif-typeahead .motif-typeahead-close-button svg {\n\t\theight: 100% !important;\n\t\twidth: 100% !important;\n\t}\n}\n\n.prioritymembers-tooltip {\n\t.motif-tooltip-wrapper {\n\t\t.motif-tooltip-inner {\n\t\t\twidth: var(--px-300);\n\t\t\theight: var(--px-150);\n\t\t\toverflow-x: hidden;\n\t\t\toverflow-y: auto;\n\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: var(--px-6);\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\tbackground: #e7e7ea;\n\t\t\t\twidth: var(--px-6);\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\tbackground: #c4c4cd;\n\t\t\t\twidth: var(--px-6);\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar-thumb:hover {\n\t\t\t\tbackground: #747480;\n\t\t\t}\n\n\t\t\t.motif-tooltip-content-children {\n\t\t\t\twidth: calc(100% - var(--px-28));\n\n\t\t\t\t.eyparticipants-header,\n\t\t\t\t.externalparticipants-header {\n\t\t\t\t\tfont-size: var(--px-12);\n\t\t\t\t\tfont-weight: 700;\n\n\t\t\t\t\t.eyparticipants-count,\n\t\t\t\t\t.externalparticipants-count {\n\t\t\t\t\t\tmargin-left: var(--px-3);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.eyparticipants-list,\n\t\t\t\t.externalparticipants-list {\n\t\t\t\t\tlist-style: none;\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tmargin-top: var(--px-5);\n\t\t\t\t\tmargin-bottom: 0;\n\n\t\t\t\t\tli {\n\t\t\t\t\t\tmargin-bottom: var(--px-5);\n\n\t\t\t\t\t\t.eyparticipants-name,\n\t\t\t\t\t\t.externalparticipants-name {\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\tfont-size: var(--px-12);\n\t\t\t\t\t\t\tfont-weight: 300;\n\t\t\t\t\t\t\tfont-family: ey_interstate;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.eyparticipants-list {\n\t\t\t\t\tmargin-bottom: var(--px-15);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.entities-modal,\n.CreateEditAccountModalContainer,\n.CreateEditControlModalContainer,\n.CreateEditEstimateModalContainer,\n.CreateEditITApplicationModalContainer,\n.CreateEditITControlModalContainer,\n.CreateEditITProcessModalContainer,\n.CreateEditITRiskModalContainer,\n.CreateEditMestModalContainer,\n.CreateEditRiskModalContainer,\n.CreateEditScotModalContainer,\n.CreateEditTaskSectionModalContainer,\n.CreateEditWCGWModalContainer {\n\tmax-height: calc(100vh - var(--px-40)) !important;\n\tmin-height: calc(100vh - var(--px-40)) !important;\n}\n\n.CreateEditITApplicationModalBody {\n\t.modal-error-wrapper {\n\t\t.motif-toast {\n\t\t\tposition: absolute;\n\t\t\tz-index: 5;\n\t\t}\n\t}\n}\n\n.addTeamMemberModal {\n\t.motif-modal-body {\n\t\tmin-height: var(--px-450) !important;\n\t}\n}\n\n.bulk-handOff-modal {\n\t.motif-modal-body {\n\t\tmin-height: var(--px-450) !important;\n\t}\n}\n\n.bulk-markComplete-modal {\n\t.motif-modal-body {\n\t\tmin-height: var(--px-450) !important;\n\t}\n}\n\n.task-delete-modal {\n\t.motif-modal-body {\n\t\tmax-height: var(--px-450) !important;\n\t}\n}\n\n.task-desc-kendo-modal {\n\t.k-window-content {\n\t\t&:last-child {\n\t\t\tpadding-bottom: 0;\n\t\t}\n\t}\n}\n\n.MoreMenuContainer {\n\t.motif-menu-overlay {\n\t\tpointer-events: none;\n\t\tz-index: 9999999999 !important;\n\n\t\t&.motif-menu-overlay-open {\n\t\t\t.motif-menu {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\n\t\t.motif-menu {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n//temporary code, should be removed once ASU address this - Starts\n\n.tooltip-class.motif-tooltip-content {\n\twidth: 32% !important;\n}\n\n//temporary code, should be removed once ASU address this - Ends\n\n/* Ellipses Tooltip CSS Starts */\n.tooltip {\n\tposition: absolute;\n\tdisplay: block;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: var(--px-20);\n\tline-break: auto;\n\ttext-align: start;\n\ttext-decoration: none;\n\ttext-shadow: none;\n\ttext-transform: none;\n\tletter-spacing: normal;\n\tword-break: normal;\n\tword-spacing: normal;\n\tword-wrap: normal;\n\twhite-space: normal;\n\tfilter: alpha(opacity=0);\n\tz-index: 99999999999 !important;\n\n\t&.tooltipCustomWidth {\n\t\twidth: auto;\n\t\tmax-width: 20%;\n\t}\n\n\t.tooltip-arrow {\n\t\tposition: absolute;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-color: transparent;\n\t\tborder-style: solid;\n\t}\n\n\t&.fade {\n\t\ttransition: opacity 0.15s linear;\n\t}\n\n\t&.in {\n\t\tfilter: alpha(opacity=100);\n\t\topacity: 1;\n\n\t\t&.top {\n\t\t\t.tooltip-arrow {\n\t\t\t\tborder-top-color: var(--neutrals-00white) !important;\n\t\t\t}\n\t\t}\n\n\t\t&.bottom {\n\t\t\t.tooltip-arrow {\n\t\t\t\tborder-bottom-color: var(--neutrals-00white) !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.top {\n\t\tpadding: var(--px-10) 0;\n\t\tmargin-top: calc(var(--px-3) * -1);\n\n\t\t.tooltip-arrow {\n\t\t\tbottom: 0;\n\t\t\tleft: 50%;\n\t\t\tborder-width: var(--px-10) var(--px-10) 0;\n\t\t\tborder-top-color: var(--neutrals-00white) !important;\n\t\t\tbox-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);\n\t\t}\n\t}\n\n\t&.bottom {\n\t\tpadding: var(--px-10) 0;\n\t\tmargin-top: var(--px-3);\n\n\t\t.tooltip-arrow {\n\t\t\ttop: 0;\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(var(--px-5) * -1);\n\t\t\tborder-width: 0 var(--px-10) var(--px-10);\n\t\t\tborder-bottom-color: var(--neutrals-00white) !important;\n\t\t\tbox-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);\n\t\t}\n\t}\n\n\t.tooltip-inner {\n\t\tpadding: var(--px-6);\n\t\tfont-size: var(--px-14);\n\t\tcolor: var(--neutrals-1000) !important;\n\t\tbackground-color: var(--neutrals-00white) !important;\n\t\tbox-shadow: 0 0 var(--px-20) 0 rgba(0, 0, 0, 0.3);\n\t\ttext-align: left;\n\t\tword-wrap: break-word;\n\t\tborder-radius: var(--px-4);\n\t\tmax-width: var(--px-200);\n\t}\n}\n\n.assignment-task-tooltip {\n\tborder-radius: var(--px-12);\n\n\t.motif-tooltip-wrapper {\n\t\t.motif-tooltip-inner {\n\t\t\tbackground-color: var(--neutrals-00white);\n\t\t\tpadding: 0;\n\t\t\tborder-radius: var(--px-12);\n\n\t\t\t.motif-tooltip-content-children {\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Ellipses Tooltip CSS Ends */\n\n// CSS for Modal Header Close Button when Disabled - Starts\n.motif-modal-header {\n\t.motif-modal--header-icon-button {\n\t\t&:disabled {\n\t\t\tsvg {\n\t\t\t\tpath {\n\t\t\t\t\tfill: var(--neutrals-500) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// CSS for Modal Header Close Button when Disabled - Ends\n\n//Adding typography until next motif-upgrade\n.motif-h6-default-regular {\n\tfont-size: var(--px-16) !important;\n\tfont-weight: 400 !important;\n\tline-height: var(--px-24) !important;\n}\n\n.motif-h4-default-regular {\n\tfont-size: var(--px-20) !important;\n\tfont-weight: 400 !important;\n\tline-height: var(--px-30) !important;\n}\n\n.motif-label4-default-regular {\n\tfont-size: var(--px-12) !important;\n\tfont-weight: 400 !important;\n\tline-height: var(--px-18) !important;\n}\n\n.contentUpdate-update-selected,\n.warning-message-modal,\n.addCanvasForm-modal {\n\t.motif-modal-body {\n\t\tpadding: var(--px-24) !important;\n\t}\n}\n\n.delete-package-list-modal,\n.package-list-modal,\n.import-modal,\n.manageTeam-modal {\n\t.motif-modal-body {\n\t\tpadding: 0 !important;\n\t}\n}\n\n.contentinfo-icon {\n\tcursor: pointer;\n}\n\n.motif-dropdown-menu {\n\t.StyledCogDropdownMenuContent {\n\t\theight: auto;\n\t\tmax-height: var(--px-266);\n\t\toverflow-y: auto;\n\t}\n}\n\n[motif-theme] .motif-checkbox-disabled .motif-checkbox-input + .motif-checkbox-inner {\n\tbackground-color: var(--ui-stroke-disabled) !important;\n\tborder-color: var(--ui-stroke-disabled) !important;\n}\n\n[motif-theme] .motif-checkbox-disabled .motif-checkbox-input + .motif-checkbox-inner .motif-checkbox-icon {\n\tcolor: var(--ui-background-main);\n}\n\n[motif-theme] .motif-checkbox-wrapper-disabled:hover .motif-checkbox-checked .motif-checkbox-inner {\n\tbackground-color: var(--ui-stroke-disabled) !important;\n\tborder-color: var(--ui-stroke-disabled) !important;\n}\n\n[motif-theme]\n\t.motif-checkbox-wrapper-disabled:hover\n\t.motif-checkbox-checked\n\t.motif-checkbox-inner\n\t.motif-checkbox-icon {\n\tcolor: var(--ui-background-main);\n}\n\n.checkboxLabel-statusLabel {\n\tcursor: pointer;\n}\n\n/* ql-editor CSS - Starts */\n.ql-editor {\n\tli[data-list='bullet'] > .ql-ui:before {\n\t\tfont-family: auto !important;\n\t}\n}\n/* ql-editor CSS - Ends */\n\n.DocumentNameWrapper {\n\t.DocumentFileName {\n\t\t.document-name {\n\t\t\t.coedit-mode {\n\t\t\t\t.coedit-mode-label {\n\t\t\t\t\tmax-width: var(--px-450) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.container-blur {\n\topacity: 0.5;\n\tpointer-events: none;\n}\n","/**\n * Global LESS variables\n */\n\n/* Colors */\n@ey-black: #000;\n@ey-buttercup: #ffee99;\n@ey-green: #2c973e;\n@ey-green-50: #95cb89;\n@ey-lilac: #ac98db;\n@ey-lilac-50: #d8d2e0;\n@ey-link-blue: #336699;\n@ey-link-blue-50: #7fd1d6;\n@ey-purple: #91278f;\n@ey-purple-50: #c893c7;\n@ey-red: #f04c3e;\n@ey-white: #fff;\n@ey-yellow: #ffd200;\n@ey-orange: #f7941d;\n@gray-light: #f0f0f0;\n@gray: #c0c0c0;\n@gray-half: #81858b;\n@gray-34th: #44494f;\n@gray-dark: #24282d;\n@gray-charcoal: #333;\n@grey-50: #3b3838;\n@grey-70: #7f7f7f;\n@ey-sky-blue: #35b7c0;\n@ey-teal: #00a3ae;\n@gray-100: #44494f;\n@grey-light-bg: #f4f4f4;\n@gray-14th: #bec1c7;\n@ey-ready-green: #00a4ae;\n@ey-inqueuebadge: #fcd5b5;\n@ey-inprogressbadge: #d7e4bd;\n/* Layout */\n@footer-height: (@nav-height / 4) + @footer-padding * 2;\n@footer-padding: 5px;\n@nav-height: 80px;\n@screen-xs: 480px;\n@screen-sm: 768px;\n@screen-md: 992px;\n@screen-lg: 1200px;\n@label-font-weight: bold;\n@cursor-disabled: default;\n@labelWeightNormal: normal;\n@z-index-select-dropdown: 1060; // must be higher than a modal background (1050)\n//** Placeholder text color\n@input-color-placeholder: #999;\n@channelToolsWidth: 100%;\n@baseFontSize: 12px;\n@label-font-weight: bold;\n@toggleButtonBorder: #d9dadb;\n@toggleActiveButton: #ffe600;\n@buttonBorderRadius: 4px;\n@inputBorderRadius: 4px;\n@textColorWhite: #fff;\n@inputActiveBorder: #f7941d;\n@label-font-weight: bold;\n@baseVMFontSize: 0.77vw;\n@label-placeholder-color: #81858b;\n@formComponentHeight: 30px;\n@typeaheadTokenColor: #e7f4ff;\n@typeheadLabelColor: #1f8dd6;\n@typeheadDisabledColor: #ddd;\n@typeheadSelectedColor: #1f8dd6;\n@buttonDisabled: #ddd;\n@buttonActiveBorder: #bde7ea;\n@opacity-transparent: 1;\n@opacity-blur: 0.8;\n@ey-border-radius: 4px;\n@cursor-default: default;\n@cursor-pointer: pointer;\n@boxshadow-none: none;\n@display-inline: inline-block;\n@typeahead-background: #646464;\n@baseFormLineHeight: 32px;\n@global100Percent: 100%;\n@globalRadius: 0px;\n@bg-disabled: #eee;\n\n.global-lh-pd-fs {\n\tpadding: 0 10px;\n}\n\n// Small devices (phones, 320px and up)\n@mobile-default: ~'only screen and (min-width : 320x)';\n\n// Small devices (landscape phones, 576px and up)\n@mobile-large: ~'only screen and (min-width : 576px)';\n\n// Medium devices (tablets, 768px and up)\n@tablet-default: ~'only screen and (min-width : 768px)';\n\n// Large devices (desktops, 992px and up)\n@desktop-small: ~'only screen and (min-width : 992px)';\n\n// Large desktops (large desktops, 1200px and up)\n@desktop-default: ~'only screen and (min-width : 1200px)';\n\n// Extra large desktop (large desktops, 1824px and up)\n@desktop-large: ~'only screen and (min-width : 1824px)';\n\n:export {\n\tey-buttercup: @ey-buttercup;\n\tey-green: @ey-green;\n\tey-green-50: @ey-green-50;\n\tey-lilac: @ey-lilac;\n\tey-lilac-50: @ey-lilac-50;\n\tey-link-blue: @ey-link-blue;\n\tey-link-blue-50: @ey-link-blue-50;\n\tey-purple: @ey-purple;\n\tey-purple-50: @ey-purple-50;\n\tey-red: @ey-red;\n\tey-white: @ey-white;\n\tey-yellow: @ey-yellow;\n\tey-orange: @ey-orange;\n\tgray-light: @gray-light;\n\tgray: @gray;\n\tgray-half: @gray-half;\n\tgray-34th: @gray-34th;\n\tgray-dark: @gray-dark;\n\tgray-charcoal: @gray-charcoal;\n\tgrey-50: @grey-50;\n\tgrey-70: @grey-70;\n\tey-sky-blue: @ey-sky-blue;\n\tey-teal: @ey-teal;\n\tgray-100: @gray-100;\n\tgrey-light-bg: @grey-light-bg;\n\tgray-14th: @gray-14th;\n\tey-ready-green: @ey-ready-green;\n\tey-inqueuebadge: @ey-inqueuebadge;\n\tey-inprogressbadge: @ey-inprogressbadge /* Layout */;\n\tfooter-height: @footer-height;\n\tfooter-padding: @footer-padding;\n\tnav-height: @nav-height;\n\tscreen-xs: @screen-xs;\n\tscreen-sm: @screen-sm;\n\tscreen-md: @screen-md;\n\tscreen-lg: @screen-lg;\n\tlabel-font-weight: @label-font-weight;\n\tcursor-disabled: @cursor-disabled;\n\tlabelWeightNormal: @labelWeightNormal;\n\tz-index-select-dropdown: @z-index-select-dropdown;\n\tinput-color-placeholder: @input-color-placeholder;\n\tchannelToolsWidth: @channelToolsWidth;\n\tbaseFontSize: @baseFontSize;\n\tlabel-font-weight: @label-font-weight;\n\ttoggleButtonBorder: @toggleButtonBorder;\n\ttoggleActiveButton: @toggleActiveButton;\n\tbuttonBorderRadius: @buttonBorderRadius;\n\tinputBorderRadius: @inputBorderRadius;\n\ttextColorWhite: @textColorWhite;\n\tinputActiveBorder: @inputActiveBorder;\n\tlabel-font-weight: @label-font-weight;\n\tbaseVMFontSize: @baseVMFontSize;\n\tlabel-placeholder-color: @label-placeholder-color;\n\tformComponentHeight: @formComponentHeight;\n\ttypeaheadTokenColor: @typeaheadTokenColor;\n\ttypeheadLabelColor: @typeheadLabelColor;\n\ttypeheadDisabledColor: @typeheadDisabledColor;\n\ttypeheadSelectedColor: @typeheadSelectedColor;\n\tbuttonDisabled: @buttonDisabled;\n\tbuttonActiveBorder: @buttonActiveBorder;\n\topacity-transparent: @opacity-transparent;\n\topacity-blur: @opacity-blur;\n\tey-border-radius: @ey-border-radius;\n\tcursor-default: @cursor-default;\n\tcursor-pointer: @cursor-pointer;\n\tboxshadow-none: @boxshadow-none;\n\tdisplay-inline: @display-inline;\n\ttypeahead-background: @typeahead-background;\n\tbaseFormLineHeight: @baseFormLineHeight;\n\tglobal100Percent: @global100Percent;\n\tglobalRadius: @globalRadius;\n\tbg-disabled: @bg-disabled;\n\tmobile-default: @mobile-default;\n\tmobile-large: @mobile-large;\n\ttablet-default: @tablet-default;\n\tdesktop-small: @desktop-small;\n\tdesktop-default: @desktop-default;\n\tdesktop-large: @desktop-large;\n}\n","/* rastwe: 10/17/17 - I'm adding an @import here to point at the\n *  EY Online Style Guide. This is required because of some issues with\n *  The \"extract-text-webpack-plugin\", or webpack itself. In either case,\n *  relying on the @import order instead of webpack fixes the issue.\n *  TODO: undo this later, and just refer to the OSG in the top-level\n *  component. */\n@import './vars';\n\n@font-face {\n\tfont-family: 'EYInterstate';\n\tsrc: url('../../assets/fonts/EYInterstate-Regular.ttf');\n}\n@font-face {\n\tfont-family: 'EYInterstate';\n\tfont-style: italic;\n\tsrc: url('../../assets/fonts/EYInterstate-Italic.ttf');\n}\n@font-face {\n\tfont-family: 'EYInterstate';\n\tfont-weight: bold;\n\tsrc: url('../../assets/fonts/EYInterstate-Bold.ttf');\n}\n@font-face {\n\tfont-family: 'EYInterstate';\n\tfont-style: italic;\n\tfont-weight: bold;\n\tsrc: url('../../assets/fonts/EYInterstate-BoldItalic.ttf');\n}\n@font-face {\n\tfont-family: 'EYInterstate';\n\tfont-weight: 300;\n\tsrc: url('../../assets/fonts/EYInterstate-Light.ttf');\n}\n\n/* default Global font sizes */\n\n// Small devices (phones, 320px and up)\n@mobile-default: ~'only screen and (min-width : 320x) and (max-width : 575px)';\n\n// Small devices (landscape phones, 576px and up)\n@mobile-large: ~'only screen and (min-width : 576px) and (max-width : 766px)';\n\n// All mobile devices (Mobiles, 768px and below)\n@all-mobiles: ~'only screen and (max-width : 767px)';\n\n// Medium devices (tablets, 768px and up)\n@tablet-default: ~'only screen and (min-width : 768px) and (max-width : 991px)';\n\n// Large devices (desktops, 992px and up)\n@desktop-small: ~'only screen and (min-width : 992px) and (max-width : 1366px)';\n\n// Medium desktop (1280px to 1366px)\n@desktop-medium: ~'only screen and (min-width : 1367px) and (max-width : 1600px)';\n\n// Large desktops (large desktops, 1200px and up)\n@desktop-default: ~'only screen and (min-width : 1200px)';\n\n// Extra large desktop (Extra large desktops, 1824px and up)\n@desktop-large: ~'only screen and (min-width : 1824px)';\n\n\nhtml {\n\theight: 100vh;// to apply background from ASU\n\twidth: 100%;\n\tfont-size: 14px !important;\n\t@media @desktop-medium {\n\t\tfont-size: 12.61px !important;\n\t}\n\t@media @desktop-small {\n\t\tfont-size: 11.2px !important;\n\t}\n\t@media @tablet-default {\n\t\tfont-size: 11.2px !important;\n\t}\n}\n\nbody {\n\theight: 100%;\n\twidth: 100%;\n\toverflow: hidden !important;\n\tmargin: 0 auto;\n\tfont-family: 'EYInterstate' !important;\n\tfont-size: 14px !important;\n\t@media @desktop-medium {\n\t\tfont-size: 12.61px !important;\n\t}\n\t@media @desktop-small {\n\t\tfont-size: 11.2px !important;\n\t}\n\t@media @tablet-default {\n\t\tfont-size: 11.2px !important;\n\t}\n\t* {\n\t\tfont-family: 'EYInterstate';\n\t}\n}\n","/*Typing Loader*/\n.typing_loader{\n    width: var(--px-6);\n    height: var(--px-6);\n    border-radius: 50%;\n    -webkit-animation: typing 1s linear infinite alternate;\n       -moz-animation: Typing 1s linear infinite alternate;\n            animation: typing 1s linear infinite alternate;\n    margin: var(--px-4) var(--px-10);  \n    position: relative;\n    left: calc(var(--px-12) * -1);\n}\n@-webkit-keyframes typing{\n    0%{\n        background-color: rgba(255, 210, 0, 1);\n        box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0,0.2), \n                    var(--px-24) 0 0 0 rgba(255, 210, 0,0.2);\n      }\n    25%{ \n        background-color: rgba(255, 210, 0, 0.4);\n        box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0,2), \n                    var(--px-24) 0 0 0 rgba(255, 210, 0,0.2);\n    }\n    75%{ background-color: rgba(255, 210, 0, 0.4);\n        box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0,0.2), \n                    var(--px-24) 0 0 0 rgba(255, 210, 0,1);\n      }\n}\n\n@-moz-keyframes typing{\n   0%{\n        background-color: rgba(255, 210, 0, 1);\n        box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0,0.2), \n                    var(--px-24) 0 0 0 rgba(255, 210, 0,0.2);\n      }\n    25%{ \n        background-color: rgba(255, 210, 0, 0.4);\n        box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0,2), \n                    var(--px-24) 0 0 0 rgba(255, 210, 0,0.2);\n    }\n    75%{ background-color: rgba(255, 210, 0, 0.4);\n        box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0,0.2), \n                    var(--px-24) 0 0 0 rgba(255, 210, 0,1);\n      }\n}\n\n@keyframes typing{\n   0%{\n        background-color: rgba(255, 210, 0, 1);\n        box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0,0.2), \n                    var(--px-24) 0 0 0 rgba(255, 210, 0,0.2);\n      }\n    25%{ \n        background-color: rgba(255, 210, 0, 0.4);\n        box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0,2), \n                    var(--px-24) 0 0 0 rgba(255, 210, 0,0.2);\n    }\n    75%{ background-color: rgba(255, 210, 0, 0.4);\n        box-shadow: var(--px-12) 0 0 0 rgba(255, 210, 0,0.2), \n                    var(--px-24) 0 0 0 rgba(255, 210, 0,1);\n      }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
